export default {
  key1000000: `Title:`,
  key1000001: `Link address:`,
  key1000002: `Successfully copied!`,
  key1000003: `copy`,
  key1000004: `Please enter the correct keywords`,
  key1000005: `Please enter a keyword`,
  key1000006: `Please enter the menu keywords`,
  key1000007: `Publishing Tools`,
  key1000008: `Transit Listing`,
  key1000009: `Mall`,
  key1000010: `Please enter keywords.`,
  key1000011: `Search`,
  key1000012: `Categories`,
  key1000013: `Operating system`,
  key1000014: `Supplier system`,
  key1000015: `Distributor System`,
  key1000016: `Merchant ID:`,
  key1000017: `Tongtool Customer code:`,
  key1000018: `Exiting`,
  key1000019: `Currently, there are `,
  key1000020: ` The order has exceeded the deadline and has not been shipped,`,
  key1000021: `Please click to process`,
  key1000022: `View more`,
  key1000023: `Time zone:`,
  key1000024: `Your current time:`,
  key1000025: `UTC:`,
  key1000026: `Log out`,
  key1000027: `Help Center`,
  key1000028: `The format of the uploaded file is incorrect,`,
  key1000029: `Please select a file in jpg, jpeg, or png format`,
  key1000030: `File size is limited, file`,
  key1000031: `too big,`,
  key1000032: `No more than 20M`,
  key1000033: `All Products`,
  key1000034: `Please enter keywords to search`,
  key1000035: `Upload image search`,
  key1000036: `Selling Area`,
  key1000037: `Message Center`,
  key1000038: `Personal Center`,
  key1000039: `My Collection`,
  key1000040: `Log out`,
  key1000041: `Hello, welcome!`,
  key1000042: `free registration`,
  key1000043: `Log in`,
  key1000044: `Raw Materials`,
  key1000045: `Our products are made using the best available materials.`,
  key1000046: `Design`,
  key1000047: `Research, testing, and development of new products.`,
  key1000048: `Quality Control`,
  key1000049: `100% inspection will be conducted before delivery.`,
  key1000050: `Market`,
  key1000051: `USA, Europe, North America, Australia, India, etc.`,
  key1000052: `Record No:`,
  key1000053: `Many`,
  key1000054: `Massive high-quality supply`,
  key1000055: `20w+SKU, daily update of 500+`,
  key1000056: `Quick`,
  key1000057: `One-click upload to all platforms`,
  key1000058: `A must for opening a store, open a store in 5 minutes`,
  key1000059: `Okay`,
  key1000060: `Professional team quality assurance`,
  key1000061: `Professional picking, sorting, packaging, shipping and other services`,
  key1000062: `Province`,
  key1000063: `0 inventory to open a store, no financial pressure`,
  key1000064: `No need to stock up and stock up, pay first and then pay`,
  key1000065: `Mall Introduction`,
  key1000066: `Phone number:`,
  key1000067: `phone number:`,
  key1000068: `Email:`,
  key1000069: `Become A Distributor`,
  key1000070: `Sign up now`,
  key1000071: `Becoming a supplier`,
  key1000072: `Supplier settlement`,
  key1000073: `Entry Guide`,
  key1000074: `Supplier login`,
  key1000075: `Common Problem`,
  key1000076: `Legal Notices`,
  key1000077: `Terms of Service`,
  key1000078: `Privacy Policy`,
  key1000079: `About Us`,
  key1000080: `Platform business`,
  key1000081: `Contact us`,
  key1000082: `Business Consulting`,
  key1000083: `One-stop cross-border clothing distribution`,
  key1000084: `Discontinued`,
  key1000085: `Hi, welcome`,
  key1000086: `Mall!`,
  key1000087: `Hi, welcome to TONGTOOL!`,
  key1000088: `Country/Region Of Sale:`,
  key1000089: `Goods shipped from:`,
  key1000090: `Merchant number:`,
  key1000091: `Exit`,
  key1000092: `Please log in`,
  key1000093: `Message`,
  key1000094: `Getting started`,
  key1000095: `My Order`,
  key1000096: `Show Cart`,
  key1000097: `The operation was successful!`,
  key1000098: `Search from the whole site`,
  key1000099: `Search from our shop`,
  key1000100: `product name:`,
  key1000101: `Please select`,
  key1000102: `No matching data`,
  key1000103: `Loading`,
  key1000104: `No Data`,
  key1000105: `Delete`,
  key1000106: `More`,
  key1000107: `No filter data`,
  key1000108: `Confirm`,
  key1000109: `Reset`,
  key1000110: `All`,
  key1000111: `Confirm`,
  key1000112: `Cancel`,
  key1000113: `Save successfully`,
  key1000114: `Custom Column Display`,
  key1000115: `Custom column display`,
  key1000116: `Restore default`,
  key1000117: `Save as default`,
  key1000118: `The total amount of the order:`,
  key1000119: `Total amount of goods:`,
  key1000120: `Processing fee:`,
  key1000121: `Freight:`,
  key1000122: `Logistics channel Name:`,
  key1000123: `Freight: to be selected logistics channel`,
  key1000124: `Order-`,
  key1000125: `Current Account`,
  key1000126: `Sufficient balance`,
  key1000127: `Please ask whether to confirm the submission of the order, the system will automatically use the account balance for deduction.`,
  key1000128: `Insufficient balance`,
  key1000129: `Click to recharge`,
  key1000130: `(Ignore this prompt if you have your own inventory)`,
  key1000131: `Do you want to confirm the submission of the order? The system will automatically create an order in the status of "Pending Payment" for you. The platform will only perform the order after you pay.`,
  key1000132: `(If it has been recharged, close the window and resubmit it)`,
  key1000133: `More Options(Recipient country, Payment date, etc.)`,
  key1000134: `Last week`,
  key1000135: `Last month`,
  key1000136: `Last three months`,
  key1000137: `Spot shipping`,
  key1000138: `File size exceeds the limit, up to 10M`,
  key1000139: `The system is busy and the file upload failed!`,
  key1000140: `File format error`,
  key1000141: `pack up`,
  key1000142: `No relevant records`,
  key1000143: `Password can not be blank`,
  key1000144: `The password cannot contain Chinese characters`,
  key1000145: `Please fill in the email address.`,
  key1000146: `Not valid mailbox or incorrect mailbox format`,
  key1000147: `Mobile phone number cannot be empty`,
  key1000148: `Incorrect phone number format`,
  key1000149: `Only numeric format numbers are allowed to be entered`,
  key1000150: `The fixed phone number format is incorrect`,
  key1000151: `The address of a province or city cannot be empty`,
  key1000152: `Please select the complete province/city address`,
  key1000153: `Confirm whether to remove`,
  key1000154: `Tips`,
  key1000155: `Successful operation`,
  key1000156: `Parcel number`,
  key1000157: `Data coverage reminder`,
  key1000158: `The new sales product information will overwrite the already generated sales product information, which cannot be restored after generation. Do you want to generate it?`,
  key1000159: `Generate Now`,
  key1000160: `Please check the data to generate sales information first!`,
  key1000161: `The task has been successfully generated. Please check the results in the Generate Sales Information module.`,
  key1000162: `Price adjustment`,
  key1000163: `Jump failed!`,
  key1000164: `Order Submission Confirmation`,
  key1000165: `1 day`,
  key1000166: `2 days`,
  key1000167: `3 days`,
  key1000168: `4 days`,
  key1000169: `5 days`,
  key1000170: `6 days`,
  key1000171: `7 days`,
  key1000172: `You can only select up to 5 optional values for basic attributes!`,
  key1000173: `This property already exists. Please enter a different property name.`,
  key1000174: `The attribute value has been deactivated. Please replace it with a similar attribute value`,
  key1000175: `Abnormal attribute value, please replace the attribute value`,
  key1000176: `Attribute value scale cannot be empty`,
  key1000177: `Attribute value scale must be a positive integer greater than 0`,
  key1000178: `The sum of the attribute value proportions for each attribute is equal to 100 percent`,
  key1000179: `The specification attribute has a disabled attribute value. Replace it with a similar attribute value and try again.`,
  key1000180: `The attribute value of the specification attribute is abnormal. Please change the attribute value and try again.`,
  key1000181: `The attribute value of the basic attribute is abnormal. Change the attribute value and try again.`,
  key1000182: ` alike`,
  key1000183: `Product specifications cannot be empty, you must select and fill in one product specification information`,
  key1000184: `Unmatched`,
  key1000185: `Specified products`,
  key1000186: `Designated site`,
  key1000187: `Designated shop`,
  key1000188: `and`,
  key1000189: `or`,
  key1000190: `with`,
  key1000191: `not with`,
  key1000192: `System Busy, Please Try Again`,
  key1000193: `Transportation type is null.`,
  key1000194: `Add success`,
  key1000195: `Operation failed, please try again.`,
  key1000196: `Delete failed, please try again`,
  key1000197: `designated country`,
  key1000198: `Specified classification`,
  key1000199: `Please enter a full postcode.`,
  key1000200: `Specify Content`,
  key1000201: `Designate basic logistics`,
  key1000202: `Multiple products`,
  key1000203: `Single item`,
  key1000204: `Pick list:`,
  key1000205: `Picking warehouse:`,
  key1000206: `Logistics provider:`,
  key1000207: `Picking order type:`,
  key1000208: `Number of outbound orders:`,
  key1000209: `Creation time:`,
  key1000210: `Number of SKUs:`,
  key1000211: `Pickers:`,
  key1000212: `Number of SKUs:`,
  key1000213: `Storage area`,
  key1000214: `Storage bin`,
  key1000215: `Quantity to be picked`,
  key1000216: `Chinese description`,
  key1000217: `Product variation`,
  key1000218: `English description`,
  key1000219: `Batch No.`,
  key1000220: `Logistics providers`,
  key1000221: `Waiting`,
  key1000222: `Logistics channel`,
  key1000223: `Multiple shipping method`,
  key1000224: `Cart`,
  key1000225: `WeChat Consulting`,
  key1000226: `Telephone consultation`,
  key1000227: `Back to top`,
  key1000228: `Tips for charging voiding fees for logistics documents`,
  key1000229: `"Logistic Order Void Cost:`,
  key1000230: `The order has been successfully delivered to the logistics and the waybill number has been obtained. This operation will cancel the order and generate a new order. Currently, the time for obtaining the waybill number has expired.`,
  key1000231: `Cancellation of orders requires a charge`,
  key1000232: `(The actual deduction shall be subject to the corresponding time when the operation is canceled)`,
  key1000233: `ORDER ORDER COST:`,
  key1000234: `Refund amount:`,
  key1000235: `Logistics channel name cannot be null.`,
  key1000236: `Select the referenced channel`,
  key1000237: `Please select a logistics provider:`,
  key1000238: `Please select a logistics channel:`,
  key1000239: `SKU Information`,
  key1000240: `Specifications:`,
  key1000241: `Warehouse name`,
  key1000242: `Allocated quantity`,
  key1000243: `Quantity Available`,
  key1000244: `The available quantity must be an integer greater than or equal to 0`,
  key1000245: `Supplier Inventory Details`,
  key1000246: `Details of central warehouse storage`,
  key1000247: `Processing...`,
  key1000248: `Close`,
  key1000249: `File size exceeds limit, max. 100M`,
  key1000250: `Failed to upload files, please try again`,
  key1000251: `Upload success`,
  key1000252: `Please select a category first!`,
  key1000253: `Please select the goods delivery warehouse first!`,
  key1000254: `Please select an upload file first`,
  key1000255: `download in...`,
  key1000256: `Successfully downloaded the template!`,
  key1000257: `Import Product`,
  key1000258: `Select classification:`,
  key1000259: `Select goods delivery warehouse:`,
  key1000260: `The supply warehouse needs to be equipped with a specific target collection warehouse, and the straight-hair warehouse needs to be equipped with a specific available logistics, otherwise it cannot be used.`,
  key1000261: `template:`,
  key1000262: `Upload file:`,
  key1000263: `Step 1: Download Template`,
  key1000264: `Template download`,
  key1000265: `Step 2: Upload materials`,
  key1000266: `Please select the file`,
  key1000267: `When importing data and discovering the same SPU:`,
  key1000268: `Overwrite`,
  key1000269: `ignore`,
  key1000270: `Reminder:`,
  key1000271: `1. Please follow the import instructions in the template to upload product information.`,
  key1000272: `2. Only support extension:. zip.`,
  key1000273: `3. When there are exceptions in the imported data, the data import fails.`,
  key1000274: `4. After the import operation, please check the import result in "Import/Export Task - Import View" later.`,
  key1000275: `5. It is currently not possible to import or overwrite assembled products.`,
  key1000276: `No compliance responsible person information? Click`,
  key1000277: `No manufacturer information? Click`,
  key1000278: `Associated Compliance Officer`,
  key1000279: `Associated Manufacturer`,
  key1000280: `Association successful!`,
  key1000281: `Person in charge:`,
  key1000282: `Manufacturer:`,
  key1000283: `new`,
  key1000284: `Choose category`,
  key1000285: `Selected category name:`,
  key1000286: `attribute`,
  key1000287: `Attribute value`,
  key1000288: `Operation log`,
  key1000289: `Operation type`,
  key1000290: `description of operation content`,
  key1000291: `operation time`,
  key1000292: `Operator`,
  key1000293: `Distributor Operations`,
  key1000294: `Operation staff`,
  key1000295: `Supplier`,
  key1000296: `View details`,
  key1000297: `Processing fee modification:`,
  key1000298: `Logistics fee modification:`,
  key1000299: `Original price:`,
  key1000300: `After modification:`,
  key1000301: `Modification of product amount:`,
  key1000302: `Original value:`,
  key1000303: `Edit Properties`,
  key1000304: `Required`,
  key1000305: `Not required`,
  key1000306: `Recommended`,
  key1000307: `Specification properties`,
  key1000308: `Normal attributes`,
  key1000309: `Multiple selection of attribute values`,
  key1000310: `Single Choice of Attribute Values`,
  key1000311: `It is a size attribute`,
  key1000312: `Not a size attribute`,
  key1000313: `Allow custom attribute values`,
  key1000314: `Custom attribute values are not allowed`,
  key1000315: `Edit attribute values`,
  key1000316: `Got it`,
  key1000317: `Quantity Required for Order`,
  key1000318: `Print quantity`,
  key1000319: `Operation`,
  key1000320: `Printing`,
  key1000321: `Print quantity cannot be empty!`,
  key1000322: `Get print label link address exception!`,
  key1000323: `Print Compliance Label`,
  key1000324: `Please input`,
  key1000325: `Quick search sidebar menu`,
  key1000326: `Menu settings`,
  key1000327: `Import succeeded. The currently imported ymsSku does not exist:`,
  key1000328: `Warehouse`,
  key1000329: `Import`,
  key1000330: `Tips`,
  key1000331: `Download file template failed!`,
  key1000332: `Please select a warehouse first.`,
  key1000333: `：warehouse:`,
  key1000334: `File Name:`,
  key1000335: `Warehouse:`,
  key1000336: `When imported data already exists:`,
  key1000337: `Update`,
  key1000338: `add`,
  key1000339: `Current Custom Item SKU`,
  key1000340: `Previously designed goods SKU`,
  key1000341: `Design Repeat Tips`,
  key1000342: `The following customized products are consistent with the corresponding design content of the products in the "Products Designed by Me" list. Do not repeat the design.`,
  key1000343: `Serial number`,
  key1000344: `Task Number`,
  key1000345: `export type`,
  key1000346: `Export time`,
  key1000347: `export status`,
  key1000348: `Exporting`,
  key1000349: `System operation`,
  key1000350: `Remarks`,
  key1000351: `The file is kept for 7 days, and it cannot be downloaded after 7 days!`,
  key1000352: `download files`,
  key1000353: `in exporting`,
  key1000354: `complete export`,
  key1000355: `Failed to export`,
  key1000356: `Date format error`,
  key1000357: `Export type:`,
  key1000358: `Task Number:`,
  key1000359: `Export time:`,
  key1000360: `Select a date`,
  key1000361: `Search`,
  key1000362: `View all notifications`,
  key1000363: `other`,
  key1000364: `Required fields cannot be empty!`,
  key1000365: `Selected`,
  key1000366: `term`,
  key1000367: `Submit`,
  key1000368: `skip`,
  key1000369: `All categories`,
  key1000370: `Please enter category keywords`,
  key1000371: `Countries/regions where products can be sold`,
  key1000372: `Setting the selling country successfully!`,
  key1000373: `Edited and sold the country successfully!`,
  key1000374: `Products can be sold in:`,
  key1000375: `No options available`,
  key1000376: `Factory SPU`,
  key1000377: `Please enter factory SPU`,
  key1000378: `Factory SKU`,
  key1000379: `Please enter factory SKU`,
  key1000380: `Commodity name`,
  key1000381: `Please enter the product name`,
  key1000382: `Factory cannot be empty`,
  key1000383: `Product Information`,
  key1000384: `Factory SPU:`,
  key1000385: `Factory SKU:`,
  key1000386: `Classification`,
  key1000387: `POD platform not bound`,
  key1000388: `The POD platform has not been bound yet. Please try again after binding.`,
  key1000389: `Go to Bind`,
  key1000390: `Main material selection`,
  key1000391: `Factory:`,
  key1000392: `Yes`,
  key1000393: `No`,
  key1000394: `Single choice`,
  key1000395: `Multiple choices`,
  key1000396: `Property Chinese name`,
  key1000397: `Attribute value type`,
  key1000398: `Do you want to customize it`,
  key1000399: `Fill in the requirements`,
  key1000400: `Single/Multiple Choice`,
  key1000401: `See`,
  key1000402: `Remove`,
  key1000403: `Are you sure you want to remove this attribute from the associated attribute list?`,
  key1000404: `Association attribute management`,
  key1000405: `Adding new associated attributes`,
  key1000406: `Select from Property Pool`,
  key1000407: `Choose Delivery Method`,
  key1000408: `Logistics channel name`,
  key1000409: `Logistics Plan Code`,
  key1000410: `Logistics timeliness`,
  key1000411: `(Day)`,
  key1000412: `Modify delivery method`,
  key1000413: `Please check the data for the delivery method first!`,
  key1000414: `The current shipping address does not support delivery!`,
  key1000415: `Carrier`,
  key1000416: `Carrier name`,
  key1000417: `Carrier phone`,
  key1000418: `Usable or not`,
  key1000419: `available`,
  key1000420: `Unavailable`,
  key1000421: `Pick`,
  key1000422: `The name of the carrier cannot be empty!`,
  key1000423: `Please enter the name of the carrier`,
  key1000424: `Carrier Name:`,
  key1000425: `The property has been used and cannot be modified.`,
  key1000426: `The attribute value has been used and cannot be modified.`,
  key1000427: `Property Units (`,
  key1000428: `New attributes`,
  key1000429: `Chinese Name`,
  key1000430: `English-US`,
  key1000431: `English-UK`,
  key1000432: `English-AU`,
  key1000433: `English-EU`,
  key1000434: `French name`,
  key1000435: `German name`,
  key1000436: `Spanish name`,
  key1000437: `Dutch name`,
  key1000438: `Polish name`,
  key1000439: `Portuguese name`,
  key1000440: `Italian name`,
  key1000441: `Romanian name`,
  key1000442: `language`,
  key1000443: `code`,
  key1000444: `law`,
  key1000445: `Germany`,
  key1000446: `Spain`,
  key1000447: `Netherlands`,
  key1000448: `poland`,
  key1000449: `Portugal`,
  key1000450: `Italy`,
  key1000451: `Romania`,
  key1000452: `An attribute with the same name already exists. Please modify the attribute name before submitting!`,
  key1000453: `Chinese, English US attribute names cannot be empty!`,
  key1000454: `The attribute value of the same language must be filled in!`,
  key1000455: `Attribute values cannot be the same in the same language!`,
  key1000456: `Add Successfully`,
  key1000457: `Failed to upload`,
  key1000458: `Cancel this size group?`,
  key1000459: `Confirm to cancel this size group? After confirmation, this size group will not be displayed in the attribute value, and the filled data will be cleared.`,
  key1000460: `OK Cancel`,
  key1000461: `state`,
  key1000462: `Enable`,
  key1000463: `Disable`,
  key1000464: `Reference image`,
  key1000465: `Upload pictures`,
  key1000466: `brief introduction`,
  key1000467: `Please fill in the attribute unit`,
  key1000468: `Attribute units cannot be the same in the same language`,
  key1000469: `Please fill in the country size information`,
  key1000470: `Please fill in the national language name`,
  key1000471: `Attribute values cannot be the same under the same language`,
  key1000472: `Own site:`,
  key1000473: `Specifications/General Properties:`,
  key1000474: `Attribute value type:`,
  key1000475: `Attribute value single selection/multiple selection:`,
  key1000476: `Fill in requirements:`,
  key1000477: `Size attribute:`,
  key1000478: `Whether to fill in the proportion:`,
  key1000479: `Attribute name`,
  key1000480: `Attribute Unit`,
  key1000481: `Size Group Name:`,
  key1000482: `Add attribute units`,
  key1000483: `Optional value`,
  key1000484: `Allow customization`,
  key1000485: `Add attribute values`,
  key1000486: `Successfully reviewed, the system will send an announcement at the specified time`,
  key1000487: `Successfully returned`,
  key1000488: `Cancellation success`,
  key1000489: `The operation was successful！`,
  key1000490: `Reminder later`,
  key1000491: `Update completion prompt`,
  key1000492: `year`,
  key1000493: `Month`,
  key1000494: `Customer billing`,
  key1000495: `Platform Invoice`,
  key1000496: `bill`,
  key1000497: `Customer"`,
  key1000498: `"of"`,
  key1000499: `The bill has been updated. Do you want to jump to view it?`,
  key1000500: `Picture failed to load`,
  key1000501: `File size exceeds limit, max 5M!`,
  key1000502: `Upload image format error! The system only supports uploading images in JPG, JPEG, PNG, WEBP, and BMP formats.`,
  key1000503: `upload pictures in...`,
  key1000504: `Add multiple pictures`,
  key1000505: `Selected images to upload:`,
  key1000506: `Picture requirements:`,
  key1000507: `It is recommended to upload large real images of squares with 800*800 pixels or more, for example: 800*800px,1000*1000px,1500 * 1500px, with a maximum of no more than 5MB. If the size is not met, the upload will fail.`,
  key1000508: `Clear images without watermarks;`,
  key1000509: `Include the overall style and product details of the product, such as selfie model images, poster images, white background images, 3D images, detail images, etc.`,
  key1000510: `4. Click on the picture to use the cutting tools provided by the system to help you better display the characteristics of the goods!`,
  key1000511: `Click Crop`,
  key1000512: `Delete Picture`,
  key1000513: `OK to upload`,
  key1000514: `Loading...`,
  key1000515: `There is no more.`,
  key1000516: `Pull up to load more`,
  key1000517: `Successfully opened!`,
  key1000518: `Need to read and accept the service terms and privacy policy`,
  key1000519: `Have read and accepted`,
  key1000520: `and`,
  key1000521: `Timed order processing`,
  key1000522: `Order No.`,
  key1000523: `Quantity`,
  key1000524: `Out of stock quantity`,
  key1000525: `Estimated delivery time`,
  key1000526: `mark as out-of-stock`,
  key1000527: `The following order has expired. Please update the estimated delivery time.`,
  key1000528: `The selected order product information is as follows:`,
  key1000529: `The expected delivery time should be greater than today's date!`,
  key1000530: `Successfully marked!`,
  key1000531: `Out of stock quantity cannot be empty`,
  key1000532: `Expected delivery time cannot be empty`,
  key1000533: `Please select the estimated delivery time`,
  key1000534: `View by Order`,
  key1000535: `View by SKU`,
  key1000536: `stockout`,
  key1000537: `Not out of stock`,
  key1000538: `replenishment`,
  key1000539: `Halt sales`,
  key1000540: `The system will automatically suspend the sale of this SKU`,
  key1000541: `A maximum of 100 rows of order data can be processed in a single pop-up window`,
  key1000542: `Process Later`,
  key1000543: `Confirm`,
  key1000544: `The same coverage of the country, different additions`,
  key1000545: `Overwrite the original data`,
  key1000546: `Select upload file`,
  key1000547: `Import Freight Template`,
  key1000548: `Billing method:`,
  key1000549: `Weight calculation method:`,
  key1000550: `Select the file:`,
  key1000551: `Import:`,
  key1000552: `(Volume weight:`,
  key1000553: `Bulk upload`,
  key1000554: `Download`,
  key1000555: `Save`,
  key1000556: `Logistics selection cannot be empty`,
  key1000557: `Wanyitong 3PL Logistics`,
  key1000558: `Miyun warehouse platform logistics`,
  key1000559: `Binding succeeded!`,
  key1000560: `Please select the 3PL logistics to be bound first!`,
  key1000561: `Overseas warehouse platform logistics binding`,
  key1000562: `Logistics options:`,
  key1000563: `(Enabled)`,
  key1000564: `Platform-based logistics`,
  key1000565: `Association Binding`,
  key1000566: `select designated exception`,
  key1000567: `This condition is used to screen abnormal situations. If any one of the following conditions is met, this condition is considered to be satisfied.`,
  key1000568: `The number of spaces in the name characters is less than`,
  key1000569: `Russian Post requires to write the full name of recipient, here you can enter 2`,
  key1000570: `The number of name characters is less than`,
  key1000571: `Entering 1 means the recipient name is empty.`,
  key1000572: `The character length of address is less than`,
  key1000573: `The total character length of address1 and address2`,
  key1000574: `The character length of city name is less than`,
  key1000575: `Entering 1 means the city name is empty.`,
  key1000576: `The character length of province/state is less than`,
  key1000577: `Entering 1 means the province/state name is empty.`,
  key1000578: `The character length of postcode is less than`,
  key1000579: `Entering 1 means the zip code is empty.`,
  key1000580: `The character length of telephone number is less than`,
  key1000581: `The condition will be established only if both telephone number and cellphone number are less than the value.`,
  key1000582: `Warehouse Direct Price (`,
  key1000583: `Supply price（`,
  key1000584: `Are you sure to delete?`,
  key1000585: `image`,
  key1000586: `Supplier SKU`,
  key1000587: `Specification`,
  key1000588: `Packaging size (length, width, height cm)`,
  key1000589: `Weight(g)`,
  key1000590: `Product Status`,
  key1000591: `Deleted`,
  key1000592: `This warehouse does not support direct shipment.`,
  key1000593: `on shelf`,
  key1000594: `Print barcode`,
  key1000595: `Print QR code`,
  key1000596: `Automatically generated after approval`,
  key1000597: `Category:`,
  key1000598: `Product status:`,
  key1000599: `Chinese title:`,
  key1000600: `Supplier SPU:`,
  key1000601: `Number of SKUs:`,
  key1000602: `Total available quantity of goods:`,
  key1000603: `Reason for rejection`,
  key1000604: `A large number of spot`,
  key1000605: `Promote with confidence`,
  key1000606: `The platform will use the account balance to deduct the total amount payable for the order. Please ensure that there is sufficient balance in the account.`,
  key1000607: `The platform will initiate a payment message in the "Payment Management" list, where you can upload the payment voucher.`,
  key1000608: `Payment successful`,
  key1000609: `Payment`,
  key1000610: `Check`,
  key1000611: `Orders`,
  key1000612: `Payment method:`,
  key1000613: `Account balance payment`,
  key1000614: `Upload payment receipt`,
  key1000615: `Platform Tips:`,
  key1000616: `Addr label`,
  key1000617: `Failed to obtain the waybill address!`,
  key1000618: `Print prompt`,
  key1000619: `SKU contains Chinese and currently does not support barcode printing. Please use QR code printing!`,
  key1000620: `The number of prints must be greater than 0`,
  key1000621: `Face single size selection:`,
  key1000622: `Style Preview:`,
  key1000623: `Black · XL`,
  key1000624: `Print quantity:`,
  key1000625: `Picture size at least ≥`,
  key1000626: `and`,
  key1000627: `File size exceeds limit, maximum is`,
  key1000628: `loading pictures in...`,
  key1000629: `Crop Image. jpeg`,
  key1000630: `Picture Cropping`,
  key1000631: `Cutting Instructions`,
  key1000632: `1. In order to ensure that your products can be better displayed to distributors and bring more orders, the length and width of the uploaded product pictures must be ≥ 800.`,
  key1000633: `2. If the length and width of the originally uploaded picture are less than or equal to 800, the picture needs to be uploaded again.`,
  key1000634: `3. Merchants can adjust the display proportion of uploaded pictures by cutting to highlight the characteristics of goods.`,
  key1000635: `Picture width:`,
  key1000636: `Picture height:`,
  key1000637: `Preview`,
  key1000638: `Re-upload image`,
  key1000639: `Return description cannot be empty`,
  key1000640: `return`,
  key1000641: `Return instructions:`,
  key1000642: `Please enter a return description`,
  key1000643: `After returning, this announcement will be circulated as pending modification. Please confirm whether to return the modification?`,
  key1000644: `Log content`,
  key1000645: `Change to`,
  key1000646: `Operation date`,
  key1000647: `Operating system operation`,
  key1000648: `Supplier system operation`,
  key1000649: `SPU price adjustment`,
  key1000650: `Partial SKU price adjustment`,
  key1000651: `SKU price adjustment`,
  key1000652: `Issue orders of different storage area groups are allowed to enter the same pick list？`,
  key1000653: `Issue orders from different storage area areas are allowed to enter the same pick list？`,
  key1000654: `Packages from different logistics providers are allowed to enter the same picking list？`,
  key1000655: `Allow packages of the same logistics provider with different shipping methods to enter the same picking list？`,
  key1000656: `Maximum number of packages per regular picking list`,
  key1000657: `Maximum number of packages per stocking and picking list`,
  key1000658: `Allow`,
  key1000659: `Not allowed`,
  key1000660: `Please select a publishing store`,
  key1000661: `Please select a publication template`,
  key1000662: `Please select the goods delivery warehouse`,
  key1000663: `Failed to publish draft`,
  key1000664: `Choose a store to publish`,
  key1000665: `Site:`,
  key1000666: `Publishing store:`,
  key1000667: `Publication template:`,
  key1000668: `Commodity delivery warehouse:`,
  key1000669: `Set up`,
  key1000670: `Your goods:`,
  key1000671: `, the audit failed, the reason for rejection:`,
  key1000672: `in processing`,
  key1000673: `Operation successful, the system is processing...`,
  key1000674: `Marked as read!`,
  key1000675: `Message notification`,
  key1000676: `Click to authorize`,
  key1000677: `No more data...`,
  key1000678: `Let's see later`,
  key1000679: `NO`,
  key1000680: `Item:`,
  key1000681: `cannot be empty`,
  key1000682: `upload`,
  key1000683: `export successfully`,
  key1000684: `failed to export`,
  key1000685: `Commodity selection`,
  key1000686: `Select the goods and their specifications that need to be customized`,
  key1000687: `Custom information configuration`,
  key1000688: `Select the customized parts of the goods and upload the material pictures you need to customize.`,
  key1000689: `Product SPU:`,
  key1000690: `alike`,
  key1000691: `Configure custom content`,
  key1000692: `Customized parts`,
  key1000693: `Material map`,
  key1000694: `Finished product preview`,
  key1000695: `SKU Qty`,
  key1000696: `Supplier inventory (pieces)`,
  key1000697: `Price`,
  key1000698: `Customize my design`,
  key1000699: `New design`,
  key1000700: `View & Edit Custom Information`,
  key1000701: `Content not saved reminder`,
  key1000702: `Unsaved content will be lost. Are you sure you want to exit?`,
  key1000703: `Please select the goods that need to be customized first!`,
  key1000704: `The configuration customization information of customized goods cannot be empty!`,
  key1000705: `Saved successfully！`,
  key1000706: `Design Success Tips`,
  key1000707: `Added success tips`,
  key1000708: `Configuration succeeded!`,
  key1000709: `Please check the information before operating`,
  key1000710: `The format of the uploaded picture is wrong, only jpg, png and jpeg format pictures can be uploaded!`,
  key1000711: `Upload a single picture size can not exceed 5MB!`,
  key1000712: `Image deleted successfully`,
  key1000713: `All Custom Category`,
  key1000714: `Product SPU`,
  key1000715: `Select the goods you need to customize.`,
  key1000716: `Commodity customization information configuration`,
  key1000717: `Select the specific part you need to customize, upload the corresponding material map and finished product preview.`,
  key1000718: `Add to`,
  key1000719: `Please select custom parts`,
  key1000720: `Click to view larger image`,
  key1000721: `Product specifications`,
  key1000722: `Select the specification information of the goods you need to customize.`,
  key1000723: `Customized information for optional bulk/individual configuration items`,
  key1000724: `Batch Configuration`,
  key1000725: `Previous Step`,
  key1000726: `Successful design! The SPU has been added for you as"`,
  key1000727: `of goods`,
  key1000728: `Distribution backstage-I designed the goods.`,
  key1000729: `"List, do you want to jump to the corresponding list to view?`,
  key1000730: `New design success! The SPU has been added for you as"`,
  key1000731: `"in the list.`,
  key1000732: `I got it!`,
  key1000733: `Supplier Currency`,
  key1000734: `Add Supplier Currency`,
  key1000735: `Add Distributor Currency`,
  key1000736: `Change currency`,
  key1000737: `Distributor Currency`,
  key1000738: `Currency`,
  key1000739: `Summary of problems`,
  key1000740: `Changes in available inventory`,
  key1000741: `Allocated inventory changes`,
  key1000742: `Event type`,
  key1000743: `Available inventory balance`,
  key1000744: `Allocation inventory changes`,
  key1000745: `Allocation of inventory balance`,
  key1000746: `Void Inventory Change`,
  key1000747: `Voided inventory balance`,
  key1000748: `Reference no.`,
  key1000749: `receive the products`,
  key1000750: `Allocate`,
  key1000751: `Unassign`,
  key1000752: `Inventory movement`,
  key1000753: `Stock freeze`,
  key1000754: `Unfreeze`,
  key1000755: `Inventory adjustment`,
  key1000756: `Transfer out`,
  key1000757: `Receipt on shelf`,
  key1000758: `Adjust the order`,
  key1000759: `Cancel out`,
  key1000760: `Synchronize inventory`,
  key1000761: `Cancel receiving`,
  key1000762: `Recycle inventory`,
  key1000763: `Return to the warehouse`,
  key1000764: `Outbound`,
  key1000765: `Import inventory`,
  key1000766: `Update inventory`,
  key1000767: `Failed to get list data`,
  key1000768: `Inventory event details`,
  key1000769: `Inventory change type:`,
  key1000770: `Operating time:`,
  key1000771: `Select start date`,
  key1000772: `Select end date`,
  key1000773: `to`,
  key1000774: `Excel Export`,
  key1000775: `Not selected`,
  key1000776: `added successfully!`,
  key1000777: `The template name cannot be empty!`,
  key1000778: `Do you want to delete the current template?`,
  key1000779: `Deleting Success`,
  key1000780: `Select Date Time`,
  key1000781: `Please enter the template name`,
  key1000782: `The generated report file can be kept by the system for a maximum of 7 days, and downloading is not supported if it exceeds 7 days.`,
  key1000783: `View Export List`,
  key1000784: `Export template:`,
  key1000785: `Manage export templates`,
  key1000786: `Back`,
  key1000787: `Time range:`,
  key1000788: `Please select an export dimension:`,
  key1000789: `Please check the fields to be exported:`,
  key1000790: `Select All`,
  key1000791: `Save as new template`,
  key1000792: `export`,
  key1000793: `Select a shipping method`,
  key1000794: `Pack up`,
  key1000795: `spread`,
  key1000796: `Image upload specifications`,
  key1000797: `Uploading specifications for rotation charts`,
  key1000798: `It is recommended to upload images in the following order, with a reasonable and clear image sequence for easy viewing of products.`,
  key1000799: `Single image size`,
  key1000800: `The recommended size is 800 * 800px or above (800 * 800px, 1000 * 1000px, 1500 * 1500px), and the maximum size should not exceed 5MB.`,
  key1000801: `The proportion is square, and the appropriate size can clearly see the details.`,
  key1000802: `Supply price stratification value cannot be empty!`,
  key1000803: `Price inventory list required item can not be empty!`,
  key1000804: `Supplier Warehouse Straight Price Configuration`,
  key1000805: `Supplier Straight Hair Warehouse`,
  key1000806: `markup amount (`,
  key1000807: `Service fee (`,
  key1000808: `Price (`,
  key1000809: `Supplier Straight Hair Warehouse Wholesale Price`,
  key1000810: `Wholesale Price (`,
  key1000811: `This price is only applicable to the supplier's supply warehouse supply/stock to the platform.`,
  key1000812: `Warehouse`,
  key1000813: `Central Warehouse Price Configuration`,
  key1000814: `Central Warehouse`,
  key1000815: `Central warehouse wholesale price`,
  key1000816: `The product category is successfully matched`,
  key1000817: `Commodity Category Information`,
  key1000818: `", after confirming that the main material is selected, the current commodity category information will be replaced, and the setting information such as commodity specification will be overwritten by the information corresponding to the new category.`,
  key1000819: `The main product category does not belong`,
  key1000820: `For the category content in the commodity category table, please replace and select the main material, or manually bind the factory to process the commodity.`,
  key1000821: `Product classification cannot be empty`,
  key1000822: `Item No./SPU cannot be empty`,
  key1000823: `Origin of goods cannot be empty`,
  key1000824: `Goods delivery warehouse cannot be empty`,
  key1000825: `The product rotation chart cannot be empty`,
  key1000826: `The image type cannot be empty`,
  key1000827: `Accumulated purchase quantity`,
  key1000828: `To`,
  key1000829: `Cannot be less than or equal to the left interval`,
  key1000830: `Discount amount`,
  key1000831: `Discount coefficient`,
  key1000832: `Please enter the discount amount, such as 1.00`,
  key1000833: `Please enter a discount factor, such as 0.1`,
  key1000834: `Layered Price Reference`,
  key1000835: `Discount price:`,
  key1000836: `infinite`,
  key1000837: `Remove hierarchy`,
  key1000838: `Product`,
  key1000839: `Update successfully`,
  key1000840: `Option not filled in completely`,
  key1000841: `The input box for product attributes is limited to numbers and decimal points!`,
  key1000842: `The Chinese name of the commodity cannot be empty!`,
  key1000843: `New product review successful!`,
  key1000844: `In the sale of goods modification audit success!`,
  key1000845: `One size`,
  key1000846: `Enter after entering the value`,
  key1000847: ` Automatic generation`,
  key1000848: `Automatically generate sku rules: item number/SPU + specification attribute`,
  key1000849: `Main material size (length, width, height cm):`,
  key1000850: `long`,
  key1000851: `Width`,
  key1000852: `Height`,
  key1000853: `Length/Width/Height`,
  key1000854: `Weight`,
  key1000855: `Weight of main ingredients (g):`,
  key1000856: `Main material SKU information`,
  key1000857: `Click to select processing main material`,
  key1000858: `Processing main material not selected`,
  key1000859: `Auxiliary material process`,
  key1000860: `Please select main material information first`,
  key1000861: `Click to select excipient process`,
  key1000862: `Excipient process not selected`,
  key1000863: `Location & Material`,
  key1000864: `After setting the first column of 'location & material' information, check it to make the goods with the same available printing position get the same 'location & material' setting, but you need to judge by yourself whether there is information for goods of different specifications that needs to be fine-tuned.`,
  key1000865: `Position & Material not set`,
  key1000866: `Customization Information`,
  key1000867: `Custom information cannot be empty`,
  key1000868: `(Attribute value has been deactivated)`,
  key1000869: `Preview image`,
  key1000870: `Activity price`,
  key1000871: `Activity price（`,
  key1000872: `Warehouse Direct Price (CNY)`,
  key1000873: `Warehouse Straight Price`,
  key1000874: `This price is applicable to the supplier warehouse straight hair to the buyer`,
  key1000875: `Supplier Straight Hair`,
  key1000876: `Price: This price is applicable when the supplier's warehouse is straight to the buyer.`,
  key1000877: `price \n`,
  key1000878: `Price = Warehouse Direct Price Merchandise markup amount Merchandise service fee`,
  key1000879: `Supplier Straight Wholesale Price: This price applies to the wholesale price when the supplier's warehouse is straight to the buyer \n`,
  key1000880: `Wholesale price of goods = warehouse direct price of goods mark-up amount of goods service fee`,
  key1000881: `Supply price (CNY)`,
  key1000882: `Supply price`,
  key1000883: `Center Price (CNY)`,
  key1000884: `Price: This product passes through`,
  key1000885: `When central warehouse is issued`,
  key1000886: `Price = commodity supply price commodity markup amount commodity service fee`,
  key1000887: `Central warehouse wholesale price: this commodity through`,
  key1000888: `Wholesale price when central warehouse is issued \n`,
  key1000889: `Commodity wholesale price = commodity supply price commodity markup amount commodity service fee`,
  key1000890: `Inventory`,
  key1000891: `Product item number/SPU cannot be empty!`,
  key1000892: `Size`,
  key1000893: `Code`,
  key1000894: `Code`,
  key1000895: `Spanish Code`,
  key1000896: `Dutch Code`,
  key1000897: `Poland Code`,
  key1000898: `Portugal Code`,
  key1000899: `Italian Code`,
  key1000900: `Romania Code`,
  key1000901: `Upload up to 5 images per specification`,
  key1000902: `Close prompt`,
  key1000903: `Confirm Exit`,
  key1000904: `Title cannot be empty`,
  key1000905: `Select main material confirmation`,
  key1000906: `This main material is not available`,
  key1000907: `Switch main material SKU confirmation`,
  key1000908: `After switching SKU of main material, part & material setting information needs to be filled in again. Please confirm whether to switch SKU of main material?`,
  key1000909: `Confirm switch`,
  key1000910: `Packing size (length * width * height cm)`,
  key1000911: `The maximum length of each side of the packaging shall not exceed 40cm, except for swimwear. The maximum height of spring and summer styles shall not exceed 3cm, and the minimum height shall not be less than 1cm`,
  key1000912: `Padded data cannot be 0`,
  key1000913: `Fill`,
  key1000914: `Fill in the maximum weight in yards and grams`,
  key1000915: `Please enter price`,
  key1000916: `Retail`,
  key1000917: `Sales`,
  key1000918: `Price increase configuration: the supply price of goods. `,
  key1000919: `% + fixed amount `,
  key1000920: `Service fee configuration: the amount of the goods after the price increase. `,
  key1000921: `Wholesale`,
  key1000922: `Content before modification:`,
  key1000923: `Please select the goods delivery warehouse first`,
  key1000924: `Inventory is a whole number`,
  key1000925: `Please enter inventory`,
  key1000926: `The current commodity category does not allow customization of its commodities. Please clear the commodity category. Note that this operation will empty the commodity information maintained below. Please operate carefully.`,
  key1000927: `Enter can enter custom attributes`,
  key1000928: `Please select a specification`,
  key1000929: `Essential information`,
  key1000930: `Type:`,
  key1000931: `whether the commodity supports custom:`,
  key1000932: `Product category:`,
  key1000933: `Commodity number/SPU:`,
  key1000934: `Please enter the product number/SPU`,
  key1000935: `Origin of Goods:`,
  key1000936: `Select the main material:`,
  key1000937: `Product rotation chart:`,
  key1000938: `Image type:`,
  key1000939: `Product title composition: Product features+product category, no need to add words such as year, eBay, Amazon, etc`,
  key1000940: `Commodity attributes`,
  key1000941: `Only numbers and decimal points are allowed`,
  key1000942: `Price Inventory`,
  key1000943: `Service and Commitment`,
  key1000944: `Commodity service:`,
  key1000945: `Delivery time:`,
  key1000946: `Product sales suggestions`,
  key1000947: `Viewing Examples`,
  key1000948: `The main attribute image cannot be empty`,
  key1000949: `Supply Price`,
  key1000950: `Set this item in`,
  key1000951: `After the cumulative sales reach a certain number of preferential rules, this discount will be directly given to the distributor, but the distributor can not directly view the set preferential rules, only after the distributor reaches a certain level of quantity to view the next level of preferential, please rest assured to set.`,
  key1000952: `Submit`,
  key1000953: `Normal products`,
  key1000954: `Select product category`,
  key1000955: `Modify Category`,
  key1000956: `Accurately selecting categories is beneficial for product exposure and promotion of conversion.`,
  key1000957: `For the convenience of management, you can customize the product code, such as the product number, which will take effect after successful publication.`,
  key1000958: `Select plant main material`,
  key1000959: `Reselect`,
  key1000960: `Home image`,
  key1000961: `Upload network images`,
  key1000962: `Priority should be given to using background model puzzles for the first image. If there are no puzzles, choose the front image of the model. Models with backgrounds should be arranged in a certain order.`,
  key1000963: `View specifications`,
  key1000964: `Picture requirements`,
  key1000965: `It is recommended to upload large images of squares with 800*800 pixels or more, for example, 800*800px,1000*1000px,1500 * 1500px, with a maximum of 5MB. If the size does not meet the requirements, the upload will fail.`,
  key1000966: `recommend JPG and JPEG format images, but the platform supports uploading PNG, WEBP and BMP format images (limited platform restrictions will convert non-JPG and JPEG formats into JPEG format, but will cause slight distortion of images)`,
  key1000967: `Automatic generation`,
  key1000968: `Listing product attribute information:`,
  key1000969: `Expand and fill in more attributes`,
  key1000970: `The following attributes require a percentage of the attribute value:`,
  key1000971: `Please select a product category first`,
  key1000972: `Please fill in the attributes accurately. More product attributes will help improve the conversion rate of orders.`,
  key1000973: `Only the first set of specification setting images are supported. The set image should be selected as the set image, and a maximum of 5 images can be uploaded for each specification. The recommended size is 800 * 800px.`,
  key1000974: `For customized goods that have been put on shelves, the specifications of the goods do not support adjustment. If adjustment is required, stop selling the goods and adjust the specifications of the new goods.`,
  key1000975: `Multi specification sorting`,
  key1000976: `Specification details`,
  key1000977: `Custom Columns`,
  key1000978: `Size chart`,
  key1000979: `Please add product specifications first`,
  key1000980: `Fixed amount`,
  key1000981: `discount`,
  key1000982: `Add Layering`,
  key1000983: `Not available temporarily after submission for review`,
  key1000984: `Temporary storage`,
  key1000985: `Edit`,
  key1000986: `Approved`,
  key1000987: `Reject`,
  key1000988: `Send the verification code`,
  key1000989: `The graphic verification code cannot be empty`,
  key1000990: `verification code must be filled`,
  key1000991: `Account Currency cannot be empty`,
  key1000992: `In order to ensure the security and normal use of the account, please bind the mobile phone number.`,
  key1000993: `To ensure the security and normal use of the account, please select currency information.`,
  key1000994: `To ensure the security and normal use of the account, please bind the mobile phone number and select the currency information.`,
  key1000995: `Resend`,
  key1000996: `The phone verification code has been sent!`,
  key1000997: `Confirm that the new password cannot be empty`,
  key1000998: `The password does not match the confirmed password`,
  key1000999: `Binding success`,
  key1001000: `Please check the read and accept`,
  key1001001: `Please enter your phone number`,
  key1001002: `Please enter the graphic verification code`,
  key1001003: `Captcha image`,
  key1001004: `please enter verification code`,
  key1001005: `Input Password`,
  key1001006: `Please confirm the password again`,
  key1001007: `Email (optional)`,
  key1001008: `Click to select account currency`,
  key1001009: `Improve account information`,
  key1001010: `Not within the weight range`,
  key1001011: `Starting weight`,
  key1001012: `Cut-off weight`,
  key1001013: `Original Price`,
  key1001014: `Paid-in price after floating`,
  key1001015: `First weight (`,
  key1001016: `Original first heavy freight`,
  key1001017: `First heavy freight`,
  key1001018: `Paid-in first heavy freight after floating`,
  key1001019: `Continued unit weight (`,
  key1001020: `Unit price of original renewal weight`,
  key1001021: `Unit price of renewal weight`,
  key1001022: `Unit price of paid-in renewed weight after floating`,
  key1001023: `Registration fee`,
  key1001024: `Operation cost`,
  key1001025: `Original operating expenses`,
  key1001026: `Paid-in operating fee after floating`,
  key1001027: `Surcharge (%)`,
  key1001028: `Cut-off weight should be greater than initial weight`,
  key1001029: `The end weight of the previous interval must be equal to the starting weight of the next interval.`,
  key1001030: `Please choose the country`,
  key1001031: `Price cannot be empty.`,
  key1001032: `The first priority should not be empty`,
  key1001033: `Priority freight cannot be empty`,
  key1001034: `Continuous weight per unit weight must not be empty`,
  key1001035: `Continuous unit price cannot be empty`,
  key1001036: `Volume weight cannot be empty`,
  key1001037: `Billing Model Editing`,
  key1001038: `The price increase will be based on the current billing model; the percentage increase will be based on the "price, first freight, and unit price for renewal"; the fixed price increase will be based on the "operating fee".`,
  key1001039: `On the basis of the distributor billing model, the additional amount charged is subsequently refunded and compensated according to the actual logistics fee.`,
  key1001040: `Support Chinese, English and Binary Code Search`,
  key1001041: `Volume (kg):`,
  key1001042: `Volume weight:`,
  key1001043: `= Length (cm) × Width (cm) × Height (cm)/ `,
  key1001044: `(Volume (kg)=Length (cm) x Width (cm) x Height (cm) ÷`,
  key1001045: `Verify that the shipping cost is correct: weight (`,
  key1001046: `Paid-in logistics configuration`,
  key1001047: `Upward floating`,
  key1001048: `Markup`,
  key1001049: `Advance logistics fee configuration`,
  key1001050: `Selected countries:`,
  key1001051: `Clear`,
  key1001052: `Set postal code`,
  key1001053: `View postal code`,
  key1001054: `Add weight range`,
  key1001055: `Verify delivery fee`,
  key1001056: `Delivery fee:`,
  key1001057: `Paid-in freight:`,
  key1001058: `Freight received in advance:`,
  key1001059: `Freight withheld:`,
  key1001060: `Custom goods have begun processing, cancel the order, custom goods costs are not returned;`,
  key1001061: `Customized goods have not started processing, cancel the order, the order fee is fully returned;`,
  key1001062: `"Processing has already started, orders have been canceled, and the cost of customized goods will not be returned;`,
  key1001063: `"If the processing is not started, the order will be canceled and the order fee will be returned in full;`,
  key1001064: `Allow Cancel`,
  key1001065: `Order Cancellation`,
  key1001066: `Cancel reason cannot be empty!`,
  key1001067: `Canceled successfully!`,
  key1001068: `Please enter a cancellation reason`,
  key1001069: `Please enter the handling fee`,
  key1001070: `Logistic document void cost:`,
  key1001071: `Reason for cancellation:`,
  key1001072: `Custom goods present in order"`,
  key1001073: `", the order needs to be canceled after confirming the processing status of this commodity to the supplier.`,
  key1001074: `Commodity processing status:`,
  key1001075: `Processing has started`,
  key1001076: `Processing not started`,
  key1001077: `The order has been successfully delivered to the logistics and the waybill number has been obtained. The time for obtaining the waybill number has expired.`,
  key1001078: `Need to charge"`,
  key1001079: `". (The actual deduction is subject to the corresponding time when the distributor's operation is canceled)`,
  key1001080: `Cancellation Fee:`,
  key1001081: `Custom goods in order"`,
  key1001082: `custom goods costs:`,
  key1001083: `Total refund:`,
  key1001084: `After creation, if there is this commodity in the subsequent platform order, there is no need to manually match it.`,
  key1001085: `Goods, which can be done directly through this association.`,
  key1001086: `Commodity match.`,
  key1001087: `Tip: The created association relationship can be viewed/edited through the path "Commodity Management-Collected Commodities-Operation Item [Set Association Relationship];`,
  key1001088: `(Uncollected items can also be associated, which can be viewed/edited after collection)`,
  key1001089: `SPU, support for multiple row-separated`,
  key1001090: `SKU, support for multiple row-separated`,
  key1001091: `Central warehouse inventory`,
  key1001092: `Add product`,
  key1001093: `Supplier SPU`,
  key1001094: `Please enter vendor SPU, support multiple row-separated`,
  key1001095: `Please enter SPU, support multiple commas and delimited by line`,
  key1001096: `Please enter SKU, support multiple commas and delimit by line`,
  key1001097: `Please enter the product name, support multiple commas and separate by line`,
  key1001098: `Supplier Merchant Number`,
  key1001099: `Product title`,
  key1001100: `Please enter the product title`,
  key1001101: `Supplier name`,
  key1001102: `Supplier inventory`,
  key1001103: `Product SKU:`,
  key1001104: `Available stock`,
  key1001105: `Sales in the past 30 days`,
  key1001106: `Choice`,
  key1001107: `My Inventory`,
  key1001108: `In-transit inventory:`,
  key1001109: `Available Inventory:`,
  key1001110: `Unit Price`,
  key1001111: `length, width and height(cm)`,
  key1001112: `on sale`,
  key1001113: `trial sale`,
  key1001114: `Clearance`,
  key1001115: `The quantity of goods cannot be empty!`,
  key1001116: `Please select the product first!`,
  key1001117: `This product already has an associated relationship!`,
  key1001118: `Subscription status:`,
  key1001119: `Select Confirm`,
  key1001120: `Items`,
  key1001121: `Confirm to select this`,
  key1001122: `Goods for order matching?`,
  key1001123: `Selected:`,
  key1001124: `Set as main material`,
  key1001125: `Create a relationship`,
  key1001126: `System notification`,
  key1001127: `No more reminders`,
  key1001128: `You do not have permission to access this page.`,
  key1001129: `Back`,
  key1001130: `The system version is upgraded, and the old version link is invalid. Please click the sidebar menu or the lower button to use all functions normally.`,
  key1001131: `Return To The System Homepage`,
  key1001132: `Return to the menu with permissions`,
  key1001133: `Not matched to accessible menu!`,
  key1001134: `Please check the custom list fields that need to be displayed first!`,
  key1001135: `Not print`,
  key1001136: `Bar code`,
  key1001137: `custom content`,
  key1001138: `Storage bin`,
  key1001139: `Preview and occupy storage bin`,
  key1001140: `Storage area`,
  key1001141: `Preview and occupy storage area`,
  key1001142: `Reference Number`,
  key1001143: `preview and occupy reference number`,
  key1001144: `Medium material`,
  key1001145: `Tag size`,
  key1001146: `Start and end information`,
  key1001147: `Maximum support 100mm`,
  key1001148: `Typeface`,
  key1001149: `About 35mm Width/Pt`,
  key1001150: `Note: The printed content can be dragged to change the position.`,
  key1001151: `Adjust specification sorting by dragging and dropping`,
  key1001152: `Add shipping address`,
  key1001153: `Province/State cannot be empty`,
  key1001154: `The city cannot be empty`,
  key1001155: `District/County cannot be empty`,
  key1001156: `The detailed address cannot be empty.`,
  key1001157: `The recipient name cannot be empty`,
  key1001158: `Phone number cannot be blank`,
  key1001159: `Successfully added!`,
  key1001160: `Update completed!`,
  key1001161: `Current delivery to:`,
  key1001162: `Province/State:`,
  key1001163: `Please enter the province/state`,
  key1001164: `City:`,
  key1001165: `Please enter the city`,
  key1001166: `District:`,
  key1001167: `Please enter the district/county`,
  key1001168: `detailed address:`,
  key1001169: `Please enter detailed address information, such as road, house number, community, building number, unit, etc`,
  key1001170: `Zip code:`,
  key1001171: `Please enter your zip code.`,
  key1001172: `Name of consignee:`,
  key1001173: `Not exceeding 25 characters in length`,
  key1001174: `Mobile phone number:`,
  key1001175: `Fixed phone number:`,
  key1001176: `Please enter a fixed phone number`,
  key1001177: `Email address:`,
  key1001178: `Please input the email address.`,
  key1001179: `Set as default shipping address`,
  key1001180: `Creation time:`,
  key1001181: `Print box mark`,
  key1001182: `Select product`,
  key1001183: `Configure Customization Information`,
  key1001184: `Whether customization is required`,
  key1001185: `No need to configure custom content`,
  key1001186: `There are goods that do not need customization in the checked information, please select again`,
  key1001187: `Saving...`,
  key1001188: `Customized goods are specially made for you, and no refund/cancellation will be made after the production starts. Please confirm that the demand is correct and submit the order. Thank you for your understanding.`,
  key1001189: `whether the need for custom goods:`,
  key1001190: `Yes, I need to configure custom content`,
  key1001191: `No, you can buy basic goods directly.`,
  key1001192: `Platform Customization Data Selection`,
  key1001193: `Details of supply price`,
  key1001194: `Warehouse Straight Price Details`,
  key1001195: `Switch category confirmation`,
  key1001196: `After switching categories, information such as product attributes and specifications needs to be filled out again. Please confirm whether to switch categories?`,
  key1001197: `Please select a type`,
  key1001198: `Classification retrieval`,
  key1001199: `Recently used:`,
  key1001200: `Selected category:`,
  key1001201: `Successfully bound phone`,
  key1001202: `Temporarily not bound`,
  key1001203: `Abnormal goods`,
  key1001204: `The following goods are customized goods. Stocking is not supported for the time being. Please modify the order and resubmit it.`,
  key1001205: `Edit successfully!`,
  key1001206: `Edit Template`,
  key1001207: `Template name:`,
  key1001208: `The shipping warehouse cannot be empty`,
  key1001209: `Single item processing fee cannot be empty`,
  key1001210: `Renewal processing fee cannot be empty`,
  key1001211: `Expense Currency cannot be empty`,
  key1001212: `Weight unit cannot be empty`,
  key1001213: `Order processing fee`,
  key1001214: `First charge`,
  key1001215: `cost`,
  key1001216: `<span class = "font-weight-bold"> Handling fee = weight * unit price </span>`,
  key1001217: `<span class = "color-666"> Weight less than or equal to first weight:</span>`,
  key1001218: `<span class = "font-weight-bold"> Handling fee = First charge </span>`,
  key1001219: `<span class = "color-666 mt3 ml24"> Weight greater than first weight:</span>`,
  key1001220: `<span class = "font-weight-bold mt3"> Handling fee = first weight charge rounded up (total weight-first weight)/unit weight of continued weight * unit price of continued weight </span>`,
  key1001221: `<span class = "font-weight-bold"> Processing fee = cost </span>`,
  key1001222: `Unit price cannot be empty`,
  key1001223: `First charge cannot be empty`,
  key1001224: `Expense cannot be empty`,
  key1001225: `Cost allocation`,
  key1001226: `types of fee:`,
  key1001227: `Shipping Warehouse:`,
  key1001228: `Order processing fee configuration is only supported for straight-out warehouse.`,
  key1001229: `Charging mode:`,
  key1001230: `Single piece processing fee:`,
  key1001231: `Renewal processing fee:`,
  key1001232: `Fee Currency:`,
  key1001233: `Weight Unit:`,
  key1001234: `Warehouse processing fee= `,
  key1001235: `(Number of pieces -1)`,
  key1001236: `Verify that the handling fee is correct: weight (`,
  key1001237: `Charge according to the number of items in the order.`,
  key1001238: `Charge by order item weight`,
  key1001239: `Verification processing fee`,
  key1001240: `Before postal code`,
  key1001241: `Position:`,
  key1001242: `Postcode:`,
  key1001243: `Postcode cannot be empty.`,
  key1001244: `The postal code format can only be numbers or letters`,
  key1001245: `Supports batch input, please separate with line breaks`,
  key1001246: `Before truncating the postal code`,
  key1001247: `position`,
  key1001248: `Outbound order number`,
  key1001249: `Order cancellation prompt`,
  key1001250: `There are cancelled orders in this assignment, and the detailed information of the outbound order included in the order is as follows.`,
  key1001251: `Continue to sort`,
  key1001252: `Remove cancelled outbound orders`,
  key1001253: `If the product is already associated with"`,
  key1001254: `Person in charge ", this operation will overwrite the previously associated content.`,
  key1001255: `If the goods are in"`,
  key1001256: `"The manufacturer information has been associated. This operation will overwrite the previously associated content.`,
  key1001257: `European Union`,
  key1001258: `Türkiye`,
  key1001259: `EU/Turkey`,
  key1001260: `Head of the European Union:`,
  key1001261: `Head of Turkey:`,
  key1001262: `Batch Associated Compliance Owner`,
  key1001263: `Batch Associated Manufacturer`,
  key1001264: `Please select the associated responsible person!`,
  key1001265: `Please select the associated manufacturer!`,
  key1001266: `Responsible area:`,
  key1001267: `Please select the responsible person information you need to associate;`,
  key1001268: `Please select the manufacturer information you need to associate;`,
  key1001269: `Manufacturer Information:`,
  key1001270: `Click "Same" and the system will batch fill all SKUs in the list.`,
  key1001271: `Click "same", the system will be based on the product specifications you choose, only for the same specifications of the SKU for batch filling.`,
  key1001272: `Bulk Fill Configuration`,
  key1001273: `Fill mode:`,
  key1001274: `SKU Unified Configuration`,
  key1001275: `Configure by SKU specification`,
  key1001276: `Selection of specifications:`,
  key1001277: `The length and width of the regular order waybill cannot be empty!`,
  key1001278: `The length and width of the AliExpress fully managed product label cannot be empty!`,
  key1001279: `The length and width of the AliExpress fully managed logistics waybill cannot be empty!`,
  key1001280: `Print Configuration`,
  key1001281: `Regular order waybill`,
  key1001282: `Lemgth:`,
  key1001283: `Width:`,
  key1001284: `AliExpress fully managed product label`,
  key1001285: `AliExpress fully managed logistics waybill`,
  key1001286: `Copied!`,
  key1001287: `Commodity Rejection Notice`,
  key1001288: `The following product review is rejected, please revise and resubmit for review:`,
  key1001289: `Next Reminder`,
  key1001290: `This category has not yet maintained platform mapping. Please consult customer service if necessary.`,
  key1001291: `There are currently no platforms to support publishing!`,
  key1001292: `Unbound store`,
  key1001293: `Your account is currently not linked to a store, or the linked store has expired.`,
  key1001294: `Choose the platform to publish`,
  key1001295: `Please fill in the picture address`,
  key1001296: `Incorrect link address format`,
  key1001297: `Failed to get uploaded image!`,
  key1001298: `Adding pictures from addresses`,
  key1001299: `Image URL:`,
  key1001300: `Set up custom content`,
  key1001301: `Custom services zero surcharge, only according to the basic commodity price settlement, effectively reduce the consumption threshold, improve conversion.`,
  key1001302: `All customized parts adopt standardized pricing (A yuan/part), and charge according to the number of selected parts, so as to realize efficient and transparent management.`,
  key1001303: `Supports independent pricing for each customized part, and the cost is accurately accumulated according to the items selected by the buyer to meet the needs of differentiated pricing and value stratification.`,
  key1001304: `Cost of unified customized parts (`,
  key1001305: `Customization fee (`,
  key1001306: `View custom content`,
  key1001307: `Please complete all required fields`,
  key1001308: `Expense amount must be greater than 0`,
  key1001309: `Please enter the charge amount`,
  key1001310: `Customized parts:`,
  key1001311: `Custom Instructions:`,
  key1001312: `can enter a custom description, for example: this part is located right in front of the t-shirt left about 20cm...`,
  key1001313: `Schematic diagram of parts:`,
  key1001314: `Customizable area (length, width cm):`,
  key1001315: `Custom process:`,
  key1001316: `Custom Charges`,
  key1001317: `The unified custom part cost cannot be empty and must be greater than 0`,
  key1001318: `For customized goods that have been put on shelves, their customization information cannot be modified (except for the charging mode). If you need to modify, please stop selling this product, create a new customized product and edit it again.`,
  key1001319: `Add custom parts`,
  key1001320: `Please select the part diagram to upload`,
  key1001321: `Customizable area (length, width cm) cannot be empty and must be greater than 0`,
  key1001322: `Please select custom process`,
  key1001323: `Customization fee cannot be empty`,
  key1001324: `Code`,
  key1001325: `Account`,
  key1001326: `Effective`,
  key1001327: `invalid`,
  key1001328: `Update shop`,
  key1001329: `Add shop`,
  key1001330: `Authorized list`,
  key1001331: `You can enter code and account name to search`,
  key1001332: `Please designate`,
  key1001333: `No rule selected`,
  key1001334: `Rule name cannot be empty`,
  key1001335: `Declaration rules`,
  key1001336: `Logistics rules`,
  key1001337: `Warehouse Rules`,
  key1001338: `Public Rules`,
  key1001339: `Special rules`,
  key1001340: `Add`,
  key1001341: `key words`,
  key1001342: `Shipping Warehouse`,
  key1001343: `You can enter multiple postcodes, separated by a comma or newline`,
  key1001344: `Enter more than one, separated by English commas`,
  key1001345: `Please enter key words...`,
  key1001346: `Multi-postcode wrap requests half-width input comma to separate`,
  key1001347: `Please choose platform`,
  key1001348: `Please enter the shipping method to search.`,
  key1001349: `Add transpotation type`,
  key1001350: `Are you sure to delete?`,
  key1001351: `(USD)`,
  key1001352: `or (EUR)`,
  key1001353: `or (GBP)`,
  key1001354: `or (AUD)`,
  key1001355: `Or RMB`,
  key1001356: `Please enter the SKU. Use comma or new line to separate multiple SKUs`,
  key1001357: `Please Choose or Input Location`,
  key1001358: `Please select the shop or enter the search.`,
  key1001359: `Please select a logistics`,
  key1001360: `Please enter an SPU, multiple SPUs separated by commas or newlines`,
  key1001361: `Please enter the supplier merchant number, multiple merchant numbers are separated by commas or line breaks`,
  key1001362: `Please enter the distributor merchant number, multiple merchant numbers are separated by commas or newlines`,
  key1001363: `Ten-day orders are X-day orders, such as 5-days, 10-days`,
  key1001364: `Specified scope`,
  key1001365: `Designated type`,
  key1001366: `Start`,
  key1001367: `Ending`,
  key1001368: `Specified law`,
  key1001369: `designated SKU`,
  key1001370: `Designated warehouse`,
  key1001371: `or`,
  key1001372: `Designated platform`,
  key1001373: `Specify the place of shipment`,
  key1001374: `Designated delivery warehouse`,
  key1001375: `Specify SPU`,
  key1001376: `Designated Supplier`,
  key1001377: `Designated Distributor`,
  key1001378: `Designated Distributor Level`,
  key1001379: `Selected conditions`,
  key1001380: `Items included in the order:`,
  key1001381: `volumetric factor`,
  key1001382: `The total quantity of products in the package meets the following selected conditions:`,
  key1001383: `The weight meets all the following conditions:`,
  key1001384: `The length of the product should meet all the following conditions:`,
  key1001385: `The total width meets all the following conditions:`,
  key1001386: `The height of products should satisfy all the following conditions:`,
  key1001387: `The product volume of the order meets all the following conditions`,
  key1001388: `The total quantity of products in the order meets the following conditions:`,
  key1001389: `The character length of the zip code should meet the following conditions:`,
  key1001390: `Products in the order:`,
  key1001391: `and the sum of the quantity of the above goods meets all the conditions selected below:`,
  key1001392: `The heavier one of volumetric weight and actual weight will be the final weight of order.`,
  key1001393: `Note: The longest side of each item recorded in the commodity management is a1. The middle side is b1, and the shortest is c,`,
  key1001394: `The longest side of each item recorded in the commodity management is a1. The middle side is b1, and the shortest is c. The maximum value of all a1 is a, and the maximum value of all b1 is b. The sum of the short sides c of all items in the order is d,`,
  key1001395: `then the maximum value of a, b, and d is the total length, the middle value is the total width, and the minimum value is the total height.`,
  key1001396: `volumetric weight(g)= (a*b*d)/ volumetric factor*1000`,
  key1001397: `Note: The longest side of each item recorded in the commodity management is a1. The middle side is b1, and the shortest is c,`,
  key1001398: `The longest side of each item recorded in the commodity management is a1. The middle side is b1, and the shortest is c. The maximum value of all a1 is a, and the maximum value of all b1 is b. The sum of the short sides c of all items in the order is d,`,
  key1001399: `then the maximum value of a, b, and d is the total length, the middle value is the total width, and the minimum value is the total height.`,
  key1001400: `then the maximum value of a, b, and d is the total length, the middle value is the total width, and the minimum value is the total`,
  key1001401: `height, a*b*d is the total volume of all the products in the order.`,
  key1001402: `Order includes multiple transactions(and use the same shipping method)`,
  key1001403: `The order only has one transaction.`,
  key1001404: `The order contains multiple transactions (and the shipping methods are not the exact same`,
  key1001405: `specified conditions`,
  key1001406: `The contact number of recipient should meet the following conditions:`,
  key1001407: `readable character length of mobile number≤`,
  key1001408: `Readable character length of fixed phone number≤`,
  key1001409: `Mobile phone prefix`,
  key1001410: `designated string`,
  key1001411: `appoint the character to be searched in the address(only Street1 + Street2, not include the information of the country, province/state and city):`,
  key1001412: `Please enter the name of the warehouse where the order is shipped in the background of the e-commerce platform:`,
  key1001413: `Designated length`,
  key1001414: `The character length of the shipping address is less than`,
  key1001415: `*。The address information is combined by street1 and stree2, which does not include the information of the country, province/state and city.`,
  key1001416: `, and`,
  key1001417: `, or`,
  key1001418: `includes`,
  key1001419: `specified format`,
  key1001420: `The postcode should meet at least one of the following selected conditions (input content is limited to numbers, English letters, dashes and spaces):`,
  key1001421: `Designated exception`,
  key1001422: `and the postcode is in`,
  key1001423: `Postcode section`,
  key1001424: `Postcode list`,
  key1001425: `Have chosen`,
  key1001426: `,Note: For other currencies to be converted into USD, all options must be filled in`,
  key1001427: `Freight paid by customer convert to (currency):`,
  key1001428: `：then meet all the following conditions:`,
  key1001429: `Specified product status`,
  key1001430: `And for`,
  key1001431: `Designated products`,
  key1001432: `Designated mode of mailing`,
  key1001433: `The total amount of the package includes the amount of all orders merged into one package. The amount of orders in different currencies will be converted to the currencies in the following settings according to the exchange rate.`,
  key1001434: `Currency:`,
  key1001435: `Enter the characters to be searched in Customer ID`,
  key1001436: `Note: If multiple conditions are added, the rule execution conditions are set according to the relationship of "and" in the order of addition.`,
  key1001437: `Rule Name:`,
  key1001438: `Optional conditions`,
  key1001439: `More Platforms`,
  key1001440: `Please Choose Label`,
  key1001441: `Batch Configuration Label`,
  key1001442: `Label:`,
  key1001443: `Add tags`,
  key1001444: `delete a tap`,
  key1001445: `Importing`,
  key1001446: `complete import`,
  key1001447: `Failed to import`,
  key1001448: `import type`,
  key1001449: `import files`,
  key1001450: `time of import`,
  key1001451: `import status`,
  key1001452: `Success/Failure`,
  key1001453: `Import type：`,
  key1001454: `Please enter the task number`,
  key1001455: `Import time：`,
  key1001456: `Location`,
  key1001457: `Location schematic`,
  key1001458: `Printable area (length and width cm)`,
  key1001459: `Printing size (length, width cm)`,
  key1001460: `Material`,
  key1001461: `Material coding`,
  key1001462: `Information used by the supplier to identify the material`,
  key1001463: `Finished product renderings`,
  key1001464: `Confirmation of switching position`,
  key1001465: `After switching parts, information such as printing size and material need to be re-entered. Please confirm whether to switch parts?`,
  key1001466: `File size exceeds limit, max 20M!`,
  key1001467: `There are required items not filled in!`,
  key1001468: `Location & Material Settings`,
  key1001469: `Click to select parts`,
  key1001470: `Click to enter`,
  key1001471: `Part cannot be empty`,
  key1001472: `Please select parts first`,
  key1001473: `Printable area cannot be empty`,
  key1001474: `Cannot exceed length of printable area`,
  key1001475: `Cannot exceed printable area width`,
  key1001476: `Please enter print size first`,
  key1001477: `The uploaded file format is incorrect. The uploaded image format is limited to JPG, JPEG, and PNG`,
  key1001478: `The maximum image size is 5MB`,
  key1001479: `Payment channel cannot be empty`,
  key1001480: `Operation collection account cannot be empty`,
  key1001481: `Online payment`,
  key1001482: `Offline Payment, Upload Payment Voucher`,
  key1001483: `Create Pending Order`,
  key1001484: `(Payment can be summarized later in the order list)`,
  key1001485: `Please upload the payment flow picture`,
  key1001486: `Please improve the offline payment information`,
  key1001487: `Payment successful`,
  key1001488: `Created successfully`,
  key1001489: `Order Submission`,
  key1001490: `Payment Options:`,
  key1001491: `Payment Channels:`,
  key1001492: `Operational Collection Account:`,
  key1001493: `Amount Payable :`,
  key1001494: `Payment Voucher Picture:`,
  key1001495: `Notes:`,
  key1001496: `Amount corresponding to currency of operating collection account:`,
  key1001497: `Available order amount (`,
  key1001498: `Available Balance (`,
  key1001499: `Remaining Credit Line (`,
  key1001500: `= Credit Line ( `,
  key1001501: `Used credit line ( `,
  key1001502: `Are you sure you want to submit this order?`,
  key1001503: `View full message`,
  key1001504: `After submission, the operator needs to review and confirm the validity of the payment information. The order will take effect only after confirmation. Please enter the payment information accurately.`,
  key1001505: `Currently, the available order amount is sufficient. Click "OK" to pay directly and complete the order.`,
  key1001506: `Current`,
  key1001507: `The available order amount is insufficient`,
  key1001508: `, please recharge and open the window again to complete the payment.`,
  key1001509: `Click to recharge`,
  key1001510: `(If you have recharged, please reopen this window and refresh the data)`,
  key1001511: `To be queried`,
  key1001512: `Querying`,
  key1001513: `Not found`,
  key1001514: `In transit`,
  key1001515: `Waiting to receive`,
  key1001516: `Have been received`,
  key1001517: `Delivery failed`,
  key1001518: `Transported too long`,
  key1001519: `May be abnormal`,
  key1001520: `Tracking information`,
  key1001521: `Waybill number:`,
  key1001522: `Status:`,
  key1001523: `Download success`,
  key1001524: `Failed to get download address!`,
  key1001525: `View Customization Information`,
  key1001526: `If the customized goods in the order do not have customized information here, the basic goods can be shipped directly.`,
  key1001527: `One click to download all pictures`,
  key1001528: `Material map:`,
  key1001529: `Preview of finished products:`,
  key1001530: `Apply to become a distributor`,
  key1001531: `Find products`,
  key1001532: `Collect products`,
  key1001533: `Product Listing & Download Kit`,
  key1001534: `Place an order to ship`,
  key1001535: `Order Management`,
  key1001536: `Financial Management`,
  key1001537: `Register now`,
  key1001538: `Click "Become a Distributor" in the upper right corner of the mall homepage, and use your mobile phone number to register or use your Tongtool account to authorize to log in.`,
  key1001539: `Browse`,
  key1001540: `Search keywords to find the products you want to distribute.`,
  key1001541: `In the category navigation, find the product you want to distribute.`,
  key1001542: `On the homepage and core page, find the product you want to distribute.`,
  key1001543: `Go collect`,
  key1001544: `On the product list page, find the product and click the "Save" button to save it for publication.`,
  key1001545: `On the product details page, click the "Save Now" button to save the product for publication.`,
  key1001546: `4. Product Publishing&Download Kit`,
  key1001547: `Product publish`,
  key1001548: `Use Tongtool Listing to publish products on eBay, Aliexpress, Wish, Amazon and other overseas e-commerce platforms with one click.`,
  key1001549: `Download the package`,
  key1001550: `You can also download the data package for free on the "Product List", "Product Details Page" or "Product Management" page, and then go to the third-party sales platform to list the products in the backstage of the merchant.`,
  key1001551: `Basic Settings`,
  key1001552: `Enable logistics`,
  key1001553: `In Tongtool ERP2.0, third-party logistics is enabled, and the Tongtool system has built-in some logistics providers with a large number of users in the industry and a good reputation. You can select and enable it according to your needs.`,
  key1001554: `Enable shipping method`,
  key1001555: `Choose which shipping method you want to enable. After enabling it, you will be prompted "The shipping method activated successfully".`,
  key1001556: `Warehouse setup`,
  key1001557: `Select "YMS Supply Chain" in the third-party warehouse to enable it.`,
  key1001558: `Bind logistics channels`,
  key1001559: `Select the "YMS supply chain" warehouse, click "Bind logistics channel" on the right, and click the "Confirm" button after selecting the logistics method.`,
  key1001560: `Generate Tongtool sku`,
  key1001561: `In the "Product Management - Cloud Sales and Distribution Products" module of Tongtu ERP2.0, click on the favorite products, and in the product details, click "Generate Product Information".`,
  key1001562: `In Tongtool ERP2.0, select the "Shipping Management-Managed Warehouse-Waiting for allocation" module, and the warehouse selects "YMS Supply Chain", click "YMS Order". If the balance is insufficient, you can contact customer service to recharge.`,
  key1001563: `Go to view`,
  key1001564: `In the "Order Management-My Order" module, you can query the order and enter the "Order Details Page" to check the delivery status.`,
  key1001565: `In the "Financial Management" module, you can query the recharge records and view the cost details.`,
  key1001566: `Successfully marked shipment, bill of lading number:`,
  key1001567: `Please select a logistics plan`,
  key1001568: `Please select a shipping address`,
  key1001569: `Please select Logistics Provider`,
  key1001570: `The logistics tracking number cannot be empty`,
  key1001571: `Logistics Information`,
  key1001572: `Mark Shipment`,
  key1001573: `Modify logistics information`,
  key1001574: `China`,
  key1001575: `Shipping method:`,
  key1001576: `Shipping mode:`,
  key1001577: `Logistics solution:`,
  key1001578: `Shipping address:`,
  key1001579: `Carrier:`,
  key1001580: `Logistics tracking number:`,
  key1001581: `Logistics`,
  key1001582: `Door-to-door collection`,
  key1001583: `Please be sure to contact in advance`,
  key1001584: `Make offline confirmation, whether it can be collected at home!!`,
  key1001585: `Goods to be posted at the time of delivery`,
  key1001586: `Commodity bar code, large package outside need to paste the box mark in a conspicuous place!`,
  key1001587: `Own Logistics`,
  key1001588: `express`,
  key1001589: `Please`,
  key1001590: `Account Management - Basic Information`,
  key1001591: `Maintaining shipping address information in`,
  key1001592: `End boxing`,
  key1001593: `Error initializing WebSocket:`,
  key1001594: `Commodity Basic Attributes 【`,
  key1001595: `Commodity specification attribute 【`,
  key1001596: `-Packaging size (length * width * height`,
  key1001597: `-Weight`,
  key1001598: `-Inventory`,
  key1001599: `-Size-`,
  key1001600: `Tiered pricing type`,
  key1001601: `Stratified price`,
  key1001602: `Field`,
  key1001603: `Whether the product supports customization`,
  key1001604: `Product categories`,
  key1001605: `Commodity number/SPU`,
  key1001606: `Commodity delivery warehouse`,
  key1001607: `Origin of Goods`,
  key1001608: `Commodity carousel diagram`,
  key1001609: `Image Type`,
  key1001610: `Product Chinese Title`,
  key1001611: `Product English Title`,
  key1001612: `Goods and services`,
  key1001613: `Delivery time`,
  key1001614: `Commodity removal specifications`,
  key1001615: `Commodity new specifications`,
  key1001616: `commodity basic attribute`,
  key1001617: `Commodity specification attribute`,
  key1001618: `Minutes ago`,
  key1001619: `Hours ago`,
  key1001620: `Days ago`,
  key1001621: `Weeks ago`,
  key1001622: `Months ago`,
  key1001623: `last year`,
  key1001624: `Sunday`,
  key1001625: `Monday`,
  key1001626: `Tuesday`,
  key1001627: `Wednesday`,
  key1001628: `Thursday`,
  key1001629: `Friday`,
  key1001630: `Saturday`,
  key1001631: `day`,
  key1001632: `hour`,
  key1001633: `minute`,
  key1001634: `1 minute`,
  key1001635: `just`,
  key1001636: `The offline payment function for orders has been disabled. Please contact Tongtu Business if you need to enable it.`,
  key1001637: `The platform's self-operated commodity mode has been turned off. If you need to enable it, please contact Tongtu Business.`,
  key1001638: `The third-party platform authorization function of the supplier has been disabled. If you need to use it, please contact the platform operation.`,
  key1001639: `Offline payment function has been disabled, if you need to use please contact the platform operation.`,
  key1001640: `The order compliance label verification function has been disabled. If you need to enable it, please contact the platform operation.`,
  key1001641: `The current function is turned off`,
  key1001642: `Supplier Operations`,
  key1001643: `Operation`,
  key1001644: `Please download the tongtool print plugin`,
  key1001645: `Click to download`,
  key1001646: `If it is installed, please turn on the through print control. If it is already on, please turn off the control and restart it and try again.`,
  key1001647: `New Products`,
  key1001648: `Current browser Not support websocket`,
  key1001649: `Failed to connect rookie print control,Please confirm that the rookie print control is installed or enabled`,
  key1001650: `Page initialization failed, please refresh and try again`,
  key1001651: `Refresh page`,
  key1001652: `Insufficient account balance`,
  key1001653: `Your account balance is insufficient. Please recharge enough amount before submitting the order!`,
  key1001654: `To recharge`,
  key1001655: `Your account balance is insufficient, please contact the operation staff to recharge or choose other payment methods before paying for the order!`,
  key1001656: `Failed to get Saas system configuration data ===:`,
  key1001657: `Oceania`,
  key1001658: `Europe`,
  key1001659: `Asia`,
  key1001660: `Antarctica`,
  key1001661: `America`,
  key1001662: `Africa`,
  key1001663: `(Supply warehouse and straight hair warehouse)`,
  key1001664: `(Supply warehouse)`,
  key1001665: `(Straight hair compartment)`,
  key1001666: `Supplier Logistics`,
  key1001667: `The logistics method you selected does not support delivery to the receiving address/zip code, which may be due to the fact that the logistics service does not cover the address/zip code;`,
  key1001668: `Checking balance...`,
  key1001669: `access to the cloud to sell logistics failure:`,
  key1001670: `Failed to get enumeration data for all rule items:`,
  key1001671: `Failed to get import template:`,
  key1001672: `Test freight = (weight * unit price registration fee operation fee) * (1 surcharge)`,
  key1001673: `Paid-in freight = (weight * paid-in price after floating registration fee after floating) *(1 surcharge)`,
  key1001674: `Pre-received freight = (weight * paid-in price after floating *(1 pre-received floating percentage) registration fee paid-in operating fee after floating pre-received logistics fee increase amount) *(1 surcharge)`,
  key1001675: `Withholding freight = (weight * price *(1 withholding floating percentage) registration fee operation fee withholding logistics fee increase amount) *(1 surcharge)`,
  key1001676: `Weight less than or equal to first weight:`,
  key1001677: `Test freight = (first heavy freight registration fee operating fee) *(1 surcharge)`,
  key1001678: `Weight greater than the first weight:`,
  key1001679: `Test Freight = {First Weight Freight Rounding Up (Total Weight-First Weight)/Continued Weight Unit Weight * Continued Weight Unit Price Registration Fee Operating Fee} *(1 Surcharge)`,
  key1001680: `Paid-in freight = (paid-in first heavy freight after floating, registration fee, paid-in operating fee after floating) *(1 surcharge)`,
  key1001681: `Pre-received freight = (paid-in first heavy freight after floating *(1 floating percentage of pre-received logistics fee) registration fee after floating paid-in operating fee prepaid logistics fee markup amount) *(1 surcharge)`,
  key1001682: `Paid-in freight = {paid-in first weight freight after floating up rounded up (total weight-first weight)/unit weight of continued weight * paid-in unit price after floating up registered fee paid-in operation fee after floating up} *(1 surcharge)`,
  key1001683: `Pre-received freight = {paid-in first heavy freight after floating * (1 floating percentage of pre-received logistics fee) rounded up (total weight-first weight)/unit weight of renewed weight * paid-in unit price after floating * (1 floating percentage of pre-received logistics fee) paid-in operation fee after floating registration fee prepaid logistics fee markup amount} * (1 surcharge)`,
  key1001684: `Withholding freight = (first heavy freight *(1 withholding logistics fee floating percentage) registration fee operation fee withholding logistics fee markup amount) *(1 surcharge)`,
  key1001685: `Withholding freight = {first heavy freight *(1 withholding logistics fee floating percentage) rounded up (total weight-first weight)/continued weight unit weight * continued weight unit price *(1 withholding logistics fee floating percentage) registration fee operation fee withholding logistics fee markup amount} *(1 surcharge)`,
  key1001686: `Test freight = (unit price registration fee operation fee) * (1 surcharge)`,
  key1001687: `Paid-in freight = (paid-in price after floating, registration fee, paid-in operating fee after floating) *(1 surcharge)`,
  key1001688: `Freight received in advance = paid-in price after floating * (1 percentage of floating in advance) registration fee paid-in operation fee after floating in advance logistics fee increase amount * (1 surcharge)`,
  key1001689: `Withholding freight = (price *(1 withholding floating percentage) registration fee operation fee withholding logistics fee markup amount) *(1 surcharge)`,
  key1001690: `Request timed out`,
  key1001691: `Server Error`,
  key1001692: `The account has been disabled. To re-enable the account, please contact`,
  key1001693: `Operations staff.`,
  key1001694: `Commodity"`,
  key1001695: `"Inventory is insufficient, please revise the quantity and submit it again.`,
  key1001696: `You already have`,
  key1001697: `Account number, you can use this directly`,
  key1001698: `The account number is settled as a supplier.`,
  key1001699: `The account number opens the distributor account.`,
  key1001700: `No access to system`,
  key1001701: `Dear Passage User, you do not have permission to access the system!`,
  key1001702: `Please contact the system administrator!`,
  key1001703: `Reminder for pending confirmation of accounting statement`,
  key1001704: `There are unconfirmed bills, please confirm in a timely manner. If the bill is not confirmed within 14 days after generation, the system will default to the bill being correct and automatically confirm the bill.`,
  key1001705: `View bills`,
  key1001706: `Confirm later`,
  key1001707: `Account deactivation prompt`,
  key1001708: `Insufficient inventory prompt`,
  key1001709: `Confirmation of becoming a supplier`,
  key1001710: `Go to settle in`,
  key1001711: `Confirmation of becoming a distributor`,
  key1001712: `Confirm activation`,
  key1001713: `You already have a Tongtu account, you can directly use this account to open a distributor account.`,
  key1001714: `Bill of Lading,`,
  key1001715: `, there is a large number of goods, has been converted to stock inventory stored in.`,
  key1001716: `Central warehouse.`,
  key1001717: `Automatic order cancellation notification`,
  key1001718: `Your Order`,
  key1001719: `, has timed out and canceled automatically, please pay attention in time.`,
  key1001720: `After opening, when the platform order`,
  key1001721: `When SKU has only one delivery warehouse, the system will automatically match this delivery warehouse by default;`,
  key1001722: `Wanyitong Overseas Warehouse`,
  key1001723: `Miyun Warehouse`,
  key1001724: `Single choices can be customized`,
  key1001725: `Multiple choice can be customized value`,
  key1001726: `Yunmai Supply Chain`,
  key1001727: `Function Introduction`,
  key1001728: `Introduction to Cloud Selling Supply Chain Functions`,
  key1001729: `register`,
  key1001730: `Register for Cloud Selling Supply Chain`,
  key1001731: `Store authorization`,
  key1001732: `One click publishing`,
  key1001733: `Chinese`,
  key1001734: `English`,
  key1001735: `Order out of stock reminder`,
  key1001736: `When the order status is marked as out of stock`,
  key1001737: `Order No.`,
  key1001738: `Your order:<span class = "highlight_color"> [A] </span> is out of stock, please pay attention to it in time!`,
  key1001739: `Stock up`,
  key1001740: `Order stocking reminder`,
  key1001741: `Order qty`,
  key1001742: `You have <span class = "highlight_color"> [A] </span> orders, stock has timed out, please stock in time!`,
  key1001743: `Picking`,
  key1001744: `Order picking reminder`,
  key1001745: `You have <span class = "highlight_color"> [A] </span> orders, picking has timed out, please pick in time!`,
  key1001746: `Switch bill`,
  key1001747: `Order exchange reminder`,
  key1001748: `You have <span class = "highlight_color"> [A] </span> orders. the order change has timed out. please change the order in time!`,
  key1001749: `Packing`,
  key1001750: `Order packing reminder`,
  key1001751: `You have <span class = "highlight_color"> [A] </span> orders, packing has timed out, please pack in time!`,
  key1001752: `Fullfill`,
  key1001753: `Order Delivery Reminder`,
  key1001754: `You have <span class = "highlight_color"> [A] </span> orders, delivery has timed out, please timely delivery!`,
  key1001755: `Order cancellation reminder`,
  key1001756: `When the order status is marked as cancelled`,
  key1001757: `The distributor has canceled the order:<span class = "highlight_color"> [A] </span>, please pay attention to the delivery situation in time`,
  key1001758: `Notice of Product Suspension`,
  key1001759: `When the supplier marks SPU or SKU as discontinued`,
  key1001760: `Dear distributor: your collection:<span class = "highlight_color"> [a] </span>, product code:<span class = "highlight_color"> [B] </span> has been discontinued. if you have already put this product on the shelves, please remove it from the shelves in time.`,
  key1001761: `When the product description or image is modified`,
  key1001762: `Commodity information modification notice`,
  key1001763: `Product <span class = "highlight_color"> [A] </span> information modification notice`,
  key1001764: `Dear distributor: the description/picture of your collection of goods <span class = "highlight_color"> [A] </span> has been modified. if you have put the goods on the shelves, please update them to the latest product information in time.`,
  key1001765: `When the product price is modified`,
  key1001766: `Product Price Adjustment Notice`,
  key1001767: `Commodity <span class = "highlight_color"> [A] </span> price adjustment notice`,
  key1001768: `Dear distributor: due to cost changes, the price of your collection of goods <span class = "highlight_color"> [A] </span> has been adjusted, please pay attention to it in time.`,
  key1001769: `When new products from suppliers are reviewed and approved`,
  key1001770: `Product New Notification`,
  key1001771: `The supplier you are following has launched new products`,
  key1001772: `The supplier you are interested in:<span class = "highlight_color"> [A] </span> has new products.`,
  key1001773: `When the inbound sorting is completed and there are over received items in the bill of lading`,
  key1001774: `Notification of multiple shipments of goods`,
  key1001775: `Bill of Lading Number`,
  key1001776: `When adjusting inventory or shelving tool status through automatic rules configured by distributors`,
  key1001777: `Product status automatic synchronization notification`,
  key1001778: `The goods you subscribe to <span class = "highlight_color"> [A] </span> have been discontinued and relevant information has been automatically adjusted according to the rules. Please pay attention in time.`,
  key1001779: `When adjusting online publication prices through automatic rules configured by distributors`,
  key1001780: `Online publication of automatic price adjustment notifications`,
  key1001781: `For the goods you subscribe to <span class = "highlight_color">【 A 】</span>, the supply price is adjusted, and the online price is automatically adjusted according to the rules. Please pay attention in time.`,
  key1001782: `When the order is automatically cancelled through the timeout configured by the distributor`,
  key1001783: `When automatic order placement through the platform fails due to insufficient balance`,
  key1001784: `Notification of insufficient balance and failed order placement`,
  key1001785: `Notice of insufficient balance`,
  key1001786: `Platform`,
  key1001787: `Your balance is insufficient. <span class = "highlight_color"> [A] </span> order <span class = "highlight_color"> [B] </span> failed automatically. Please recharge in time.`,
  key1001788: `When commodity review is rejected`,
  key1001789: `Notice of Commodity Review Rejection`,
  key1001790: `Your product:<span class = "highlight_color"> [A] </span>, the audit failed, rejected reason: XXXXXXXXX.`,
  key1001791: `When the distributor store status is marked as "unauthorized;`,
  key1001792: `Store Authorization Expiration Notice`,
  key1001793: `Platform Name`,
  key1001794: `Shop Name`,
  key1001795: `Your authorization for the store <span class = "highlight_color"> [B] </span> in the platform:<span class = "highlight_color"> [A] </span> has expired, please update the authorization information in time;`,
  key1001796: `When the authorization status of the distributor's own logistics provider is marked as "unauthorized;`,
  key1001797: `Own logistics authorization expiration notice`,
  key1001798: `Your own logistics provider:<span class = "highlight_color"> [A] </span>, the authorization has expired, please update the authorization information in time;`,
  key1001799: `Complete Creation`,
  key1001800: `Awaiting Payment`,
  key1001801: `Waiting for in-transit inventory`,
  key1001802: `Waiting for merchants to pick up goods`,
  key1001803: `Pending merchant review`,
  key1001804: `To be packed by merchants`,
  key1001805: `In express transportation`,
  key1001806: `Arriving at the central warehouse`,
  key1001807: `The central warehouse has arrived`,
  key1001808: `To be picked`,
  key1001809: `To be packed`,
  key1001810: `To be boxed`,
  key1001811: `Waiting for logistics provider to come and pick up the package`,
  key1001812: `Delivered to logistics provider`,
  key1001813: `Cancelled`,
  key1001814: `English US name`,
  key1001815: `English UK name`,
  key1001816: `English - AU name`,
  key1001817: `English - EU name`,
  key1001818: `Buy It Now`,
  key1001819: `Add To The Cart`,
  key1001820: `Skillful Collection`,
  key1001821: `Generate sales information`,
  key1001822: `Download`,
  key1001823: `Merchandise available for sale`,
  key1001824: `After the opening of the goods can be sold to the seller configuration, in the mall can be through this commodity screening;`,
  key1001825: `Commodity label display`,
  key1001826: `After activation, the commodity label will be displayed in the mall, while when deactivated, it will only be displayed in the commodity list at the operating end;`,
  key1001827: `LOGO Configuration`,
  key1001828: `After the configuration, the LOGO display department involved in the operation system will display the LOGO you configured;`,
  key1001829: `Default Language`,
  key1001830: `After configuration, the operating system user logs in for the first time to display this language;`,
  key1001831: `Platform billing cycle configuration`,
  key1001832: `After configuration, platform bills are summarized and generated in this cycle;`,
  key1001833: `Offline payment`,
  key1001834: `After the offline payment is enabled, the distributor can complete the order payment by offline payment and uploading the payment voucher;`,
  key1001835: `Order automatically canceled`,
  key1001836: `After the automatic countdown cancellation is enabled and set, the order will enter the countdown immediately after the distributor creates the order to be paid, and the order will be canceled automatically after the countdown ends;`,
  key1001837: `Cross-border e-commerce platform configuration`,
  key1001838: `Distributors can only bind the configured e-commerce platform stores to publish one item and pull orders;`,
  key1001839: `Online payment channels`,
  key1001840: `After configuration, the distributor can enable the corresponding payment channel (upload the corresponding qualification according to the channel requirements);`,
  key1001841: `After configuration, the distribution mall and the LOGO display office involved in the distribution background will display the LOGO you configured;`,
  key1001842: `Language Configuration`,
  key1001843: `The distributor can switch the display in the corresponding system according to the configured language;`,
  key1001844: `Product Details Page Button Layout Configuration`,
  key1001845: `The layout priority of each functional button in the commodity details page of the mall can be adjusted according to the current business focus;`,
  key1001846: `Mall tourist price display configuration`,
  key1001847: `According to the actual business situation, whether the commodity price of the mall for unregistered tourist distributors is displayed/displayed can be configured.`,
  key1001848: `Mall Registered Distributor Default Business Type Configuration`,
  key1001849: `The default business type (retail/wholesale) registered by the mall registration portal as a distributor can be configured according to the actual business situation.`,
  key1001850: `Platform Order Delivery Warehouse Matching Configuration`,
  key1001851: `Display Configuration of Suspension Information on the Right Side of the Mall`,
  key1001852: `Click on the "WeChat Consultation" and "Telephone Consultation" information content displayed on the right side of the configurable distribution mall and distribution background page;`,
  key1001853: `Third-party platform configuration`,
  key1001854: `After configuration, the supplier can authorize the configured platform to synchronize inventory and pull orders;`,
  key1001855: `After configuration, the LOGO display places involved in the supplier system will display your configured LOGO;`,
  key1001856: `The supplier can switch the display in the corresponding system according to the configured language;`,
  key1001857: `Routine`,
  key1001858: `paramValue parsing failed:`,
  key1001859: `Original recipient name`,
  key1001860: `Original recipient email`,
  key1001861: `Original recipient phone number`,
  key1001862: `Original recipient user`,
  key1001863: `Original receiving country code`,
  key1001864: `Original recipient's mobile phone`,
  key1001865: `Original shipping address 1`,
  key1001866: `Original shipping address 2`,
  key1001867: `Original recipient city`,
  key1001868: `Original recipient state/province`,
  key1001869: `Original recipient's postal code`,
  key1001870: `Original recipient's passport code`,
  key1001871: `Order [`,
  key1001872: `]Successfully modified the address:`,
  key1001873: `Payment, actual amount paid:`,
  key1001874: `Distributor has made payment, actual amount paid:`,
  key1001875: `Price adjustment; Total original price of goods:`,
  key1001876: `; Distributor's payable amount:`,
  key1001877: `; Supplier's receivable amount:`,
  key1001878: `Arrived at warehouse`,
  key1001879: `Mark as not`,
  key1001880: `Order, empty goods & logistics information`,
  key1001881: `Automatic matching of order items or logistics failed`,
  key1001882: `Original order cancellation`,
  key1001883: `No logistics matched`,
  key1001884: `Matching basic logistics failed`,
  key1001885: `Cancel the order successfully`,
  key1001886: `automatic matching logistics success:`,
  key1001887: `Order`,
  key1001888: `Successfully matched logistics:`,
  key1001889: `]Match logistics special rules:[`,
  key1001890: `]Matching scope:`,
  key1001891: `Matching scheme rules:`,
  key1001892: `Successfully matched product manually: Platform SKU:`,
  key1001893: `, match`,
  key1001894: `Failed to manually match product: Platform SKU:`,
  key1001895: `, not matched`,
  key1001896: `Successfully matched product: Platform SKU:`,
  key1001897: `Automatic matching of products failed: Platform SKU:`,
  key1001898: `SKU failed, SKU discontinued`,
  key1001899: `manual matching logistics success:`,
  key1001900: `Failed to place order, distributor balance is insufficient`,
  key1001901: `Change logistics information, original logistics method:`,
  key1001902: `Original waybill number:`,
  key1001903: `Original transaction number:`,
  key1001904: `Shipment failed due to:`,
  key1001905: `Successfully shipped with tracking number:`,
  key1001906: `Cancellation of order failed due:`,
  key1001907: `Failed to place the order`,
  key1001908: `Successfully ordered`,
  key1001909: `Automatic matching of logistics failed, no eligible logistics methods were found`,
  key1001910: `(No logistics that meet the basic conditions were found)`,
  key1001911: `Failed to modify address information`,
  key1001912: `]Successfully modified logistics:`,
  key1001913: `Original logistics`,
  key1001914: `Change to`,
  key1001915: `]Failed to modify logistics information`,
  key1001916: `Add Authorization`,
  key1001917: `Update Authorization`,
  key1001918: `Authorization expired`,
  key1001919: `Manual labeling of platform orders indicates successful shipment`,
  key1001920: `Edit IOSS; IOSS Name:`,
  key1001921: `; IOSS number:`,
  key1001922: `Add IOSS; IOSS Name:`,
  key1001923: `Add rules; Rule Name:`,
  key1001924: `; IOSS used:`,
  key1001925: `; Applicable platforms:`,
  key1001926: `; Applicable stores:`,
  key1001927: `Editing rules; Rule Name:`,
  key1001928: `Cancel transaction, Cancellation Amount:`,
  key1001929: `Partial Cancellation, Cancellation Amount:`,
  key1001930: `Create a stock order`,
  key1001931: `Confirm order acceptance and accept price adjustment`,
  key1001932: `Refuse price adjustment`,
  key1001933: `Undelivered part has been refunded, refund amount`,
  key1001934: `, currency:`,
  key1001935: `All sub orders have arrived at the warehouse and have been completed`,
  key1001936: `Place an order`,
  key1001937: `Goods out of stock, restocking in progress:; Estimated delivery time:`,
  key1001938: `; The out of stock content is as follows:;`,
  key1001939: `The goods are out of stock and have been discontinued:; The out of stock content is as follows:;`,
  key1001940: `Please provide postal code information and try again`,
  key1001941: `Add attribute`,
  key1001942: `Enable Properties`,
  key1001943: `Deactivate Properties`,
  key1001944: `Delivery successful`,
  key1001945: `Successfully issued logistics`,
  key1001946: `Change logistics information; Original logistics method:`,
  key1001947: `; Original waybill number:`,
  key1001948: `; Original item flow tracking number:`,
  key1001949: `Void order successfully`,
  key1001950: `Generate bills`,
  key1001951: `Update warehouse bills`,
  key1001952: `Generate customer bills`,
  key1001953: `Logistics sorting completed`,
  key1001954: `New rate:`,
  key1001955: `Edit rate:`,
  key1001956: `Generate a supplier invoice`,
  key1001957: `Generate a distributor invoice`,
  key1001958: `Failed to change order and returned to the generated picking list`,
  key1001959: `From picking list【`,
  key1001960: `】Remove`,
  key1001961: `Order has been changed`,
  key1001962: `Reset sorting`,
  key1001963: `Mark as picked`,
  key1001964: `Picking list has been generated, picking list number:【`,
  key1001965: `Failed to change order and returned to the picking list`,
  key1001966: `The bill of lading has been collected`,
  key1001967: `Bill of lading created`,
  key1001968: `The bill of lading has been stored in the warehouse`,
  key1001969: `The bill of lading has been shelved`,
  key1001970: `Bill of lading sorted`,
  key1001971: `There are excess packages, please contact the supplier`,
  key1001972: `Reason for failure to pass the review:`,
  key1001973: `Approved by review`,
  key1001974: `Change to`,
  key1001975: `Review failed:`,
  key1001976: `Failed by review`,
  key1001977: `Failed to pass the audit`,
  key1001978: `Adjusting subsidies`,
  key1001979: `by`,
  key1001980: `adjust to`,
  key1001981: `; Adjustment instructions:`,
  key1001982: `Manually adding suppliers for operations`,
  key1001983: `Deactivate supplier`,
  key1001984: `Enable supplier`,
  key1001985: `Edit suppliers`,
  key1001986: `Registering suppliers in the mall`,
  key1001987: `Entering the mall to improve supplier and enterprise information`,
  key1001988: `Review rejection, reason for rejection:`,
  key1001989: `New configuration added`,
  key1001990: `Edit Configuration`,
  key1001991: `Allocated inventory`,
  key1001992: `Matching intelligent logistics rules:`,
  key1001993: `Create Order`,
  key1001994: `In stock`,
  key1001995: `Outbound order No.:`,
  key1001996: `Successfully matched the warehouse automatically; Shipping warehouse:`,
  key1001997: `Canceled order`,
  key1001998: `Cancel Order, Cancellation Reason:`,
  key1001999: `Logistics [`,
  key1002000: `]Change to[`,
  key1002001: `; Special rules:`,
  key1002002: `Applicable scope`,
  key1002003: `Freight/Time Priority`,
  key1002004: `Abnormal package status obtained before uploading package`,
  key1002005: `Application for waybill number failed`,
  key1002006: `Failed to obtain shipping number`,
  key1002007: `Exception in obtaining AliExpress product labels`,
  key1002008: `Successfully applied for waybill number`,
  key1002009: `(Waybill number:`,
  key1002010: `(Reason for failure:`,
  key1002011: `Edits re uploading package exception`,
  key1002012: `Manual modification: Update warehouse bill 【 Document cost 】`,
  key1002013: `Manual modification: Update warehouse bill [other expenses]`,
  key1002014: `Manual modification: adding other expenses【`,
  key1002015: `Add notes`,
  key1002016: `Manual modification`,
  key1002017: `Currency modification`,
  key1002018: `Import billing updates`,
  key1002019: `Confirm settlement`,
  key1002020: `Manual mark mark mark allows order cancellation`,
  key1002021: `Due to the change of address, the current logistics cannot be delivered. The original order has been canceled. Please re-match the logistics and place the order.`,
  key1002022: `Receiving`,
  key1002023: `The original order has been canceled due to address modification.`,
  key1002024: `Voided bill of lading, reason:`,
  key1002025: `Manually mark payment success`,
  key1002026: `The buyer modifies the receiving address and updates the order receiving address.`,
  key1002027: `Payment amount:`,
  key1002028: `, Duration:`,
  key1002029: `Months`,
  key1002030: `First allocation of stock documents`,
  key1002031: `Change of merchant's industrial and commercial information, reason for rejection:`,
  key1002032: `Supplier modified:`,
  key1002033: `Merchant business information change, approved`,
  key1002034: `Add tag to order:`,
  key1002035: `Order Delete Tag:`,
  key1002036: `There is a stock document that has not yet arrived and is waiting for in-transit inventory.`,
  key1002037: `Add notes to order:`,
  key1002038: `Meixi warehouse stock is insufficient, waiting for the next distribution.`,
  key1002039: `Review Billing`,
  key1002040: `Confirm billing`,
  key1002041: `Confirm payment`,
  key1002042: `Goods discontinued:`,
  key1002043: `Stopped Goods:`,
  key1002044: `, generating product label exception;`,
  key1002045: `Upload payment voucher information`,
  key1002046: `Edit payment voucher information`,
  key1002047: `Operational Reconciliation-Pass`,
  key1002048: `Operational Reconciliation-Return`,
  key1002049: `Order Payment Information Cancellation`,
  key1002050: `Offline payment successful`,
  key1002051: `Order Payment Information Submission`,
  key1002052: `Modify Payment Voucher Information`,
  key1002053: `Manually match the warehouse successfully:`,
  key1002054: `Distributor Payment`,
  key1002055: `Credit limit by`,
  key1002056: `Modified to`,
  key1002057: `Auto Match Goods Shipment Warehouse Failed`,
  key1002058: `Automatic matching goods delivery warehouse success`,
  key1002059: `Successful manual matching of goods delivery warehouse`,
  key1002060: `The warehouse`,
  key1002061: `Type is modified`,
  key1002062: `, goods delivery warehouse`,
  key1002063: `Modify to match`,
  key1002064: `Add Order Manually-`,
  key1002065: `Split Order-`,
  key1002066: `, split into orders`,
  key1002067: `Order manually adjusted successfully, Order No:`,
  key1002068: `The corresponding delivery warehouse is short of inventory, please adjust the order quantity of this commodity or the delivery warehouse of the commodity.`,
  key1002069: `Product customization content configuration completed`,
  key1002070: `Automatic product customization content configuration failed`,
  key1002071: `Update Customer Billing`,
  key1002072: `Supplier Sub-Doc"`,
  key1002073: `", has been in`,
  key1002074: `Successful online delivery of platform orders`,
  key1002075: `Platform order address decryption successful.`,
  key1002076: `Decryption of platform order address failed. Failure reason:`,
  key1002077: `Add commodity SPU [`,
  key1002078: `Add goods [`,
  key1002079: `Delete SKU [`,
  key1002080: `Add Product Picture`,
  key1002081: `Added SPU color picture`,
  key1002082: `Modify commodity specifications: [`,
  key1002083: `] read [`,
  key1002084: `Modified goods: [`,
  key1002085: `]; Assembly information sku:[`,
  key1002086: `New picture:`,
  key1002087: `To delete a picture:`,
  key1002088: `Modify commodity Height:[`,
  key1002089: `Modify commodity LENGTH:[`,
  key1002090: `Modify Goods WEIGHT:[`,
  key1002091: `Modify commodity WIDTH:[`,
  key1002092: `Modify the item SKU:[`,
  key1002093: `Delete SKU item attributes, labels, pictures: [`,
  key1002094: `delivery warehouse [`,
  key1002095: `] Change of Supply Price: [`,
  key1002096: `] changed [`,
  key1002097: `Update Commodity SPU:[`,
  key1002098: `Item attributes`,
  key1002099: `Value: [`,
  key1002100: `Modify commodity description`,
  key1002101: `Modify SPU/Commodity Code: [`,
  key1002102: `Modify the Chinese name of the commodity: [`,
  key1002103: `Goods on shelves:`,
  key1002104: `Goods on shelves:`,
  key1002105: `Submission of Distributor Balance Recharge Information`,
  key1002106: `Distributor offline recharge success`,
  key1002107: `Reason for rejection:`,
  key1002108: `Merchant store information change, approved`,
  key1002109: `Merchant Collection Account Change, Rejection Reason:`,
  key1002110: `Merchant collection account change, approved`,
  key1002111: `Not associated with the corresponding regional/national compliance responsible person, manufacturer information`,
  key1002112: `[Lowest shipping cost]`,
  key1002113: `[Fastest time]`,
  key1002114: `Supply warehouse`,
  key1002115: `Straight hair bin`,
  key1002116: `[imInit] window.tmsIm SDK is not loaded, please check whether im.min.js is introduced in HTML`,
  key1002117: `[imInit] initialization failed, please check whether the systemEnvironment is correct`,
  key1002118: `The current available languages have been changed. If you have any questions, please contact the platform operation!`,
  key1002119: `Click Refresh`,
  key1002120: `Unable to stock up to`,
  key1002121: `warehouse`,
  key1002122: `Currently, orders can be placed at most.`,
  key1002123: `individual`,
  key1002124: `There are duplicates, please modify them`,
  key1002125: `Size value language:`,
  key1002126: `Cannot be empty`,
  key1002127: `Delivery note:`,
  key1002128: `Not waiting for picking status, please remove it before completing the addition`,
  key1002129: `AliExpress appointment delivery failed`,
  key1002130: `The quantity exceeds the limit, please check the quantity`,
  key1002131: `Current container`,
  key1002132: `Being occupied`,
  key1002133: `Already exists`,
  key1002134: `Operation distribution logistics exception: different warehouses`,
  key1002135: `Orders cannot be shipped simultaneously`,
  key1002136: `Logistics exception during operation: store address mismatch`,
  key1002137: `Booked, Collection Number:`,
  key1002138: `Supplier system outbound exception, bill of lading number:`,
  key1002139: `Handover order number:`,
  key1002140: `Appointment delivery exception`,
  key1002141: `The goods are not required for this order. Please confirm the order to which the goods belong`,
  key1002142: `Bill of Lading:`,
  key1002143: `Not present, please enter the correct bill of lading number`,
  key1002144: `There are issued cloud sell orders`,
  key1002145: `The storage area of the location does not match:`,
  key1002146: `[bindAppScrollClosePoppers] Scroll container not found:`,
  key1002147: `, preferential amount:`,
  key1002148: `, discount factor:`,
  key1002149: `The countdown to cancel the order to be paid cannot be empty!`,
  key1002150: `Enable this feature:`,
  key1002151: `Pending order cancellation countdown:`,
  key1002152: `priority`,
  key1002153: `Place to the bottom`,
  key1002154: `Place to the top`,
  key1002155: `Move`,
  key1002156: `Rule name`,
  key1002157: `Enable Status`,
  key1002158: `Founder`,
  key1002159: `Creation time`,
  key1002160: `Last update date`,
  key1002161: `Modification success`,
  key1002162: `Delete prompt`,
  key1002163: `After deleting the rule, it will not be recoverable. Do you want to delete it?`,
  key1002164: `Enable status:`,
  key1002165: `Please enter the rule name`,
  key1002166: `Add Rule`,
  key1002167: `Ali International`,
  key1002168: `View the rules`,
  key1002169: `Edit rules`,
  key1002170: `Copy Rules`,
  key1002171: `Please select a rule item first!`,
  key1002172: `Copy successfully`,
  key1002173: `Warehouse cannot be empty`,
  key1002174: `Action type:`,
  key1002175: `Designated account number`,
  key1002176: `Designated performing party`,
  key1002177: `Set action`,
  key1002178: `Assign shipping warehouse`,
  key1002179: `When the assigned warehouse is out of stock, it supports continuing to match other allocation warehouse rules`,
  key1002180: `Disable`,
  key1002181: `Name of place of shipment`,
  key1002182: `Country of Shipment`,
  key1002183: `Whether goods collection is allowed`,
  key1002184: `View & Edit`,
  key1002185: `New Shipment`,
  key1002186: `Cross-border e-commerce platform to choose at least one!`,
  key1002187: `Platform selection:`,
  key1002188: `Container type`,
  key1002189: `Weight(kg)`,
  key1002190: `Volume (cm³)`,
  key1002191: `Length (cm)`,
  key1002192: `Width(cm)`,
  key1002193: `Height(cm)`,
  key1002194: `Container type cannot be null`,
  key1002195: `Container weight cannot be empty`,
  key1002196: `Container volume cannot be empty`,
  key1002197: `Container length cannot be empty`,
  key1002198: `Container width cannot be empty`,
  key1002199: `Container height cannot be empty`,
  key1002200: `Add container type`,
  key1002201: `Container Type:`,
  key1002202: `Please enter the container type, e.g. pass box`,
  key1002203: `Weight (kg):`,
  key1002204: `Volume (cm³):`,
  key1002205: `Length (cm):`,
  key1002206: `Width (cm):`,
  key1002207: `Height (cm):`,
  key1002208: `Platform Currency`,
  key1002209: `Transaction Currency`,
  key1002210: `Exchange rate configuration`,
  key1002211: `Fixed exchange rate`,
  key1002212: `Real time exchange rate fluctuations`,
  key1002213: `Floating ratio`,
  key1002214: `Downward float`,
  key1002215: `Please enter a fixed exchange rate`,
  key1002216: `Please enter the floating ratio`,
  key1002217: `Exchange rate display`,
  key1002218: `Real time exchange rate:`,
  key1002219: `System exchange rate:`,
  key1002220: `Fixed exchange rate cannot be empty!`,
  key1002221: `The fixed exchange rate must be greater than or equal to 0 and a maximum of 4 decimal places allowed`,
  key1002222: `Real time exchange rate fluctuations cannot be empty!`,
  key1002223: `Real time exchange rate fluctuations must be greater than or equal to 0 and a maximum of 4 decimal places allowed`,
  key1002224: `Platform Currency:`,
  key1002225: `Supplier Currency:`,
  key1002226: `Add Supporting Currency`,
  key1002227: `Distributor Currency:`,
  key1002228: `Settlement per month`,
  key1002229: `Settlement every half month`,
  key1002230: `Settlement per week`,
  key1002231: `Monthly`,
  key1002232: `every half month`,
  key1002233: `Weekly`,
  key1002234: `Please fill in the bill generation cycle`,
  key1002235: `Generate,`,
  key1002236: `of the nth`,
  key1002237: `Bill generation cycle:`,
  key1002238: `Press`,
  key1002239: `Day, generate bill`,
  key1002240: `Print container barcodes`,
  key1002241: `Please enter custom content`,
  key1002242: `Dielectric Material:`,
  key1002243: `Label size:`,
  key1002244: `Custom content:`,
  key1002245: `Custom content font`,
  key1002246: `Bar code font`,
  key1002247: `Each PT is about 0.35 mm wide. Make sure that the longest number of SKU characters * the left PT value * 0.35 is smaller than the medium size.`,
  key1002248: `Do not print custom content`,
  key1002249: `Print custom content`,
  key1002250: `add`,
  key1002251: `set a unified print quantity`,
  key1002252: `Note: Printed content can be dragged to change position.`,
  key1002253: `The service provider does not have a warehouse at this shipping place, please select another shipping place for configuration.`,
  key1002254: `Please select the warehouse shipping place first!`,
  key1002255: `Online logistics`,
  key1002256: `Offline logistics`,
  key1002257: `platform logistics`,
  key1002258: `Please select a third party service provider`,
  key1002259: `Please improve the information of service providers`,
  key1002260: `Open warehouse`,
  key1002261: `Warehouse available logistics configuration`,
  key1002262: `Message name`,
  key1002263: `Message type`,
  key1002264: `Notification channel`,
  key1002265: `The way of notification`,
  key1002266: `Mail within Website`,
  key1002267: `Email->SMS`,
  key1002268: `SMS->Mailbox`,
  key1002269: `After deleting the message template, the reminder message will no longer be sent. Are you sure to delete it?`,
  key1002270: `Add message template`,
  key1002271: `Title cannot be empty!`,
  key1002272: `The content cannot be empty!`,
  key1002273: `The message type cannot be empty`,
  key1002274: `Content:`,
  key1002275: `Edit message template`,
  key1002276: `When the reminder time type is fixed time and the unit is the day, the specific reminder time period cannot be empty!`,
  key1002277: `The frequency of trigger conditions cannot be empty!`,
  key1002278: `The frequency cannot be empty when the reminder type is the fixed time!`,
  key1002279: `Edit successfully`,
  key1002280: `Message name:`,
  key1002281: `Please enter the name of the message, with a maximum of 20 Chinese characters`,
  key1002282: `Message type:`,
  key1002283: `Triggering conditions:`,
  key1002284: `Notification channel:`,
  key1002285: `The way of notification：`,
  key1002286: `Whether to pop up:`,
  key1002287: `Reminder time:`,
  key1002288: `The reminder time period is: 6:00-23:00, and no reminder in other time periods`,
  key1002289: `Please select a time.`,
  key1002290: `Placeholder:`,
  key1002291: `Meaning:`,
  key1002292: `The stay time of the status exceeded`,
  key1002293: `Remind in time`,
  key1002294: `Fixed time`,
  key1002295: `Every`,
  key1002296: `Remind once`,
  key1002297: `1) Dynamic fields can be added by dragging and dropping from the right side.`,
  key1002298: `2) The blue font text is a dynamic parameter, please do not modify it.`,
  key1002299: `3) Customized content only supports internal messages and emails, and SMS will be sent according to the default content.`,
  key1002300: `dynamic parameter`,
  key1002301: `Shipment name cannot be empty`,
  key1002302: `Shipping Country cannot be empty`,
  key1002303: `Name of place of shipment:`,
  key1002304: `Shipping Country:`,
  key1002305: `Allowed to collect goods:`,
  key1002306: `Button Name`,
  key1002307: `(More)`,
  key1002308: `Whether to set as the primary button`,
  key1002309: `Visible`,
  key1002310: `Button layout configuration`,
  key1002311: `This button is only displayed in the customizable product details page!`,
  key1002312: `Button Configuration`,
  key1002313: `Layout Preview`,
  key1002314: `Storage area code`,
  key1002315: `Name of storage area`,
  key1002316: `Warehouse name cannot be empty`,
  key1002317: `Storage area name cannot be empty`,
  key1002318: `The storage area code cannot be empty.`,
  key1002319: `Status cannot be empty`,
  key1002320: `Add storage area`,
  key1002321: `View the library area`,
  key1002322: `Edit library area`,
  key1002323: `Please check the data to be printed first!`,
  key1002324: `Storage area Name:`,
  key1002325: `Storage area code:`,
  key1002326: `Storage area Status:`,
  key1002327: `Warehouse name:`,
  key1002328: `Print warehouse barcode`,
  key1002329: `Storage area`,
  key1002330: `Bulk print barcodes`,
  key1002331: `Full name`,
  key1002332: `Country/Region`,
  key1002333: `Province/State`,
  key1002334: `City`,
  key1002335: `county`,
  key1002336: `Street Address 1`,
  key1002337: `Street Address 2`,
  key1002338: `Street Address 3`,
  key1002339: `Mobile phone number`,
  key1002340: `Zip code`,
  key1002341: `Company Name`,
  key1002342: `Email`,
  key1002343: `Please enter the external display-warehouse name`,
  key1002344: `Please enter external display-warehouse code`,
  key1002345: `View & Edit Warehouse`,
  key1002346: `Please contact the platform operator to determine the warehouse information and then select`,
  key1002347: `The supplier's straight hair warehouse will be displayed directly to the distributor in the mall, and the name and code of the straight hair warehouse visible to the distributor can be configured independently.`,
  key1002348: `Please select the logistics channel that this straight hair warehouse has been connected to and can be sent out.`,
  key1002349: `Third Party Logistics`,
  key1002350: `Basic information`,
  key1002351: `Warehouse place of shipment:`,
  key1002352: `Warehouse code:`,
  key1002353: `Warehouse configuration`,
  key1002354: `Warehouse type:`,
  key1002355: `Supply bin configuration`,
  key1002356: `Supply target warehouse:`,
  key1002357: `Whether you can print the logistics face sheet:`,
  key1002358: `Straight bin configuration`,
  key1002359: `External Display-Warehouse Name:`,
  key1002360: `External display-warehouse name cannot be empty`,
  key1002361: `External Display-Warehouse Code:`,
  key1002362: `External display-warehouse code cannot be empty`,
  key1002363: `Straight hair available logistics`,
  key1002364: `Warehouse address`,
  key1002365: `Shipping Address`,
  key1002366: `Return address`,
  key1002367: `Two-dimensional code picture size cannot be smaller`,
  key1002368: `170px, currently`,
  key1002369: `The format of the uploaded file is incorrect, the file`,
  key1002370: `Format error, please select jpg, jpeg, png format image`,
  key1002371: `limited file size, file`,
  key1002372: `Too big, not more than 20m`,
  key1002373: `Please upload the display picture (two-dimensional code)`,
  key1002374: `Please enter your phone number.`,
  key1002375: `Only images in PNG / JPG / JPEG format are supported`,
  key1002376: `Picture reading failed`,
  key1002377: `Image uploaded successfully`,
  key1002378: `Show this information:`,
  key1002379: `Consultation period:`,
  key1002380: `For example: Monday to Friday 9:00-18:00`,
  key1002381: `Show pictures (two-dimensional code):`,
  key1002382: `Please enter the content`,
  key1002383: `Show`,
  key1002384: `Hide`,
  key1002385: `Re upload`,
  key1002386: `Click to upload image`,
  key1002387: `Container number`,
  key1002388: `Container color`,
  key1002389: `Job status`,
  key1002390: `Warehouse`,
  key1002391: `Last occupied time`,
  key1002392: `Edit Container Color`,
  key1002393: `The warehouse must not be empty.`,
  key1002394: `Add container`,
  key1002395: `Please select data`,
  key1002396: `The number of containers cannot be empty`,
  key1002397: `The number of containers must be a positive integer greater than 0`,
  key1002398: `Failed to upload audio, please try again`,
  key1002399: `Warehouse:`,
  key1002400: `Container number:`,
  key1002401: `Please enter the container number`,
  key1002402: `Container color:`,
  key1002403: `Job status:`,
  key1002404: `Number of containers:`,
  key1002405: `Please enter a color name`,
  key1002406: `Bulk delete`,
  key1002407: `Upload audio`,
  key1002408: `Visitor Price Show:`,
  key1002409: `Check Consistency of Shipment`,
  key1002410: `It is used to identify whether the platform requires the actual place of shipment of the order to be consistent with the place of shipment marked by the platform background, so that the system can judge whether the order can be replaced by the delivery warehouse for delivery.`,
  key1002411: `Platform Settings`,
  key1002412: `Platform List`,
  key1002413: `Whether the platform verifies the consistency of the shipping place:`,
  key1002414: `Add warehouse`,
  key1002415: `Warehouse code cannot be empty`,
  key1002416: `Warehouse type cannot be empty`,
  key1002417: `Shipment place cannot be empty`,
  key1002418: `Regular order processing fee cannot be empty`,
  key1002419: `Regular multi item order continuation cannot be empty`,
  key1002420: `The processing fee for stocking orders cannot be empty`,
  key1002421: `Warehouse shipping address`,
  key1002422: `Warehouse delivery address`,
  key1002423: `Warehouse return address`,
  key1002424: `Name:`,
  key1002425: `Edit warehouses`,
  key1002426: `View warehouse`,
  key1002427: `Name is required.`,
  key1002428: `The left interval cannot be empty!`,
  key1002429: `The right interval cannot be empty!`,
  key1002430: `Layered price cannot be empty!`,
  key1002431: `The left interval cannot be greater than or equal to the right interval`,
  key1002432: `Template selection cannot be empty`,
  key1002433: `Shipment:`,
  key1002434: `Whether the goods can be stocked:`,
  key1002435: `Set as warehouse:`,
  key1002436: `Template selection:`,
  key1002437: `Regular order processing fee:`,
  key1002438: `Regular Multi Product Order Continuation:`,
  key1002439: `Regular order consumables fee:`,
  key1002440: `Stock order processing fee:`,
  key1002441: `Warehouse rent:`,
  key1002442: ` /Pieces`,
  key1002443: ` /Single`,
  key1002444: ` /Month`,
  key1002445: `Warehouse processing fee`,
  key1002446: `Add Tiered Price`,
  key1002447: `everyday`,
  key1002448: `hour`,
  key1002449: `Click to view`,
  key1002450: `Message title`,
  key1002451: `Time`,
  key1002452: `Please tick the data you want to mark as read first!`,
  key1002453: `Mark as Readed`,
  key1002454: `Total`,
  key1002455: `Messages, of which unread messages`,
  key1002456: `-Default language`,
  key1002457: `(currently configured`,
  key1002458: `(Countdown`,
  key1002459: `Function Name`,
  key1002460: `Function Description`,
  key1002461: `Functional status`,
  key1002462: `Configuration`,
  key1002463: `Don't show price`,
  key1002464: `Display commodity sales price`,
  key1002465: `Display commodity wholesale price`,
  key1002466: `Display the retail price of goods`,
  key1002467: `Operation end`,
  key1002468: `Distributor side`,
  key1002469: `Supplier side`,
  key1002470: `Deactivate Prompt`,
  key1002471: `Are you sure you want to disable this configuration item?`,
  key1002472: `Deactivated successfully!`,
  key1002473: `Successfully enabled!`,
  key1002474: `Destination country`,
  key1002475: `Customs clearance rate`,
  key1002476: `updater`,
  key1002477: `Update date`,
  key1002478: `Log`,
  key1002479: `Enable Confirmation`,
  key1002480: `Deactivation confirmation`,
  key1002481: `After activation, this destination country will verify the IOSS number. Please confirm whether to enable it?`,
  key1002482: `After deactivation, this destination country will no longer verify the IOSS number. Please confirm if you want to deactivate it?`,
  key1002483: `Confirm activation`,
  key1002484: `Confirm Deactivation`,
  key1002485: `Enabling Success`,
  key1002486: `Disabling Success`,
  key1002487: `The destination country cannot be empty`,
  key1002488: `The customs clearance rate cannot be empty`,
  key1002489: `Supports up to two decimal places, must be greater than or equal to 0`,
  key1002490: `Add tax rate settings`,
  key1002491: `Edit tax rate settings`,
  key1002492: `The customs clearance rate cannot be empty!`,
  key1002493: `Destination country:`,
  key1002494: `Customs clearance rate:`,
  key1002495: `Channel selection:`,
  key1002496: `Choose according to the order of unit price of goods cost from high to low`,
  key1002497: `Choose from high to low in the order of unit price X of the product cost`,
  key1002498: `Select according to the product volume size from large to small`,
  key1002499: `Choose according to the order of volume X from large to small`,
  key1002500: `Choose according to the order of weight from big to small`,
  key1002501: `Choose according to the order of weight X quantity from large to small`,
  key1002502: `The top price should be higher than the minimum price.`,
  key1002503: `Please enter the lowest price setting.`,
  key1002504: `Please enter Set Top Price`,
  key1002505: `Please enter the setting package capping weight`,
  key1002506: `Number of SKU species declared`,
  key1002507: `Number of SKU species declared per declaration`,
  key1002508: `The package contains information about goods to be declared when multiple SKUs are included`,
  key1002509: `Calculating method of declared weight`,
  key1002510: `Calculation method of declared price`,
  key1002511: `Default declaration settings`,
  key1002512: `All declarations`,
  key1002513: `Limit the maximum number of declared varieties`,
  key1002514: `Actual quantity`,
  key1002515: `Limit the maximum number of declarations`,
  key1002516: `This item is only used to determine the name and quantity of declaration, and has no effect on the weight and price of declaration.`,
  key1002517: `Use Fixed Total Weight Declaration`,
  key1002518: `The total weight of the fixed package is`,
  key1002519: `If the weight of each item needs to be declared in detail at the time of declaration, the system will automatically calculate the weighted average of the actual weight of the item declared.`,
  key1002520: `Declaration of true weight of goods used`,
  key1002521: `Set the top weight of the package to be`,
  key1002522: `Currency for declaration`,
  key1002523: `Use fixed price declaration`,
  key1002524: `Fixed declared price`,
  key1002525: `This item only includes the amount of money, and the currencies are taken from the declared currencies.`,
  key1002526: `Use price ratio declaration`,
  key1002527: `Use parcel`,
  key1002528: `Of`,
  key1002529: `Setting the lowest price`,
  key1002530: `Setting cap price`,
  key1002531: `After setting this option, the system will automatically convert the exchange rate according to the declared currency.`,
  key1002532: `The upload file format is wrong, the file`,
  key1002533: `Wrong format,`,
  key1002534: `Please upload`,
  key1002535: `The size must be`,
  key1002536: `Logo of operation end`,
  key1002537: `Distributor Logo`,
  key1002538: `Supplier Logo`,
  key1002539: `Operator browser icon`,
  key1002540: `Distributor browser icon`,
  key1002541: `Supplier-side browser icon`,
  key1002542: `Please select a language`,
  key1002543: `Please select a platform currency`,
  key1002544: `Please select cross-border e-commerce platform`,
  key1002545: `Image in jpg, jpeg, png format`,
  key1002546: `Picture in ico format`,
  key1002547: `A default language must be set on the distributor side`,
  key1002548: `The supplier must set a default language`,
  key1002549: `Browser icon only supports ico format`,
  key1002550: `LOGO only supports PNG / JPG / JPEG format`,
  key1002551: `Operation end configuration`,
  key1002552: `Distributor-side configuration`,
  key1002553: `Supplier-side configuration`,
  key1002554: `Complete`,
  key1002555: `Default language selection:`,
  key1002556: `Platform currency selection:`,
  key1002557: `The browser icon:`,
  key1002558: `Language selection:`,
  key1002559: `Available cross-border e-commerce platform configuration:`,
  key1002560: `Next`,
  key1002561: `welcome`,
  key1002562: `You are welcome to use the thoroughfare distributor system.`,
  key1002563: `System prompt:`,
  key1002564: `1. For the first time to enter the transit distribution system, in order to run the system smoothly, you need to configure some core content according to the actual business situation;`,
  key1002565: `2, the content of this configuration, the follow-up can be in the"`,
  key1002566: `Basic Settings-System Configuration`,
  key1002567: `"Adjustments are made in the module;`,
  key1002568: `Display in the upper left corner of the system, logo fixed display size is 210 * 22px; Limit format is PNG, JPG, JPEG;`,
  key1002569: `Top browser icon, browser top icon display, fixed display size is 16 * 16px; Limit format is ico;`,
  key1002570: `(default language)`,
  key1002571: `Set as default`,
  key1002572: `New Configuration"`,
  key1002573: `"The logistics channels,`,
  key1002574: `Binding is required.`,
  key1002575: `Logistics can be used normally. Is it bound? (`,
  key1002576: `Also available."`,
  key1002577: `Basic Logistics-Online Logistics-View Logistics Channels-Settings`,
  key1002578: `"page for binding)`,
  key1002579: `External Display-Warehouse Name`,
  key1002580: `Warehouse code`,
  key1002581: `Warehouse type`,
  key1002582: `Supply warehouse and straight hair warehouse`,
  key1002583: `Whether it is warehouse gathering`,
  key1002584: `Whether the goods can be stocked`,
  key1002585: `Shipper's address`,
  key1002586: `Country`,
  key1002587: `Supplier`,
  key1002588: `The warehouse permission has been disabled. If you need to enable it, please contact Tongtu Operation!`,
  key1002589: `Platform warehouse`,
  key1002590: `Supplier Warehouse`,
  key1002591: `Are you sure you want to deactivate this warehouse?`,
  key1002592: `Confirm to deactivate the warehouse. After deactivation, the system will automatically delete the collection/stocking relationship between the warehouse and all supplier warehouses. Please operate with caution!`,
  key1002593: `Wanyitong 3PL`,
  key1002594: `Miyun Warehouse Platform`,
  key1002595: `Logistics binding tips`,
  key1002596: `Click Bind`,
  key1002597: `Please enter warehouse name.`,
  key1002598: `Country:`,
  key1002599: `Warehouse:`,
  key1002600: `Supplier:`,
  key1002601: `Please enter vendor name/merchant number`,
  key1002602: `Image size must be`,
  key1002603: `Please upload LOGO and browser icon picture first!`,
  key1002604: `LOGO only supports PNG / JPG / JPEG`,
  key1002605: `Browser icon supports ICO only`,
  key1002606: `Logo uploaded successfully`,
  key1002607: `Browser icon uploaded successfully`,
  key1002608: `Name of reservoir area`,
  key1002609: `Code of the reservoir area to which it belongs`,
  key1002610: `Storage bin code`,
  key1002611: `Storage bin code cannot be empty.`,
  key1002612: `Add storage bin`,
  key1002613: `View location`,
  key1002614: `Edit location`,
  key1002615: `Please select the warehouse first`,
  key1002616: `Reservoir name:`,
  key1002617: `Storage bin Code:`,
  key1002618: `Storage bin Status:`,
  key1002619: `Print storage bin barcode`,
  key1002620: `Storage bin`,
  key1002621: `Import storage bin`,
  key1002622: `Hint:`,
  key1002623: `1. Support extension name:`,
  key1002624: `2. When there are exceptions in the imported data, the data import fails;`,
  key1002625: `3. After the import operation, please review the import results later in the "Import/Export Tasks - Import View" section.`,
  key1002626: `Default business type:`,
  key1002627: `Return list`,
  key1002628: `Template name`,
  key1002629: `cellphone number`,
  key1002630: `Enabled`,
  key1002631: `deactivated`,
  key1002632: `Deactivate Prompt?`,
  key1002633: `Enable Prompt?`,
  key1002634: `Are you sure you want to deactivate this template?`,
  key1002635: `Are you sure you want to enable this template?`,
  key1002636: `Please enter the template name`,
  key1002637: `Add address`,
  key1002638: `Please select at least one language`,
  key1002639: `Please set the default language`,
  key1002640: `There are ongoing inbound sorting tasks, please complete them before making any modifications.`,
  key1002641: `Inbound sorting settings`,
  key1002642: `Picking container:`,
  key1002643: `Packaging container:`,
  key1002644: `Switch Warehouse`,
  key1002645: `Bill of Lading Collection`,
  key1002646: `Process status: enabled`,
  key1002647: `Bill of lading`,
  key1002648: `Inbound sorting`,
  key1002649: `Fast outbound mode`,
  key1002650: `Label during sorting`,
  key1002651: `Product publish`,
  key1002652: `Multi product picking`,
  key1002653: `Skip this process for single item tasks`,
  key1002654: `Packaging operation`,
  key1002655: `Logistics sorting`,
  key1002656: `Shelving container`,
  key1002657: `Labeling+shelving containers`,
  key1002658: `Outbound container`,
  key1002659: `Packaging container`,
  key1002660: `Labeling+Packaging Container`,
  key1002661: `Picking container`,
  key1002662: `Sticking and picking containers`,
  key1002663: `Quantity limit for sorting container outbound orders`,
  key1002664: `We currently do not have warehouse data permissions. Please configure warehouse permissions and try again.`,
  key1002665: `Setup succeeded！`,
  key1002666: `Mall default language configuration`,
  key1002667: `Language selection:`,
  key1002668: `Template name cannot be null.`,
  key1002669: `Name cannot be empty`,
  key1002670: `Country/Region cannot be empty`,
  key1002671: `Province and state cannot be empty`,
  key1002672: `Street address cannot be empty`,
  key1002673: `Postal code cannot be empty`,
  key1002674: `Edit Address`,
  key1002675: `View address`,
  key1002676: `Name:`,
  key1002677: `Country/Region:`,
  key1002678: `Street Address 1:`,
  key1002679: `The eDIS street address is limited to 50 characters;`,
  key1002680: `Street Address 2:`,
  key1002681: `Street Address 3:`,
  key1002682: `Company Name:`,
  key1002683: `Adding time`,
  key1002684: `Order Automation Rules - Edit`,
  key1002685: `Special Declaration Rules`,
  key1002686: `Beneficiary Account Details`,
  key1002687: `Please enter the account opening bank`,
  key1002688: `Collection Account Review`,
  key1002689: `Edit Receipt Account`,
  key1002690: `bank card`,
  key1002691: `Bank card number`,
  key1002692: `Alipay`,
  key1002693: `Alipay account`,
  key1002694: `The audit was successful!`,
  key1002695: `Please enter your bank card number`,
  key1002696: `Please enter your Alipay login number`,
  key1002697: `Incorrect phone number/email format`,
  key1002698: `Please enter the name of the account holder`,
  key1002699: `Please enter the name of the account holder of this Alipay account`,
  key1002700: `Please enter ID number number`,
  key1002701: `Please enter the ID number of the account holder of this Alipay account`,
  key1002702: `Payment method:`,
  key1002703: `Account Holder Name:`,
  key1002704: `Account Name:`,
  key1002705: `Bank card number:`,
  key1002706: `ID number:`,
  key1002707: `Alipay account:`,
  key1002708: `Please enter your Alipay login number, which supports email and mobile number formats`,
  key1002709: `Account Holder ID Number:`,
  key1002710: `Original record:`,
  key1002711: `Collection Method:-`,
  key1002712: `Record after change:`,
  key1002713: `Review rejected`,
  key1002714: `Add supplier level`,
  key1002715: `Level name cannot be empty`,
  key1002716: `Grade name`,
  key1002717: `Distributor being shown`,
  key1002718: `All (including not logged in)`,
  key1002719: `View supplier rating`,
  key1002720: `Edit supplier level`,
  key1002721: `Do you want to delete the current supplier level?`,
  key1002722: `Please select a distribution level!`,
  key1002723: `Grade name:`,
  key1002724: `Distributors being shown:`,
  key1002725: `section`,
  key1002726: `Please select [jpg, jpeg, png]`,
  key1002727: `Add supplier`,
  key1002728: `Please select the business scale`,
  key1002729: `Contact person cannot be empty`,
  key1002730: `Shop name cannot be null.`,
  key1002731: `Please select a business model`,
  key1002732: `Please select the planned business category`,
  key1002733: `Please select the expected number of products to be listed`,
  key1002734: `Supplier level cannot be empty`,
  key1002735: `Less than 10 people`,
  key1002736: `10-30 people`,
  key1002737: `30-50 people`,
  key1002738: `50-100 people`,
  key1002739: `More than 100 people`,
  key1002740: `Below 10`,
  key1002741: `Above 100`,
  key1002742: `company`,
  key1002743: `Entry Review Status:`,
  key1002744: `Review status of industrial and commercial information change:`,
  key1002745: `Supplier Details`,
  key1002746: `Edit supplier information`,
  key1002747: `Audit suppliers`,
  key1002748: `Supplier industrial and commercial information change audit`,
  key1002749: `paragraph`,
  key1002750: `To be confirmed`,
  key1002751: `Business license`,
  key1002752: `Legal Representative ID Card National Emblem Face`,
  key1002753: `Identity of the Legal Representative Witness Image`,
  key1002754: `Store logo`,
  key1002755: `Please upload your business license first`,
  key1002756: `Please upload the national emblem of the legal representative's ID card first`,
  key1002757: `Please upload the photo of the legal representative as a witness first`,
  key1002758: `Please upload the store logo first`,
  key1002759: `Please select the product release frequency type first!`,
  key1002760: `Account period settlement cannot be empty!`,
  key1002761: `The number of product releases cannot be empty`,
  key1002762: `The number of product releases must be a positive integer greater than 0`,
  key1002763: `Business address cannot be empty`,
  key1002764: `Please select the complete business address of the province or city`,
  key1002765: `Please fill in the email address`,
  key1002766: `Business license:`,
  key1002767: `Legal representative's ID card:`,
  key1002768: `Business scale:`,
  key1002769: `Contact Name:`,
  key1002770: `Please fill in the contact name`,
  key1002771: `Contact phone number:`,
  key1002772: `Please fill in the contact person's phone number`,
  key1002773: `Please fill in the fixed phone number`,
  key1002774: `Store Name:`,
  key1002775: `Please fill in the store name`,
  key1002776: `Store Logo:`,
  key1002777: `Business model:`,
  key1002778: `Planned operating categories:`,
  key1002779: `Expected number of products on the shelves:`,
  key1002780: `Product release frequency:`,
  key1002781: `Please fill in the specific quantity`,
  key1002782: `Business address:`,
  key1002783: `Please fill in the detailed address`,
  key1002784: `The bill of the previous month is generated on the X day of each month, excluding the bill of the current month.`,
  key1002785: `Supplier level:`,
  key1002786: `Application time:`,
  key1002787: `Reason for rejection:`,
  key1002788: `Warehouse delivery address:`,
  key1002789: `Warehouse return address:`,
  key1002790: `Account information`,
  key1002791: `Password:`,
  key1002792: `Regenerate`,
  key1002793: `Enterprise Information`,
  key1002794: `Only JPG, JPEG, and PNG formats are supported.`,
  key1002795: `Anthropomorphic portrait`,
  key1002796: `National Emblem Face`,
  key1002797: `Store Information`,
  key1002798: `Size: 300 * 300px, only supports JPG, JPEG, and PNG formats.`,
  key1002799: `Account settlement:`,
  key1002800: `Sunrise Bill`,
  key1002801: `Payment information`,
  key1002802: `findings of audit`,
  key1002803: `Warehouse Information`,
  key1002804: `Supply target collection/stock warehouse selection:`,
  key1002805: `Supplier code`,
  key1002806: `Please enter the supplier number, which supports multiple commas or line breaks for separation`,
  key1002807: `Please enter your phone number, which supports multiple commas or line breaks for separation`,
  key1002808: `Please enter an email address that supports multiple commas or line breaks`,
  key1002809: `Certified Supplier`,
  key1002810: `Blacklist Suppliers`,
  key1002811: `Contact person`,
  key1002812: `Mobile phone`,
  key1002813: `Telephone`,
  key1002814: `Total number of SKUs`,
  key1002815: `Registration time`,
  key1002816: `down time`,
  key1002817: `Enable this supplier? After enabled, the supplier account can be used to log on to the platform.`,
  key1002818: `Name`,
  key1002819: `Submission time:`,
  key1002820: `Search characters:`,
  key1002821: `Supplier Name/Supplier Merchant ID/Contact Person/Phone/Email`,
  key1002822: `Add suppliers`,
  key1002823: `Please enter the reason for deactivation`,
  key1002824: `Reason for discontinuation:`,
  key1002825: `After deactivation, suppliers will not be able to log in to the system and perform any operations such as shipping. Please operate with caution!`,
  key1002826: `Store information details`,
  key1002827: `Please upload the store logo first`,
  key1002828: `Store information review`,
  key1002829: `Edit store information`,
  key1002830: `Store Logo uploaded successfully`,
  key1002831: `Failed to upload store logo`,
  key1002832: `Is the supplier information approved?`,
  key1002833: `Entry Review`,
  key1002834: `Business information change audit`,
  key1002835: `Business information change review rejected`,
  key1002836: `Store information change review`,
  key1002837: `Store information change review rejected`,
  key1002838: `Collection Account Change Review`,
  key1002839: `Approval of Collection Account Change Rejected`,
  key1002840: `Time rejected:`,
  key1002841: `Shop Name/Supplier Merchant Number`,
  key1002842: `Supplier Name/Supplier Merchant Number`,
  key1002843: `Through the audit`,
  key1002844: `Confirmed`,
  key1002845: `Supplier Status`,
  key1002846: `preliminary examination`,
  key1002847: `Information change`,
  key1002848: `Legal Representative Identity Card`,
  key1002849: `Scale of operation`,
  key1002850: `Contact Name`,
  key1002851: `Contact Phone Number`,
  key1002852: `Fixed phone number`,
  key1002853: `Shop Logo`,
  key1002854: `Business model`,
  key1002855: `Planned Operation Category`,
  key1002856: `Estimated number of items on shelves`,
  key1002857: `Product release frequency`,
  key1002858: `Business Address`,
  key1002859: `Address`,
  key1002860: `Payment method`,
  key1002861: `Receiving account`,
  key1002862: `Name of account holder`,
  key1002863: `Original record`,
  key1002864: `Record after change`,
  key1002865: `Submission time for review`,
  key1002866: `Rejection time`,
  key1002867: `to examine`,
  key1002868: `Please enter the reason for rejection`,
  key1002869: `Rejected successfully!`,
  key1002870: `Reject application`,
  key1002871: `Sales`,
  key1002872: `Order volume`,
  key1002873: `The time span cannot exceed one year`,
  key1002874: `Ranking`,
  key1002875: `than last month`,
  key1002876: `than last week`,
  key1002877: `Distributor business number`,
  key1002878: `Distributor name`,
  key1002879: `Statistics`,
  key1002880: `Cumulative total amount of issued orders in order status.`,
  key1002881: `Cumulative total order quantity whose order status is issued.`,
  key1002882: `The mall SKU status is the total quantity on sale.`,
  key1002883: `Calculate the total number of products subscribed by all distributors, and only calculate once for multiple distributors subscribing to the same product.`,
  key1002884: `Calculate the total number of products that have been listed on the platform by all distributors, and only calculate once for different items of the same product.`,
  key1002885: `Calculate the total number of publications published by all distributors, based on the number of items.`,
  key1002886: `Supplier Order Ranking`,
  key1002887: `Distributor Order Ranking`,
  key1002888: `Total sales revenue（`,
  key1002889: `Sales revenue for this month`,
  key1002890: `Yesterday's sales`,
  key1002891: `Today's sales`,
  key1002892: `Total number of orders (single)`,
  key1002893: `Number of orders for this month`,
  key1002894: `Yesterday's orders`,
  key1002895: `Today's orders`,
  key1002896: `Number of products on sale (SKU)`,
  key1002897: `New this month`,
  key1002898: `New from yesterday`,
  key1002899: `New today`,
  key1002900: `Product Subscriptions (SPU)`,
  key1002901: `Subscription this month`,
  key1002902: `Subscribed yesterday`,
  key1002903: `Subscribe Today`,
  key1002904: `Number of products listed (SPU)`,
  key1002905: `Number of listings this month`,
  key1002906: `Yesterday's listings`,
  key1002907: `Number of listings today`,
  key1002908: `Number of published items`,
  key1002909: `Number of publications this month`,
  key1002910: `Number of publications published yesterday`,
  key1002911: `Number of publications published today`,
  key1002912: `Total number of suppliers`,
  key1002913: `New additions this month`,
  key1002914: `Added yesterday`,
  key1002915: `New today`,
  key1002916: `Total number of distributors`,
  key1002917: `Order State`,
  key1002918: `Waiting for order`,
  key1002919: `Pending order`,
  key1002920: `To be delivered`,
  key1002921: `This week`,
  key1002922: `This month`,
  key1002923: `this year`,
  key1002924: `Product list`,
  key1002925: `Stick waybill`,
  key1002926: `Inventory Balance`,
  key1002927: `Bill of Lading List`,
  key1002928: `Outbound details`,
  key1002929: `Questionnaire statistics`,
  key1002930: `Subsidy review`,
  key1002931: `Recharge Record`,
  key1002932: `Supplier Total Bill`,
  key1002933: `Supplier Detailed Bill`,
  key1002934: `Supplier orders`,
  key1002935: `Item attribute pool`,
  key1002936: `Logistics billing`,
  key1002937: `Warehouse bill`,
  key1002938: `Inventory details`,
  key1002939: `Category Mapping`,
  key1002940: `Import Real Weight`,
  key1002941: `Self-operated products`,
  key1002942: `draft`,
  key1002943: `To be modified`,
  key1002944: `Pending review`,
  key1002945: `Waiting to send`,
  key1002946: `has been sent`,
  key1002947: `Announcement Name`,
  key1002948: `send status`,
  key1002949: `Notification object`,
  key1002950: `Send time`,
  key1002951: `(Reservation)`,
  key1002952: `Reviewer`,
  key1002953: `Approval prompt`,
  key1002954: `After passing the review, the system will send an announcement at the specified time. Please confirm if the review has been approved?`,
  key1002955: `Delete announcement prompt`,
  key1002956: `The announcement cannot be restored after deletion. Are you sure you want to delete it?`,
  key1002957: `Deletion succeeded！`,
  key1002958: `Cancel sending`,
  key1002959: `Cancel sending prompt`,
  key1002960: `After cancellation, this announcement will be circulated as a draft. Are you sure you want to cancel sending?`,
  key1002961: `Notify to:`,
  key1002962: `Founder：`,
  key1002963: `Sent:`,
  key1002964: `Create Announcement`,
  key1002965: `Questionnaire Name`,
  key1002966: `Questionnaire status`,
  key1002967: `Paused`,
  key1002968: `Answering questions`,
  key1002969: `View volume`,
  key1002970: `Recovery rate`,
  key1002971: `Final modification time`,
  key1002972: `Cannot answer questions after discontinuation`,
  key1002973: `After discontinuation, questionnaire answering will be paused. Are you sure to discontinue?`,
  key1002974: `Create a new questionnaire`,
  key1002975: `text`,
  key1002976: `pop-up notification`,
  key1002977: `Do not display the 'skip' button`,
  key1002978: `Display the 'Skip' button`,
  key1002979: `First login`,
  key1002980: `option`,
  key1002981: `Other____`,
  key1002982: `Do you want to save the questionnaire content`,
  key1002983: `Do you need to save an unsaved questionnaire?`,
  key1002984: `Do not save`,
  key1002985: `New successfully!`,
  key1002986: `The title of the question cannot be empty!`,
  key1002987: `The title of the question cannot be duplicate!`,
  key1002988: `Questionnaire Title`,
  key1002989: `Questionnaire Description`,
  key1002990: `Please enter the title of the question`,
  key1002991: `Please enter an option`,
  key1002992: `Delivery channels`,
  key1002993: `Display method`,
  key1002994: `Trigger Event`,
  key1002995: `Select question type`,
  key1002996: `Optional`,
  key1002997: `Add Options`,
  key1002998: `Add Other`,
  key1002999: `Questionnaire settings`,
  key1003000: `PDF file`,
  key1003001: `Online Content`,
  key1003002: `Guidance Title`,
  key1003003: `Module`,
  key1003004: `Guidance type`,
  key1003005: `Sort`,
  key1003006: `Deactivate reminder`,
  key1003007: `After deactivation, users will not be able to view the tutorial,`,
  key1003008: `Are you sure you want to deactivate it?`,
  key1003009: `Delete Reminder`,
  key1003010: `You are about to permanently delete, and after deletion, you will not be able to recover,`,
  key1003011: `Are you sure you want to delete it?`,
  key1003012: `New Guidelines`,
  key1003013: `Are you sure to delete [`,
  key1003014: `】Classification?`,
  key1003015: `Title`,
  key1003016: `Release date`,
  key1003017: `Last updated date`,
  key1003018: `display status`,
  key1003019: `On`,
  key1003020: `Off`,
  key1003021: `Home Page Recommendation`,
  key1003022: `Add directory`,
  key1003023: `Article title cannot be empty`,
  key1003024: `catalogue`,
  key1003025: `The homepage can recommend up to 5 help documents. Please close other recommendations before opening them!`,
  key1003026: `Are you sure you want to delete the current article?`,
  key1003027: `edit directory`,
  key1003028: `The catalog classification can only have three hierarchical relationships at most, and only the same-level drag sorting is allowed!`,
  key1003029: `Content`,
  key1003030: `Directory Name`,
  key1003031: `Content title:`,
  key1003032: `Please enter a content title`,
  key1003033: `Text content:`,
  key1003034: `Sort By:`,
  key1003035: `Display status:`,
  key1003036: `Copy article title`,
  key1003037: `Up to 28 Chinese characters can be entered`,
  key1003038: `The bigger the number, the further back`,
  key1003039: `add content`,
  key1003040: `Please configure the module and then select Open Display`,
  key1003041: `Document Type`,
  key1003042: `Content Type`,
  key1003043: `Show at Help Center`,
  key1003044: `The corresponding directory is hidden, please unhide it.`,
  key1003045: `Display at the module`,
  key1003046: `Are you sure you want to copy the current article?`,
  key1003047: `Hidden`,
  key1003048: `(hidden)`,
  key1003049: `Document Type:`,
  key1003050: `Open image on new tab`,
  key1003051: `1: 1 Display image`,
  key1003052: `Mouse wheel zoom image`,
  key1003053: `The guide title cannot be empty`,
  key1003054: `The module to which it belongs cannot be empty`,
  key1003055: `Display position cannot be empty`,
  key1003056: `Editing Guidelines`,
  key1003057: `Successfully uploaded the file`,
  key1003058: `Please upload the PDF file first!`,
  key1003059: `The body content cannot be empty!`,
  key1003060: `Guidance Title:`,
  key1003061: `Please enter the guide title`,
  key1003062: `Module:`,
  key1003063: `Display location:`,
  key1003064: `Guidance type:`,
  key1003065: `1. Only files with PDF extensions are supported.`,
  key1003066: `2. The file size should not exceed 10Mb.`,
  key1003067: `Please enter the announcement name`,
  key1003068: `Please select the notification object`,
  key1003069: `Edit Announcement`,
  key1003070: `Successfully submitted for review`,
  key1003071: `Please enter the main text content`,
  key1003072: `Please select the sending time`,
  key1003073: `Announcement Name:`,
  key1003074: `If the sending time has exceeded when the review is passed, the announcement will be sent immediately after the review is passed.`,
  key1003075: `Save as Draft`,
  key1003076: `Submit for review`,
  key1003077: `Please check the data that needs to be exported first!`,
  key1003078: `There is currently no data available for the current filtering results, unable to export!`,
  key1003079: `Merchant ID`,
  key1003080: `Starting time for answering questions`,
  key1003081: `End Answer Time`,
  key1003082: `Export Data`,
  key1003083: `Export by Selection`,
  key1003084: `Export according to query results`,
  key1003085: `Edit Content`,
  key1003086: `Content Chinese title:`,
  key1003087: `Content English Title:`,
  key1003088: `Click to enter the Chinese title of the content.`,
  key1003089: `Click to enter content English title`,
  key1003090: `Chinese title cannot be empty`,
  key1003091: `Please upload Chinese PDF`,
  key1003092: `Chinese content cannot be empty`,
  key1003093: `You can choose whether to configure this item. If not, the document can be displayed only in the help center corresponding to the platform.`,
  key1003094: `Display at the module:`,
  key1003095: `Content Type:`,
  key1003096: `Show at Help Center:`,
  key1003097: `Customer level cannot be empty`,
  key1003098: `Customer Name:`,
  key1003099: `Contact person:`,
  key1003100: `Phone number:`,
  key1003101: `Please enter your cell phone number.`,
  key1003102: `Customer Currency:`,
  key1003103: `Business Type:`,
  key1003104: `Customer level:`,
  key1003105: `Warehouse permissions:`,
  key1003106: `Customer Type:`,
  key1003107: `Distribution customers`,
  key1003108: `Ali International Distribution`,
  key1003109: `Total number of clicks`,
  key1003110: `Total number of registrations`,
  key1003111: `Registration conversion rate`,
  key1003112: `Please fill in the link name`,
  key1003113: `Time sharing data`,
  key1003114: `Number of clicks`,
  key1003115: `Number of registrations`,
  key1003116: `Link Details`,
  key1003117: `Link Name:`,
  key1003118: `Source channel:`,
  key1003119: `Promoter:`,
  key1003120: `Promotion method:`,
  key1003121: `Promotion content:`,
  key1003122: `Promotion group:`,
  key1003123: `Notes`,
  key1003124: `Link Basic Information`,
  key1003125: `link data`,
  key1003126: `Please fill in the link address`,
  key1003127: `Created successfully!`,
  key1003128: `create link`,
  key1003129: `Contact records`,
  key1003130: `Activate product records`,
  key1003131: `log information`,
  key1003132: `Please contact the customer to improve the customer currency!`,
  key1003133: `Primary Contact`,
  key1003134: `is not a valid mailbox or mailbox format is incorrect!`,
  key1003135: `Information to fill in at least one of them!`,
  key1003136: `Customer details`,
  key1003137: `Customer Information`,
  key1003138: `Number:`,
  key1003139: `Customer Source:`,
  key1003140: `Related merchants:`,
  key1003141: `Customer Responsible Person:`,
  key1003142: `Please fill in the remarks`,
  key1003143: `Balance:`,
  key1003144: `Withholding amount:`,
  key1003145: `Credit limit:`,
  key1003146: `Used amount:`,
  key1003147: `Input Name`,
  key1003148: `Title:`,
  key1003149: `Please enter a job title`,
  key1003150: `Please enter email.`,
  key1003151: `Please enter a fixed phone number`,
  key1003152: `Micro signal:`,
  key1003153: `Please input micro signal`,
  key1003154: `QQ number:`,
  key1003155: `Please enter the micro QQ number`,
  key1003156: `Customer Journey`,
  key1003157: `Next contact time:`,
  key1003158: `Operator:`,
  key1003159: `Basic customer information`,
  key1003160: `Customer Financial Information`,
  key1003161: `Customer warehouse permissions`,
  key1003162: `Customer API permissions`,
  key1003163: `Add Contact`,
  key1003164: `Set as Primary Contact`,
  key1003165: `There is currently no travel data available`,
  key1003166: `Group Name`,
  key1003167: ` Number of grouped customers`,
  key1003168: `Group Notes`,
  key1003169: `Delete grouping prompt`,
  key1003170: `Operation is in progress to delete the group. Are you sure you want to delete it?`,
  key1003171: `Delete Group`,
  key1003172: `Create Group`,
  key1003173: `Customer number`,
  key1003174: `Please enter the customer number, which supports multiple commas or line breaks for separation`,
  key1003175: `Are you sure to enable it?`,
  key1003176: `Are you sure to deactivate?`,
  key1003177: `Only customers awaiting review can proceed with the review. Please reselect!`,
  key1003178: `Please check the data to be reviewed first`,
  key1003179: `Ungrouped`,
  key1003180: `Customer Name`,
  key1003181: `Customer grouping`,
  key1003182: `Customer label`,
  key1003183: `Customer level`,
  key1003184: `Business Type`,
  key1003185: `Customer Currency`,
  key1003186: `balance`,
  key1003187: `Withholding amount`,
  key1003188: `Credit Line`,
  key1003189: `Used quota`,
  key1003190: `Registration Source`,
  key1003191: `Customer remarks`,
  key1003192: `Please select a customer first`,
  key1003193: `Registration time:`,
  key1003194: `Registration source:`,
  key1003195: `Please select the registration source`,
  key1003196: `Customer label:`,
  key1003197: `Please select the customer label`,
  key1003198: `Please select customer level`,
  key1003199: `Customer Name/Customer Number/Contact Person/Phone/Email/Remarks`,
  key1003200: `Customer Number:`,
  key1003201: ` log information`,
  key1003202: `New customers`,
  key1003203: `Mobile grouping`,
  key1003204: `Bulk review`,
  key1003205: `Please fill in the label name`,
  key1003206: `create label`,
  key1003207: `Edit Label`,
  key1003208: `Label Name:`,
  key1003209: `Please enter a label name`,
  key1003210: `Label remarks:`,
  key1003211: `Please select a group`,
  key1003212: `Specify grouping:`,
  key1003213: `There is a deletion of the group in this operation. Please regroup the customers under the group`,
  key1003214: `Tongtool merchant account cannot be empty`,
  key1003215: `View Customers`,
  key1003216: `Non Transit Customers`,
  key1003217: `Transit customers`,
  key1003218: `Label Name`,
  key1003219: `Number of labeled customers`,
  key1003220: `Label remarks`,
  key1003221: `Delete label prompt`,
  key1003222: `After deleting the label, it will be synchronously removed from the customer. Are you sure you want to delete it?`,
  key1003223: `Label Details`,
  key1003224: `Basic information of labels`,
  key1003225: `Label type:`,
  key1003226: `Label data`,
  key1003227: `Link Name`,
  key1003228: `Link Type`,
  key1003229: `View QR code`,
  key1003230: `Copy Link`,
  key1003231: `Statistical time:`,
  key1003232: `Search Link Name`,
  key1003233: `Please select a label type`,
  key1003234: `Search Tag Name`,
  key1003235: `Please fill in the group name`,
  key1003236: `Enter up to 20 characters`,
  key1003237: `Edit Group`,
  key1003238: `Group name:`,
  key1003239: `Please enter a group name`,
  key1003240: `Group remarks:`,
  key1003241: `Add customer level`,
  key1003242: `Rank`,
  key1003243: `View customer level`,
  key1003244: `Edit customer level`,
  key1003245: `Do you want to delete the current customer level?`,
  key1003246: `Tier Discount Factor`,
  key1003247: `Default level when registering`,
  key1003248: `Default`,
  key1003249: `Change registration default level`,
  key1003250: `The current operation will affect the default level when registering mall customers. Are you sure to change the default level?`,
  key1003251: `The level discount coefficient cannot be empty`,
  key1003252: `The level discount factor must be greater than 0 and less than or equal to 1`,
  key1003253: `Tier discount factor:`,
  key1003254: `Set successfully`,
  key1003255: `Unit conversion`,
  key1003256: `Platform attribute unit`,
  key1003257: `number`,
  key1003258: `Specifications/General Properties`,
  key1003259: `Size attribute`,
  key1003260: `Specification/General Properties (Specification, General)`,
  key1003261: `Whether to customize (Yes, No)`,
  key1003262: `Attribute value single/multiple selection (multiple, single selection)`,
  key1003263: `Size attribute (Yes, No)`,
  key1003264: `Filling requirements (mandatory, non mandatory, recommended)`,
  key1003265: `Attribute information`,
  key1003266: `Chinese Simplified`,
  key1003267: `French`,
  key1003268: `German`,
  key1003269: `Spanish`,
  key1003270: `Dutch`,
  key1003271: `Polish`,
  key1003272: `Portuguese`,
  key1003273: `Italian`,
  key1003274: `Attribute Status`,
  key1003275: `Property value/unit information`,
  key1003276: `Attribute deletion prompt`,
  key1003277: `There is a deletion of attributes in this modification. After deletion, the attribute field in the existing product information will be deleted as well. Are you sure you want to save this modification?`,
  key1003278: `After deactivating the attribute, when suppliers publish new products and modify published products, this attribute will not be available. Are you sure you want to deactivate it?`,
  key1003279: `Immediately deactivate`,
  key1003280: `Property name:`,
  key1003281: `Please enter the attribute name, supporting multilingual search`,
  key1003282: `Whether to customize:`,
  key1003283: `Single/Multiple Choice:`,
  key1003284: `Import item attribute`,
  key1003285: `Export Properties`,
  key1003286: `2. When there is an abnormality in the imported data, the data import fails.`,
  key1003287: `No log content`,
  key1003288: `New value:`,
  key1003289: `No operation log`,
  key1003290: `Body part`,
  key1003291: `Unit`,
  key1003292: `Do you want to delete the current size template?`,
  key1003293: `Add Template`,
  key1003294: `Label commodity quantity`,
  key1003295: `Tag name cannot be empty`,
  key1003296: `Tag`,
  key1003297: `After deleting the label, the label will be removed from the product simultaneously. Please confirm whether to delete it?`,
  key1003298: `Central warehouse wholesale price (`,
  key1003299: `Supplier Warehouse Direct Price (`,
  key1003300: `Supplier warehouse straight hair`,
  key1003301: `Supplier warehouse direct wholesale price (`,
  key1003302: `Supplier Information`,
  key1003303: `Product classification`,
  key1003304: `Product label`,
  key1003305: `Please enter the supplier SKU, support multiple separated by line`,
  key1003306: `Export in SPU dimension`,
  key1003307: `(One row per SPU in the report)`,
  key1003308: `Export as SKU dimension`,
  key1003309: `(One row per SKU in the report)`,
  key1003310: `minimum value`,
  key1003311: `Maximum value`,
  key1003312: `Supply warehouse storage`,
  key1003313: `Straight hair warehouse storage`,
  key1003314: `Not deleted`,
  key1003315: `Product listing time`,
  key1003316: `Delete time`,
  key1003317: `Sales status`,
  key1003318: `Last listing time`,
  key1003319: `Recently discontinued`,
  key1003320: `First submission for review time`,
  key1003321: `First listing time`,
  key1003322: `Supply price (including multiple countries)`,
  key1003323: `Central warehouse sales price (including multiple countries)`,
  key1003324: `Central warehouse wholesale price (including multiple countries)`,
  key1003325: `Supplier Warehouse Direct Price`,
  key1003326: `Supplier Straight Sales Price`,
  key1003327: `Supplier Warehouse Wholesale Price`,
  key1003328: `Commodity Type`,
  key1003329: `Stock in supply warehouse`,
  key1003330: `Retail price for central warehouse (including multiple countries)`,
  key1003331: `Supplier Retail Price for Straight Hair (Including Multiple Countries)`,
  key1003332: `Query in...`,
  key1003333: `Please check the data that needs to be stopped first!`,
  key1003334: `The current screening results have no data for the time being and cannot be operated to stop selling!`,
  key1003335: `The minimum inventory value cannot be greater than the maximum value. Please modify the conditions before querying.`,
  key1003336: `Please select goods first`,
  key1003337: `View SKU`,
  key1003338: `View central warehouse inventory`,
  key1003339: `View supplier inventory`,
  key1003340: `1688 Find the same model`,
  key1003341: `Change the country/region of sale of the product`,
  key1003342: `Please enter a Chinese title, support multiple lines separated`,
  key1003343: `supplier：`,
  key1003344: `Commodity Type:`,
  key1003345: `Commodity label:`,
  key1003346: `Please select product label`,
  key1003347: `Supplier deleted:`,
  key1003348: `Country of delivery warehouse:`,
  key1003349: `Type of delivery warehouse:`,
  key1003350: `Export Product List`,
  key1003351: `Number of SKUs (`,
  key1003352: `Supplier Name:`,
  key1003353: `Supplier Merchant Number:`,
  key1003354: ` (Supplier Straight Hair Warehouse)`,
  key1003355: ` (Central Warehouse)`,
  key1003356: `Straight hair warehouse:`,
  key1003357: `Central warehouse:`,
  key1003358: `Supply warehouse:`,
  key1003359: `View all (`,
  key1003360: `Bulk Discontinuation`,
  key1003361: `Stop by Select`,
  key1003362: `Stop selling according to query results`,
  key1003363: `Warehousing and prices`,
  key1003364: `Deselect`,
  key1003365: `Sales price`,
  key1003366: `Export platform self-operated goods`,
  key1003367: `Inventory:`,
  key1003368: `Add platform`,
  key1003369: `Platform cannot be empty`,
  key1003370: `Site cannot be null`,
  key1003371: `Platform attributes`,
  key1003372: `Platform Attribute Value Type`,
  key1003373: `Editing Platform`,
  key1003374: `View Platform`,
  key1003375: `(Mapped)`,
  key1003376: `Product Type cannot be empty`,
  key1003377: `FamiltType cannot be empty`,
  key1003378: `Custom values`,
  key1003379: `Start matching`,
  key1003380: `Matching...`,
  key1003381: `Matching data acquisition completed`,
  key1003382: `Data matching`,
  key1003383: `Interface request error, which may result in incomplete data matching`,
  key1003384: `Name data matching`,
  key1003385: `Category cannot be empty`,
  key1003386: `1. Choose a platform`,
  key1003387: `2. Select a site`,
  key1003388: `4. Select Product Type`,
  key1003389: `4. 选择Family Type`,
  key1003390: `5. Product Specification Mapping`,
  key1003391: `6. Product Attribute Mapping`,
  key1003392: `Change of platform attribute, original value:`,
  key1003393: `Select Site`,
  key1003394: `Product Specification Mapping`,
  key1003395: `Attribute:`,
  key1003396: `Mapped:`,
  key1003397: `To be mapped:`,
  key1003398: `Attribute value:`,
  key1003399: `Attribute value mapped:`,
  key1003400: `Attribute values to be mapped:`,
  key1003401: `Automatic matching`,
  key1003402: `Matching in progress, please wait`,
  key1003403: `Automatic matching completed, matched attributes:`,
  key1003404: `Matched attribute values:`,
  key1003405: `See more optional values`,
  key1003406: `No data`,
  key1003407: `Product Attribute Mapping`,
  key1003408: `Associated properties:`,
  key1003409: `Ladder sales price hierarchical value cannot be empty!`,
  key1003410: `commodity price allocation`,
  key1003411: `Supply price cannot be empty`,
  key1003412: `commodity wholesale price`,
  key1003413: `Matching Platform Sales Price Rules`,
  key1003414: `Matching platform sales price rules will overwrite the current sales price of goods, please confirm whether to match?`,
  key1003415: `Match successfully`,
  key1003416: `Ladder sales price`,
  key1003417: `Custom attribute values`,
  key1003418: `Searching`,
  key1003419: `Enter text to search`,
  key1003420: `Platform label attributes`,
  key1003421: `Mapping attributes`,
  key1003422: `Rules for generating Listing keywords`,
  key1003423: `Random`,
  key1003424: `Not choose`,
  key1003425: `Switching Product Type will clear the list data`,
  key1003426: `Please select Product Type first`,
  key1003427: `Platform attributes cannot be repeated`,
  key1003428: `No platform category found`,
  key1003429: `Platform mapping table`,
  key1003430: `eCommerce platform:`,
  key1003431: `Site name:`,
  key1003432: `Category name:`,
  key1003433: `Charge for mark-up:`,
  key1003434: `Service charge:`,
  key1003435: `wholesale markup charge:`,
  key1003436: `Wholesale service charge:`,
  key1003437: `The supply price of goods:`,
  key1003438: `The amount of the goods after the price increase:`,
  key1003439: `Product, Action Object (select at least one)`,
  key1003440: `Fixed amount:`,
  key1003441: `Supplier Item Number/SPU`,
  key1003442: `Classification`,
  key1003443: `Chinese Name`,
  key1003444: `Supplier Merchant No./Name`,
  key1003445: `Approval Status`,
  key1003446: `Please check the data that needs batch review!`,
  key1003447: `In review...`,
  key1003448: `Review successful!`,
  key1003449: `Please check the data to be rejected in batches first!`,
  key1003450: `Bulk reject`,
  key1003451: `Unlimited`,
  key1003452: `5 stars`,
  key1003453: `4.5-5.0 stars`,
  key1003454: `4-4.5 stars`,
  key1003455: `Below 4 stars`,
  key1003456: `Certified factory`,
  key1003457: `Same day shipment`,
  key1003458: `24-hour shipping`,
  key1003459: `48 hour shipping`,
  key1003460: `7 days without reason`,
  key1003461: `drop shipping`,
  key1003462: `Support free shipping`,
  key1003463: `at price`,
  key1003464: `Monthly sales volume`,
  key1003465: `The price starting range cannot be greater than the price ending range`,
  key1003466: `Price range (CNY):`,
  key1003467: `Comprehensive score:`,
  key1003468: `24-hour collection rate:`,
  key1003469: `48 hour recovery rate:`,
  key1003470: `Search keywords:`,
  key1003471: ` rise`,
  key1003472: `Starting batch`,
  key1003473: `minute`,
  key1003474: `Transactions in the past 30 days:`,
  key1003475: `The Chinese name of the body part in the same column cannot be repeated!`,
  key1003476: `Body part 1`,
  key1003477: `English name`,
  key1003478: ` Dutch name`,
  key1003479: `The multilingual names of the body part in the same list must be filled in completely or all blanks!`,
  key1003480: `The unit name cannot be empty!`,
  key1003481: `Successfully added a template!`,
  key1003482: `Successfully updated the template!`,
  key1003483: `Move upward`,
  key1003484: `Move down`,
  key1003485: `You cannot select duplicate unit values!`,
  key1003486: `The Chinese name cannot be empty!`,
  key1003487: `Size chart template name`,
  key1003488: `Add body part`,
  key1003489: `New unit`,
  key1003490: `Only one of the product specifications can be a size attribute!`,
  key1003491: `Please select attribute pool data first!`,
  key1003492: `Property pool management`,
  key1003493: `Please enter the Chinese name of the attribute`,
  key1003494: `Please confirm`,
  key1003495: `Is this platform available?`,
  key1003496: `Total number of products:`,
  key1003497: `Are you sure to delete this content?`,
  key1003498: `HS code cannot be empty`,
  key1003499: `The Chinese customs declaration name cannot be empty`,
  key1003500: `The English customs declaration name cannot be empty`,
  key1003501: `The size chart template cannot be empty`,
  key1003502: `Site`,
  key1003503: `modify`,
  key1003504: `Whether to update the generation rules of other item attributes for Listing keywords to the current generation rules`,
  key1003505: `synchronization`,
  key1003506: `Chinese name of customized part`,
  key1003507: `Main attribute settings`,
  key1003508: `Main attribute`,
  key1003509: `Set as primary attribute`,
  key1003510: `Can only drag at the same level`,
  key1003511: `Please set the main attribute of the product specification first!`,
  key1003512: `Do you want to delete the current category?`,
  key1003513: `Cannot contain - > special characters`,
  key1003514: `the file format is incorrect. only xls and xlsx files can be uploaded.`,
  key1003515: `Goods that support customization already exist under the classification. You cannot set the classification to not allow customization.`,
  key1003516: `Enter keyword search`,
  key1003517: `Category ID:`,
  key1003518: `The parent category has been configured not to be displayed, and this category is not displayed in the mall.`,
  key1003519: `HS code:`,
  key1003520: `Chinese declaration name:`,
  key1003521: `English declaration name:`,
  key1003522: `Size Chart Template:`,
  key1003523: `Edit failure prompt`,
  key1003524: `Add subcategory`,
  key1003525: `Import Mapping`,
  key1003526: `Classification information`,
  key1003527: `Mall display configuration:`,
  key1003528: `Don't show`,
  key1003529: `Platform Information`,
  key1003530: `Customs declaration information`,
  key1003531: `Customized parts of goods`,
  key1003532: `Whether such goods can be customized:`,
  key1003533: `Added customized parts`,
  key1003534: `The name of the original custom part you edited is`,
  key1003535: `The part of the, because the product has been set to use, disable/edit the name failed.`,
  key1003536: `Do you want to ignore the modified content of the above customized part and save other edited content?`,
  key1003537: `Print waybill`,
  key1003538: `Edit custom parts`,
  key1003539: `View customized parts`,
  key1003540: `Location Status:`,
  key1003541: `In operation, the rules cannot be adjusted (`,
  key1003542: `The SPU of the commodity is:`,
  key1003543: `The SKU of the item is:`,
  key1003544: `The classification of goods is:`,
  key1003545: `The place of shipment of the goods is:`,
  key1003546: `, and the delivery warehouse is:`,
  key1003547: `The delivery warehouse is:`,
  key1003548: `The suppliers of the goods are:`,
  key1003549: `The level of distributor for the purchase of goods is:`,
  key1003550: `The distributors who purchase the goods are:`,
  key1003551: `After clicking OK, the system will use the current rule to calculate the sales price of the goods,`,
  key1003552: `And replace the previous sales price of the goods.`,
  key1003553: `(including manual modification), do you want to confirm the implementation?`,
  key1003554: `Commodity mark-up configuration`,
  key1003555: `Commodity platform service fee configuration`,
  key1003556: `Public Configuration`,
  key1003557: `Special configuration`,
  key1003558: `Commodity markup configuration rules`,
  key1003559: `Commodity Service Fee Allocation Rules`,
  key1003560: `Final Modifier`,
  key1003561: `New Public Rule`,
  key1003562: `New Special Rule`,
  key1003563: `Completed`,
  key1003564: `Stopped`,
  key1003565: `Commodity markup amount calculation matches "special rules" first, if not matched, then public rules are matched; if neither is matched, commodity markup amount = 0;`,
  key1003566: `The commodity platform service fee calculation matches the "special rule" first, if it is not matched, then the public rule is matched: if neither is matched, the commodity platform service fee = 0;`,
  key1003567: `Enable Prompt`,
  key1003568: `Are you sure you want to enable this rule?`,
  key1003569: `Are you sure you want to deactivate this rule?`,
  key1003570: `Are you sure you want to delete this rule? Data cannot be recovered after deletion. Please operate with caution!`,
  key1003571: `<span class = "themeColor"> All products on the platform </span>`,
  key1003572: `Retail markup amount`,
  key1003573: `Commodity retail service fee`,
  key1003574: `Commodity wholesale mark-up amount`,
  key1003575: `Commodity wholesale service fee`,
  key1003576: `the supply price of goods`,
  key1003577: `The amount of the goods after the price increase.`,
  key1003578: `Merchandise markup amount`,
  key1003579: `Commodity service fee`,
  key1003580: `Rule execution confirmation`,
  key1003581: `After the "rule execution" operation, the system will automatically run the task, and the sales price of the commodity will be calculated according to the latest "price increase rule" and "service fee rule". the rule cannot be adjusted during the task running process, and can only be viewed.`,
  key1003582: `Rule content:`,
  key1003583: `For example: in the rule, the distributor merchant number, the supplier merchant number, the classification name, the name of the goods were shipped, etc.`,
  key1003584: `Last updated sales price:`,
  key1003585: `Commodity sales price = commodity supply price commodity markup amount commodity service fee;`,
  key1003586: `Commodity sales price rule calculation task:`,
  key1003587: `Stop`,
  key1003588: `Rule Execution`,
  key1003589: `Please enter the payment password`,
  key1003590: `Bill payment confirmation`,
  key1003591: `Payment password:`,
  key1003592: `Check whether the bill is correct, and confirm that the payment will be directly transferred to the supplier's account through Alipay after the payment is made. Please operate carefully.`,
  key1003593: `Billing cycle:`,
  key1003594: `Bill generation time:`,
  key1003595: `Total profit:`,
  key1003596: `Total income:`,
  key1003597: `Total expenditure:`,
  key1003598: `Business Document Number`,
  key1003599: `Order Amount`,
  key1003600: `Commodity Cost/Vendor Settlement Amount`,
  key1003601: `Order profit`,
  key1003602: `Please enter the distributor's merchant account number`,
  key1003603: `Please enter Supplier Merchant Number`,
  key1003604: `Business Doc No:`,
  key1003605: `Please enter the business document number`,
  key1003606: `Total `,
  key1003607: ` Item Data`,
  key1003608: `Total profit amount:`,
  key1003609: `Total Order Amount:`,
  key1003610: `Bill Details`,
  key1003611: `Order Currency`,
  key1003612: `Bill number`,
  key1003613: `Billing cycle`,
  key1003614: `Customer merchant number`,
  key1003615: `Monthly cumulative recharge amount`,
  key1003616: `Alipay recharge amount`,
  key1003617: `Manual recharge amount`,
  key1003618: `Accumulated consumption amount`,
  key1003619: `Bill generation time`,
  key1003620: `Billing Information`,
  key1003621: `Merchant`,
  key1003622: `Bill to which it belongs`,
  key1003623: `Recharge serial number`,
  key1003624: `Third party transaction number`,
  key1003625: `Recharge amount`,
  key1003626: `Payment Mode`,
  key1003627: `Recharge success time`,
  key1003628: `Consumption records`,
  key1003629: `Third-party waybill number`,
  key1003630: `Number or item`,
  key1003631: `Logistics weight (g)`,
  key1003632: `Product amount`,
  key1003633: `prepaid logistics fee`,
  key1003634: `Pay-as-you-go logistics fee`,
  key1003635: `Prepaid parcel handling fee`,
  key1003636: `Paid package handling fee`,
  key1003637: `Return logistics fee (CNY)`,
  key1003638: `Remote Delivery Fee (CNY)`,
  key1003639: `Secondary Dispatch (CNY)`,
  key1003640: `Logistics Scrap Fee (CNY)`,
  key1003641: `Order completion time`,
  key1003642: `Domestic express delivery fee`,
  key1003643: `Customs clearance fee`,
  key1003644: `Billing dimension`,
  key1003645: `Detail dimension`,
  key1003646: `Customer Bill Update Prompt`,
  key1003647: `The billing data is being updated. Please wait and prompt you to view it after the update is completed.`,
  key1003648: `Time of the bill:`,
  key1003649: `Customer Merchant Number:`,
  key1003650: `Please enter the customer's merchant number`,
  key1003651: `Export customer bills`,
  key1003652: `Own logistics expenses`,
  key1003653: `Settlement amount of goods`,
  key1003654: `Subtotal of goods amount`,
  key1003655: `types of fee`,
  key1003656: `Quantity of goods`,
  key1003657: `Accumulated sales of SPU in the past 30 days`,
  key1003658: `Bill of lading number`,
  key1003659: `End packing time`,
  key1003660: `Collection time`,
  key1003661: `Order delivery time`,
  key1003662: `Delivery time on Yunmai Network`,
  key1003663: `Order Creation Time`,
  key1003664: `Supplier bill number:`,
  key1003665: `Bill settlement status:`,
  key1003666: `Bill status update time:`,
  key1003667: `Bill amount:`,
  key1003668: `Amount of goods (payable):`,
  key1003669: `Domestic logistics costs (A/R):`,
  key1003670: `Subsidy amount (payable):`,
  key1003671: `Own logistics expenses (payable):`,
  key1003672: `Order processing fee (payable):`,
  key1003673: `Product price`,
  key1003674: `Domestic logistics costs`,
  key1003675: `Subsidy amount`,
  key1003676: `Bill review confirmation`,
  key1003677: `Has the bill been reviewed and confirmed to be correct? After confirmation, it will become available for payment.`,
  key1003678: `Audit confirmation`,
  key1003679: `Confirmation of offline payment for bills`,
  key1003680: `Please confirm if offline payment has been made.`,
  key1003681: `Confirm offline payment made`,
  key1003682: `Domestic logistics costs are payable by suppliers, and goods amount, subsidy amount, own logistics costs and order processing fees are receivable by suppliers. Please pay attention to the calculation.`,
  key1003683: `Charge Details`,
  key1003684: `Offline payment made`,
  key1003685: `Bill number:`,
  key1003686: `Bill update time:`,
  key1003687: `Customer paid logistics fees:`,
  key1003688: `Payable logistics fees:`,
  key1003689: `Other payable expenses:`,
  key1003690: `Total cost:`,
  key1003691: `Document number`,
  key1003692: `Document Status`,
  key1003693: `Outbound`,
  key1003694: `Collected`,
  key1003695: `Sorted`,
  key1003696: `closed`,
  key1003697: `System calculates logistics weight (g)`,
  key1003698: `Carrier's waybill number`,
  key1003699: `Logistics actual weight (g)`,
  key1003700: `Customer paid logistics fees`,
  key1003701: `Payable logistics fees`,
  key1003702: `Unreconciled`,
  key1003703: `Payable other expenses`,
  key1003704: `Total cost`,
  key1003705: `Profit and loss`,
  key1003706: `Delivery time of package`,
  key1003707: `Reconciliation data source`,
  key1003708: `Import bills`,
  key1003709: `Payable logistics fees cannot be empty`,
  key1003710: `Notes cannot be null.`,
  key1003711: `Bill confirmation settlement`,
  key1003712: `We are currently processing bill settlement and will no longer be able to modify the bill after settlement. Please confirm whether to settle?`,
  key1003713: `Settlement successful!`,
  key1003714: `Currency modification successful!`,
  key1003715: `Payable Other Expenses:`,
  key1003716: `Logistics actual weight (g):`,
  key1003717: `Unreconciled order quantity:`,
  key1003718: `Logistics provider currency:`,
  key1003719: `Only look at loss making orders`,
  key1003720: `Only view unreconciled orders`,
  key1003721: `Profit and loss (current filtering criteria):`,
  key1003722: `In operation`,
  key1003723: `Operation failed`,
  key1003724: `serial number`,
  key1003725: `Third party voucher number`,
  key1003726: `Third party vouchers`,
  key1003727: `Operation amount`,
  key1003728: `Balance before operation`,
  key1003729: `Balance after operation`,
  key1003730: `Available credit before operation`,
  key1003731: `Available credit after operation`,
  key1003732: `Operational Status`,
  key1003733: `Recharge status`,
  key1003734: `Pre-operation credit limit`,
  key1003735: `Post-operation credit limit`,
  key1003736: `Distributor account number:`,
  key1003737: `Top-up time:`,
  key1003738: `Operational status:`,
  key1003739: `serial number:`,
  key1003740: `Please enter the serial number, multiple numbers can be separated by lines`,
  key1003741: `Export recharge records`,
  key1003742: `Recharge`,
  key1003743: `Deduction`,
  key1003744: `Number of orders processed per month:`,
  key1003745: `Order processing fee:`,
  key1003746: `Order consumables fee:`,
  key1003747: `Additional service fee:`,
  key1003748: `Return processing fee:`,
  key1003749: `Total amount：`,
  key1003750: `Customer's actual payment amount:`,
  key1003751: `Other expenses:`,
  key1003752: `Cost Name`,
  key1003753: `Total amount`,
  key1003754: `Associated document number`,
  key1003755: `Quantity of goods in the order`,
  key1003756: `Order consumables fee`,
  key1003757: `Additional service fee`,
  key1003758: `Return processing fee`,
  key1003759: `total`,
  key1003760: `Customer's actual payment amount`,
  key1003761: `Cost incurred time`,
  key1003762: `Modify fees`,
  key1003763: `Document fees`,
  key1003764: `Other expenses`,
  key1003765: `Order processing fee cannot be empty`,
  key1003766: `The expense amount cannot be empty`,
  key1003767: `The expense name cannot be empty`,
  key1003768: `Add fees`,
  key1003769: `Successfully added fees`,
  key1003770: `Cost modification successful`,
  key1003771: `Successfully added notes`,
  key1003772: `Cost Name:`,
  key1003773: `Cost amount:`,
  key1003774: `Add Charges`,
  key1003775: `The currency of the distributor is`,
  key1003776: `Actual receipt`,
  key1003777: `System exchange rate: 1`,
  key1003778: `Cash`,
  key1003779: `Distributor merchant account number cannot be empty`,
  key1003780: `The payment method cannot be empty`,
  key1003781: `Payment voucher number cannot be empty`,
  key1003782: `Recharge currency cannot be empty`,
  key1003783: `Recharge currency:`,
  key1003784: `Operating currency:`,
  key1003785: `Recharge amount:`,
  key1003786: `Operation amount:`,
  key1003787: `Custom recharge denomination cannot be empty!`,
  key1003788: `Please upload payment flow pictures!`,
  key1003789: `Deduction successful!`,
  key1003790: `Successfully recharged!`,
  key1003791: `Up to five attachments can be uploaded!`,
  key1003792: `(Distributor Currency)`,
  key1003793: `Please enter the distributor merchant number to search`,
  key1003794: `If the recharge currency is different from the distributor's currency, the system will convert it to the distributor's currency for recharge based on the exchange rate.`,
  key1003795: `Payment method:`,
  key1003796: `Payment voucher number:`,
  key1003797: `Custom`,
  key1003798: `Upload attachments`,
  key1003799: `Supplier bill number`,
  key1003800: `Please enter the supplier account number, which supports multiple commas or line breaks for separation`,
  key1003801: `Bill amount`,
  key1003802: `Billing Currency`,
  key1003803: `Number of orders`,
  key1003804: `Bill settlement status`,
  key1003805: `Supplier confirmation time`,
  key1003806: `Audit time`,
  key1003807: `Payment time`,
  key1003808: `Payer`,
  key1003809: `Payment method`,
  key1003810: `Receiving account information`,
  key1003811: `Bank`,
  key1003812: `account`,
  key1003813: `ID number`,
  key1003814: `Bill Details`,
  key1003815: `Supply price (CNY)`,
  key1003816: `Subtotal of goods amount (CNY)`,
  key1003817: `Time of incurring expenses`,
  key1003818: `Waybill Type`,
  key1003819: `Central warehouse delivery time`,
  key1003820: `Whether to prepare goods in the central warehouse`,
  key1003821: `Supplier Direct Hair Own Logistics Fee (CNY)`,
  key1003822: `Domestic logistics fee (CNY)`,
  key1003823: `Total Amount (CNY)`,
  key1003824: `General Ledger`,
  key1003825: `Batch payment can only be made if the collection account is Alipay!`,
  key1003826: `Please select a bill first!`,
  key1003827: `Alipay order number`,
  key1003828: `Billing Status:`,
  key1003829: `Searchable billing number/vendor name`,
  key1003830: `Export supplier invoice`,
  key1003831: `Batch payment`,
  key1003832: `Batch confirmation of offline payment`,
  key1003833: `Total profit`,
  key1003834: `Total income`,
  key1003835: `Total expenditure`,
  key1003836: `Prompt for platform bill update`,
  key1003837: `Start Date Time ~ End Date Time`,
  key1003838: `Export platform bill`,
  key1003839: `Export Bill`,
  key1003840: `Logistics Mode`,
  key1003841: `Logistics costs`,
  key1003842: `Subsidy rules`,
  key1003843: `Bill of Lading Weight`,
  key1003844: `Quantity of goods in the bill of lading`,
  key1003845: `On time delivery rate`,
  key1003846: `Warehousing time`,
  key1003847: `Sorting time`,
  key1003848: `Last updated by`,
  key1003849: `Please enter the bill of lading number, which supports multiple commas or line breaks for separation`,
  key1003850: `Please enter the waybill number, which supports multiple commas or line breaks for separation`,
  key1003851: `Please enter the supplier merchant account, which supports multiple commas or line breaks for separation`,
  key1003852: `Only pending orders can be batch approved!`,
  key1003853: `Please check the data that needs to be reviewed first!`,
  key1003854: `Description`,
  key1003855: `Quantity of goods in the bill of lading`,
  key1003856: `Re review`,
  key1003857: `Subsidy rules:`,
  key1003858: `Please select subsidy rules`,
  key1003859: `Logistics-Express`,
  key1003860: `Logistics-door-to-door collection`,
  key1003861: `As of`,
  key1003862: `Previous`,
  key1003863: `single`,
  key1003864: `Subsidy based on the number of bills of lading`,
  key1003865: `Subsidy based on the weight of the bill of lading`,
  key1003866: `No subsidy`,
  key1003867: `Shipping method`,
  key1003868: `Order delivery rate`,
  key1003869: `Subsidy recipients`,
  key1003870: `Subsidy type`,
  key1003871: `Subsidy Description`,
  key1003872: `Subsidy conditions`,
  key1003873: `apply`,
  key1003874: `Actual data`,
  key1003875: `Subsidy calculation`,
  key1003876: `1. Single bill of lading subsidy:`,
  key1003877: `1.0-1 kg subsidy:`,
  key1003878: `2. Subsidy per kilogram of continued weight:`,
  key1003879: `3. Maximum subsidy for a single bill of lading:`,
  key1003880: `Compliance sub rule:`,
  key1003881: `Compliance with rules:`,
  key1003882: `The subsidy is manually adjusted to:`,
  key1003883: `Total:`,
  key1003884: `Settlement status`,
  key1003885: `Total amount (CNY)`,
  key1003886: `Order processing volume`,
  key1003887: `Warehouse rent`,
  key1003888: `Bill update time`,
  key1003889: `Monthly order processing volume (CNY)`,
  key1003890: `Order consumables cost (CNY)`,
  key1003891: `Additional fees (CNY)`,
  key1003892: `Return processing fee (CNY)`,
  key1003893: `Warehouse rent (CNY)`,
  key1003894: `Order consumables cost`,
  key1003895: `Additional service fees`,
  key1003896: `Return processing fees`,
  key1003897: `Total amount`,
  key1003898: `The storage fees are being recalculated, please refresh the list later to view!`,
  key1003899: `Please check the data that needs to be updated!`,
  key1003900: `Export warehouse bills`,
  key1003901: `Update billing`,
  key1003902: `The adjusted subsidy amount cannot be empty`,
  key1003903: `Adjustment description cannot be empty`,
  key1003904: `Rule calculation subsidy:`,
  key1003905: `Adjusted subsidy:`,
  key1003906: `Please enter the adjusted subsidy amount`,
  key1003907: `Adjustment instructions:`,
  key1003908: `Please enter adjustment instructions`,
  key1003909: `Distributor`,
  key1003910: `Document number`,
  key1003911: `Month to which the bill belongs`,
  key1003912: `Cost flow status`,
  key1003913: `Cost status:`,
  key1003914: `Cost incurred time:`,
  key1003915: `Account number`,
  key1003916: `Number of monthly packages`,
  key1003917: `Bill matching quantity`,
  key1003918: `Export logistics bills`,
  key1003919: `Import logistics provider bills`,
  key1003920: `Import logistics bills`,
  key1003921: `1. Once the settled billing data is imported, it will no longer be updated and will be displayed as a failure;`,
  key1003922: `2. Support extension:`,
  key1003923: `3. When there is an abnormality in the imported data, the data import fails;`,
  key1003924: `Audit reason cannot be empty`,
  key1003925: `Please select the subsidy review result:`,
  key1003926: `Reason for failure to pass the audit:`,
  key1003927: `Not set`,
  key1003928: `Set payment password`,
  key1003929: `The payment password cannot be empty`,
  key1003930: `Replacement successful!`,
  key1003931: `Saved successfully!`,
  key1003932: `The passwords entered twice do not match`,
  key1003933: `Set`,
  key1003934: `Change payment password`,
  key1003935: `Delete payment password`,
  key1003936: `Please enter the payment password:`,
  key1003937: `New payment password:`,
  key1003938: `Please enter the new password again:`,
  key1003939: `Please re-enter the payment password`,
  key1003940: `Please enter the password again:`,
  key1003941: `Billing payment password`,
  key1003942: `Remove password`,
  key1003943: `After deleting the payment password, it will no longer be necessary to enter the password for online payment confirmation. Please operate with caution.`,
  key1003944: `Monthly cumulative recharge:`,
  key1003945: `Monthly Alipay cumulative recharge:`,
  key1003946: `Monthly manual cumulative recharge:`,
  key1003947: `Monthly cumulative consumption:`,
  key1003948: `Third party transaction vouchers`,
  key1003949: `Logistics fee withheld`,
  key1003950: `Real deduction of logistics fee`,
  key1003951: `Remote area delivery fee`,
  key1003952: `Logistics return fee`,
  key1003953: `Secondary delivery fee`,
  key1003954: `Logistic document cancellation fee`,
  key1003955: `Consumption records (only calculate cancelled and shipped parts of orders)`,
  key1003956: `Multiple`,
  key1003957: `SKU line break`,
  key1003958: `Bill of Lading SKU Details`,
  key1003959: `The current SKU in the bill of lading is shown in the following figure, totaling`,
  key1003960: `Species, total`,
  key1003961: `Pieces.`,
  key1003962: `Quantity to be put on shelves`,
  key1003963: `On-shelf quantity`,
  key1003964: `The warehouse name cannot be empty!`,
  key1003965: `The library area name cannot be empty!`,
  key1003966: `The location name cannot be empty!`,
  key1003967: `The quantity on the shelf cannot be empty!`,
  key1003968: `The quantity on the shelf must be an integer greater than 0`,
  key1003969: `The number of shelves cannot be greater than the number of shelves!`,
  key1003970: `The quantity on the shelf must be greater than 0`,
  key1003971: `Goods on the shelves`,
  key1003972: `Please enter YMSSKU, support multiple commas or line breaks`,
  key1003973: `Please enter YMSSPU, support multiple commas or line breaks`,
  key1003974: `Please enter the supplier SKU, which supports multiple commas or line breaks for separation`,
  key1003975: `Please enter vendor SPU, support multiple commas or line breaks`,
  key1003976: `Supplier SKU:`,
  key1003977: `Quantity to be sticked`,
  key1003978: `Scan successfully!`,
  key1003979: `Please enter the correct supplier SKU!`,
  key1003980: `Supplier SKU cannot be empty!`,
  key1003981: `Please tick the data to be printed first!`,
  key1003982: `The number of prints cannot be empty!`,
  key1003983: `Scan or enter supplier SKU`,
  key1003984: `Bulk print`,
  key1003985: `In sticker job...`,
  key1003986: `End the sticker job`,
  key1003987: `Conventional sorting`,
  key1003988: `Stock sorting`,
  key1003989: `Remove Package Reminder`,
  key1003990: `The package is being removed and can be rescanned for packaging after removal`,
  key1003991: `Still need`,
  key1003992: `Remove success`,
  key1003993: `gram`,
  key1003994: `Kilogram`,
  key1003995: `The weighing unit is:`,
  key1003996: `Please enter the outbound order number or waybill number!`,
  key1003997: `Weighing must be an integer greater than 0!`,
  key1003998: `The weighing cannot be empty!`,
  key1003999: `This logistics channel needs to send express to the collection point. The domestic express or logistics company and logistics order number cannot be empty!`,
  key1004000: `You still have parcels that have not been sorted. Do you want to end sorting?`,
  key1004001: `Logistic sorting exception reminder`,
  key1004002: `Forced end`,
  key1004003: `Scan:`,
  key1004004: `It is able to scan outbound order number, waybill number, logistics order number, container number`,
  key1004005: `Weigh:`,
  key1004006: `Please keep the weight unit of the system and the weight unit of the electronic scale consistent.`,
  key1004007: `Actual weighing (`,
  key1004008: `Address`,
  key1004009: `Weigh`,
  key1004010: `Shipping method:`,
  key1004011: `End container sorting`,
  key1004012: `Cotton Bag`,
  key1004013: `Print appointment delivery note prompt`,
  key1004014: `For online shipment on AliExpress, a pre delivery note is required. Please print the pre delivery note in the logistics handover note after closing the bag.`,
  key1004015: `Not yet bagged`,
  key1004016: `Direct bagging`,
  key1004017: `Booking and bagging`,
  key1004018: `Print collection waybill prompt`,
  key1004019: `AliExpress fully managed JIT orders require printing of collection waybills. If not printed, delivery to AliExpress collection will not be possible.`,
  key1004020: `Printing and bagging`,
  key1004021: `Handover order number`,
  key1004022: `Parcel qty`,
  key1004023: `Delivery method`,
  key1004024: `Logistics distribution method`,
  key1004025: `System distribution`,
  key1004026: `Manual distribution`,
  key1004027: `Domestic logistics tracking number`,
  key1004028: `Handover time`,
  key1004029: `Handover person`,
  key1004030: `Mark out`,
  key1004031: `Continue packing`,
  key1004032: `Print Pre Delivery Form`,
  key1004033: `Print express waybill`,
  key1004034: `Failed to obtain the express delivery address`,
  key1004035: `Appointment collection`,
  key1004036: `Print collection waybill`,
  key1004037: `Creation Time`,
  key1004038: `Please enter the handover number, which supports multiple commas or line breaks for separation`,
  key1004039: `Please enter the outbound tracking number, which supports multiple commas or line breaks for separation`,
  key1004040: `Please check the data to be marked out of the library first!`,
  key1004041: `Failed to obtain pre delivery waybill address`,
  key1004042: `Appointment successful!`,
  key1004043: `Failed to obtain the collection waybill address`,
  key1004044: `Handover person:`,
  key1004045: `Please enter the handover person`,
  key1004046: `Sort by:`,
  key1004047: `Tripartite Bill of Lading No.`,
  key1004048: `Number of outbound orders in box/bag`,
  key1004049: `Warehousing is successful!`,
  key1004050: `Please enter the bill of lading number!`,
  key1004051: `Please scan or enter the bill of lading number/express number/three-way bill of lading number.`,
  key1004052: `Container status`,
  key1004053: `Product quantity`,
  key1004054: `Homework start time`,
  key1004055: `Continue to publish`,
  key1004056: `Actual number of listings`,
  key1004057: `Assignment End Time`,
  key1004058: `Job duration`,
  key1004059: `Export by container dimension`,
  key1004060: `Export by SKU dimension`,
  key1004061: `Number of SKUs inside the container`,
  key1004062: `Number of items`,
  key1004063: `Storage bin for putaway`,
  key1004064: `Waiting on-shelf`,
  key1004065: `In publishing`,
  key1004066: `It has been added to`,
  key1004067: `The bill of lading number cannot be empty!`,
  key1004068: `Product shelving job Reminder`,
  key1004069: `You have unfinished product publishing jobs. Do you want to continue the job?`,
  key1004070: `Listing operation:`,
  key1004071: `Scan or enter the container number`,
  key1004072: `Supports multiple container numbers separated by commas or line breaks`,
  key1004073: `Export listing data`,
  key1004074: `Container status:`,
  key1004075: `Sticker job`,
  key1004076: `Continue to stick waybills`,
  key1004077: `To stick waybill`,
  key1004078: `In sticking waybills`,
  key1004079: `Posted`,
  key1004080: `The container number cannot be empty!`,
  key1004081: `Product sticker job reminder`,
  key1004082: `You have an unfinished product sticker job. Do you want to continue the job?`,
  key1004083: `Sticking homework:`,
  key1004084: `Export sticker data`,
  key1004085: `Please select warehouse.`,
  key1004086: `Please select the cargo owner.`,
  key1004087: `Number of operations`,
  key1004088: `Receiving Warehouse`,
  key1004089: `Inventory the warehouse`,
  key1004090: `Please select a receiving warehouse`,
  key1004091: `Please select an inventory warehouse`,
  key1004092: `Operation quantity must be greater than or equal to 1`,
  key1004093: `New Bill of Lading`,
  key1004094: `Receipt Type:`,
  key1004095: `Shipper:`,
  key1004096: `Please enter the merchant number to search`,
  key1004097: `Third Party Bill of Lading No:`,
  key1004098: `Please enter third party bill of lading number`,
  key1004099: `Please add product data first`,
  key1004100: `Details`,
  key1004101: `Add items`,
  key1004102: `Waiting for collection`,
  key1004103: `Already enter the warehouse`,
  key1004104: `Missing package`,
  key1004105: `Inbound type`,
  key1004106: `Logistics trajectory`,
  key1004107: `Quantity of goods receivable`,
  key1004108: `Actual received quantity of accounts receivable`,
  key1004109: `Supplier's quantity of multiple shipments`,
  key1004110: `Abnormal State`,
  key1004111: `Abnormal quantity, please click to view`,
  key1004112: `Mark received`,
  key1004113: `Cancel`,
  key1004114: `Please enter SKU, supporting multiple commas or line breaks for separation`,
  key1004115: `Please enter the three-way bill of lading number, support multiple commas or line breaks.`,
  key1004116: `Bill of lading number`,
  key1004117: `Supplier Merchant Name`,
  key1004118: `courier number`,
  key1004119: `Shipping method`,
  key1004120: `Export by picking order dimension`,
  key1004121: `Please tick the data to be marked as received first!`,
  key1004122: `Sorting exception:`,
  key1004123: `Collecting time:`,
  key1004124: `Export Bill of Lading List`,
  key1004125: `Bulk mark has been collected`,
  key1004126: `(Cancelled)`,
  key1004127: `Actual weight of package (g)`,
  key1004128: `data sources`,
  key1004129: `Weigher`,
  key1004130: `Boxed`,
  key1004131: `Removal successful!`,
  key1004132: `Delivery time:`,
  key1004133: `Shipping settings`,
  key1004134: `Unit:`,
  key1004135: `Cut off:`,
  key1004136: `The waybill number scanned by some logistics providers will have a prefix or suffix, so the system cannot identify the waybill number. Check to cut off the corresponding prefix or suffix.`,
  key1004137: `Open (required)`,
  key1004138: `Open (not required)`,
  key1004139: `Not open`,
  key1004140: `Before`,
  key1004141: `After`,
  key1004142: `TEMU tag number`,
  key1004143: `Has it been scanned`,
  key1004144: `Weight (g)`,
  key1004145: `Print packaging labels`,
  key1004146: `Please scan the TEMU tag number!`,
  key1004147: `Scan successful`,
  key1004148: `Please scan all TEMU bags before proceeding with the bag tying operation.`,
  key1004149: `The shipping address was not obtained!`,
  key1004150: `Please scan the TEMU tag number`,
  key1004151: `Please enter a void reason`,
  key1004152: `Canceled successfully!`,
  key1004153: `Void Bill of Lading Confirmation`,
  key1004154: `Reason for cancellation:`,
  key1004155: `After voiding the bill of lading, the unshipped order will be transferred to the supplier to be shipped list again.`,
  key1004156: `Confirm void`,
  key1004157: `Sorting container:`,
  key1004158: `Bill of lading number:`,
  key1004159: `Sorting time:`,
  key1004160: `Please scan the bill of lading number first!`,
  key1004161: `Revoke operation prompt`,
  key1004162: `After revocation, the SKU in the corresponding container will be removed. Please operate with caution.`,
  key1004163: `Revoke`,
  key1004164: `Scan Record`,
  key1004165: `Revoke Action`,
  key1004166: `The container has ended and cannot be revoked`,
  key1004167: `Actual received quantity`,
  key1004168: `Destination warehouse`,
  key1004169: `Operation content/message`,
  key1004170: `Please enter the content of the remarks!`,
  key1004171: `There are multiple shipments in the bill of lading,`,
  key1004172: `It will be processed as stock, and the corresponding stock order number has been automatically created, and the type is multiple replenishment order.`,
  key1004173: `Bill of Lading Number:`,
  key1004174: `Type of Bill of Lading:`,
  key1004175: `Third Party Bill of Lading No:`,
  key1004176: `Bill of lading declared quantity and actual arrival quantity`,
  key1004177: `Sales Order:`,
  key1004178: `Stock list:`,
  key1004179: `Quantity of multiple shipments`,
  key1004180: `Bill of Lading Status`,
  key1004181: `Bill of Lading Type`,
  key1004182: `Number of outbound orders`,
  key1004183: `Sorting operation`,
  key1004184: `Number of goods on the bill of lading`,
  key1004185: `Actual sorting quantity`,
  key1004186: `Sorting container`,
  key1004187: `Number of sku`,
  key1004188: `Warehousing operation time`,
  key1004189: `Sorting start time`,
  key1004190: `Sorting end time`,
  key1004191: `Sorting end operator`,
  key1004192: `Wait for pick`,
  key1004193: `Sorting`,
  key1004194: `Inbound sorting operation reminder`,
  key1004195: `You have unfinished sorting operations. Do you want to continue the operation?`,
  key1004196: `Sorting operations:`,
  key1004197: `Scan or enter bill of lading number/express bill of lading number/third party bill of lading number`,
  key1004198: `Export sorting data`,
  key1004199: `Enter the homework interface`,
  key1004200: `Bill of Lading Status:`,
  key1004201: `Quantity to be listed`,
  key1004202: `There is an abnormal SKU, please check and try again`,
  key1004203: `Incomplete listing data`,
  key1004204: `Prompt for abnormal listing`,
  key1004205: `The number of listings cannot exceed the number of listings to be placed`,
  key1004206: `The warehouse area and location are not filled in`,
  key1004207: `Partial on-shelf`,
  key1004208: `End of publish`,
  key1004209: `The number of SKU listings is inconsistent with the number of pending listings. The details are as follows. Please confirm whether to end the listing?`,
  key1004210: `Continuing homework`,
  key1004211: `Already on`,
  key1004212: `Same SKU exists in container, please end`,
  key1004213: `Rescan bill of lading after container`,
  key1004214: `SKU/supplier SKU/logistics list cannot but be empty!`,
  key1004215: `Receivable quantity`,
  key1004216: `Sorting quantity`,
  key1004217: `Sorting still needed`,
  key1004218: `Quantity scanned`,
  key1004219: `Please scan the barcode`,
  key1004220: `Sorted quantity`,
  key1004221: `Unsorted`,
  key1004222: `The bill of lading number cannot be empty!`,
  key1004223: `The current container has been picked and needs to be rebound.`,
  key1004224: `There is no this product in the bill of lading, please confirm carefully!`,
  key1004225: `This package has been sorted, please do not repeat scanning`,
  key1004226: `Container picking prompt`,
  key1004227: `The picking quantity for this container has reached the maximum limit, and the system will automatically complete the picking of the container. Please bind a new container to continue the operation.`,
  key1004228: `The packaging quantity of this container has reached the maximum limit, and the system will automatically pick the container. Please bind a new container to continue the operation.`,
  key1004229: `End sorting operation`,
  key1004230: `Will end the bill of lading and container sorting at the same time, are you sure to end?`,
  key1004231: `End sorting`,
  key1004232: `Container color repetition prompt`,
  key1004233: `This color container already exists. Please select a different color container.`,
  key1004234: `Set container color prompt`,
  key1004235: `This container has no color. Please select a container with color attributes.`,
  key1004236: `Please scan the bill of lading number first!`,
  key1004237: `Container number cannot be empty!`,
  key1004238: `Please select the type of waybill!`,
  key1004239: `Reminder for SKU exceeding accounts receivable`,
  key1004240: `The SKUs in progress have exceeded the receivable quantity. If there are SKUs exceeding the receivable quantity after sorting is completed, the system will automatically make up the order and send a prompt to the supplier, without the need for manual operation.`,
  key1004241: `This SKU needs to be shelved, and there is currently no bound sticker+shelving container. Please bind sticker+shelving container:`,
  key1004242: `This SKU needs to be put on the shelves, and there is currently no bound container. Please bind the container to be put on the shelves:`,
  key1004243: `Prompt for abnormal SKU quantity`,
  key1004244: `There are differences between the following SKU quantities and the expected quantity. After sorting, the actual overcharged SKU system will automatically make up the order and send a prompt to the supplier.`,
  key1004245: `Scan or input`,
  key1004246: `SKU/Supplier SKU/Logistics Surface Sheet`,
  key1004247: `Scan or enter the bill of lading number`,
  key1004248: `Please scan or enter the container number`,
  key1004249: `Order No.:`,
  key1004250: `Sorting job...`,
  key1004251: `End the sorting`,
  key1004252: `Piece-by-piece`,
  key1004253: `Whether to prompt if the quantity to be shipped is exceeded`,
  key1004254: `Enable voice broadcasting`,
  key1004255: `To be labeled`,
  key1004256: `Please add a container`,
  key1004257: `Containers have been sorted completely`,
  key1004258: `Find a variety of types of waybills, please choose the right one!`,
  key1004259: `Not to be processed temporarily`,
  key1004260: `Bind Container`,
  key1004261: `Please select domestic express delivery`,
  key1004262: `Domestic courier selection`,
  key1004263: `Ordering method:`,
  key1004264: `Domestic express delivery:`,
  key1004265: `This logistics channel requires express delivery to the pickup point. After packaging, please repackage all packages under this channel, with the outermost layer labeled with a domestic express waybill!`,
  key1004266: `System Ordering`,
  key1004267: `Placing an offline order`,
  key1004268: `Supplementary charge cannot be empty`,
  key1004269: `Charges must be greater than 0`,
  key1004270: `Logistics fee collection`,
  key1004271: `Supplementary collection type:`,
  key1004272: `Supplementary charge:`,
  key1004273: `Please enter a replacement charge`,
  key1004274: `previous logistics provider`,
  key1004275: `Original shipping method`,
  key1004276: `Destination`,
  key1004277: `Reason`,
  key1004278: `No data selected`,
  key1004279: `Please choose a logistics channel`,
  key1004280: `Account number cannot be null.`,
  key1004281: `Change shipping method`,
  key1004282: `Please select the shipping method after change:`,
  key1004283: `Account:`,
  key1004284: `Modify failed data`,
  key1004285: `Logistics dynamic parameters`,
  key1004286: `Confirm`,
  key1004287: `Please enter cancel`,
  key1004288: `Order Reason`,
  key1004289: `Order reason, this reason is visible to the distributor.`,
  key1004290: `Cancel Order`,
  key1004291: `Order Cancellation Reason:`,
  key1004292: `Confirm cancellation`,
  key1004293: `Payment channels`,
  key1004294: `Collection account`,
  key1004295: `Supplement payment information`,
  key1004296: `Date Created`,
  key1004297: `Active`,
  key1004298: `Edit & View`,
  key1004299: `Confirm to delete`,
  key1004300: `Are you sure you want to delete this information?`,
  key1004301: `confirm deletion`,
  key1004302: `Deleted successfully!`,
  key1004303: `Payment channels:`,
  key1004304: `Receiving account:`,
  key1004305: `Add a new receiving account`,
  key1004306: `The commodity is a customized commodity, and the original SKU represents the SKU of the original basic customized commodity template.`,
  key1004307: `Original SKU:`,
  key1004308: `Platform-operated`,
  key1004309: `The total amount of supplier orders and distributor orders cannot be empty`,
  key1004310: `Save and place order successfully`,
  key1004311: `Total amount of supplier orders:`,
  key1004312: `Total distributor order amount:`,
  key1004313: `Distributor's payable amount:`,
  key1004314: `Supplier's receivable amount:`,
  key1004315: `Save and place an order`,
  key1004316: `Quantity received`,
  key1004317: `Cancel quantity`,
  key1004318: `Refund Quantity`,
  key1004319: `Price to be adjusted`,
  key1004320: `Waiting for suppliers to accept orders`,
  key1004321: `To be paid by the distributor`,
  key1004322: `To be put into storage`,
  key1004323: `Please enter SPU, supporting multiple commas or line breaks for separation`,
  key1004324: `Please enter SKU, supporting multiple commas or line breaks for separation`,
  key1004325: `Please enter the distributor merchant account, which supports multiple commas or line breaks`,
  key1004326: `Please enter the supplier merchant account, which supports multiple commas or line breaks for separation`,
  key1004327: `Delivered`,
  key1004328: `To be resent`,
  key1004329: `Order confirmation`,
  key1004330: `We are currently placing an order. Please confirm if you want to place an order?`,
  key1004331: `Confirm order placement`,
  key1004332: `Order placed successfully!`,
  key1004333: `Cancelled successfully!`,
  key1004334: `Stock order status:`,
  key1004335: `Stock order number:`,
  key1004336: `Please enter the stocking order number, which supports multiple line separations`,
  key1004337: `Order date:`,
  key1004338: `Payment time:`,
  key1004339: `Completion time:`,
  key1004340: `Order Amount:`,
  key1004341: `Order original amount:`,
  key1004342: `Amount after price adjustment:`,
  key1004343: `Cancelled Amount:`,
  key1004344: `Refund amount:`,
  key1004345: `Distributor:`,
  key1004346: `SUPPLIER SUBorder No:`,
  key1004347: `Shipment date:`,
  key1004348: `Receipt Time:`,
  key1004349: `Amount:`,
  key1004350: `Price adjustment:`,
  key1004351: `Settlement:`,
  key1004352: `Original unit price:`,
  key1004353: `After price adjustment:`,
  key1004354: `Unit Price:`,
  key1004355: `Order Quantity:`,
  key1004356: `Quantity received:`,
  key1004357: `Number of shelves:`,
  key1004358: `Number of cancellations:`,
  key1004359: `Number of refunds:`,
  key1004360: `Out of stock quantity:`,
  key1004361: `Expected delivery time:`,
  key1004362: `Order number:`,
  key1004363: `Abnormal State:`,
  key1004364: `Replenishing`,
  key1004365: `Shipped（`,
  key1004366: `Packing size (length, width, height cm)`,
  key1004367: `Allocated quantity`,
  key1004368: `Row no.`,
  key1004369: `Supplier order number`,
  key1004370: `Item Qty`,
  key1004371: `Outbound order status`,
  key1004372: `Out of stock status`,
  key1004373: `Out of stock, please check details`,
  key1004374: `Order status update time`,
  key1004375: `Void or not`,
  key1004376: `unclosed`,
  key1004377: `Details`,
  key1004378: `Chinese Declaration Name`,
  key1004379: `English Declaration Name`,
  key1004380: `Customs value`,
  key1004381: `Customs weight`,
  key1004382: `Declaration Amount`,
  key1004383: `HS Code`,
  key1004384: `Item link`,
  key1004385: `Customs information`,
  key1004386: `Log content description`,
  key1004387: `Waybill Type:`,
  key1004388: `Distributor order number:`,
  key1004389: `Warehouse for shipment:`,
  key1004390: `Consignee name:`,
  key1004391: `Customer ID:`,
  key1004392: `Address 1:`,
  key1004393: `Address 2:`,
  key1004394: `Logistics order no.:`,
  key1004395: `Shipping method:`,
  key1004396: `Waybill No.1:`,
  key1004397: `Waybll No.2:`,
  key1004398: `Logistics provider weighing (g):`,
  key1004399: `Freight from logistics provider:`,
  key1004400: `Order Estimate Weighing (g):`,
  key1004401: `Actual Weighing of Order (g):`,
  key1004402: `logistics provider estimated freight:`,
  key1004403: `logistics providers actual freight:`,
  key1004404: `logistics tripartite single number:`,
  key1004405: `Temu Tag Number`,
  key1004406: `SKU * Quantity`,
  key1004407: `Package weight (g)`,
  key1004408: `There is currently no packaging label available`,
  key1004409: `Temu sample`,
  key1004410: `Temu goods`,
  key1004411: `Allocated inventory`,
  key1004412: `Picking completed`,
  key1004413: `Stocked`,
  key1004414: `Please fill in the new row fully.`,
  key1004415: `Please add declaration information first!`,
  key1004416: `The current small package has not undergone logistics sorting and cannot print the box label`,
  key1004417: `Main information`,
  key1004418: `Consignee information`,
  key1004419: `logistics provider information`,
  key1004420: `Order details:`,
  key1004421: `Order Item`,
  key1004422: `Supplier Sub-Doc`,
  key1004423: `packaging information`,
  key1004424: `Outbound order type:`,
  key1004425: `Arrival time:`,
  key1004426: `All SKUs`,
  key1004427: `Abnormal quantity SKU upon arrival`,
  key1004428: `Initiate stock quantity`,
  key1004429: `Actual Quantity Received`,
  key1004430: `sku information`,
  key1004431: `Order number, supports multiple commas or line breaks`,
  key1004432: `Order Information`,
  key1004433: `Order SKU Information`,
  key1004434: `Operation`,
  key1004435: `Distributor order number`,
  key1004436: `Please enter the distributor order number, which supports multiple commas or line breaks for separation`,
  key1004437: `Please enter the supplier order number, which supports multiple commas or line breaks for separation`,
  key1004438: `Please enter the waybill number, which supports multiple commas or line breaks for separation`,
  key1004439: `Please enter the Temu tag number, which supports multiple commas or line breaks for separation`,
  key1004440: `Waybill No.`,
  key1004441: `Please enter the logistics provider order number, multiple commas or line breaks are supported`,
  key1004442: `Logistics tracking number`,
  key1004443: `Please enter the third-party logistics tracking number, which supports multiple commas or line breaks for separation`,
  key1004444: `Shipping Information`,
  key1004445: `Supplier Sub-Doc Information`,
  key1004446: `To be issued`,
  key1004447: `Under distribution`,
  key1004448: `Successful distribution`,
  key1004449: `Distribution failed`,
  key1004450: `Own channel`,
  key1004451: `Third-party channels`,
  key1004452: `Cost of goods (CNY)`,
  key1004453: `Total cost (CNY)`,
  key1004454: `Paid-in processing fee (CNY)`,
  key1004455: `Received Processing Fee in Advance (CNY)`,
  key1004456: `Prepaid Logistics Fee (CNY)`,
  key1004457: `Pay-as-you-go logistics (CNY)`,
  key1004458: `Waybill number 1`,
  key1004459: `Waybill number 2`,
  key1004460: `Supplier delivery time`,
  key1004461: `Bill of lading collection time`,
  key1004462: `Order cancellation time`,
  key1004463: `Reason for order cancellation`,
  key1004464: `Order Type`,
  key1004465: `Order Label`,
  key1004466: `SKU unit price`,
  key1004467: `Platform order information`,
  key1004468: `Platform Site`,
  key1004469: `Store Name`,
  key1004470: `Platform order number`,
  key1004471: `Platform order amount`,
  key1004472: `Platform order status`,
  key1004473: `Platform order SKU information`,
  key1004474: `Order date`,
  key1004475: `Payment date`,
  key1004476: `Order dimension`,
  key1004477: `SKU dimension`,
  key1004478: `(Column)`,
  key1004479: `(Line)`,
  key1004480: `When displaying by row, general information will be merged, please note when making statistics.`,
  key1004481: `Status update time`,
  key1004482: `By update time`,
  key1004483: `Logistics provider to be delivered`,
  key1004484: `Supplier Own Logistics`,
  key1004485: `A maximum of 1000 items can be queried at a time. Please adjust and try again.`,
  key1004486: `(To be executed for shipment)`,
  key1004487: `(Original:`,
  key1004488: `Distributor Own Logistics`,
  key1004489: `Please select the order that has been paid and the status of delivery is pending or failed to be delivered for logistics delivery!`,
  key1004490: `Please tick the data to be distributed first!`,
  key1004491: `Please tick the data to be modified first!`,
  key1004492: `Please select consistent orders from the delivery warehouse to modify the logistics method in bulk!`,
  key1004493: `Please check the data to be labeled first!`,
  key1004494: `Delete Tag Confirmation`,
  key1004495: `Deleting order label. Please confirm whether to delete?`,
  key1004496: `Update carrier`,
  key1004497: `Add carrier`,
  key1004498: `Fetching...`,
  key1004499: `SKU, supports multiple commas or line breaks`,
  key1004500: `SPU, supports multiple commas or line breaks`,
  key1004501: `Order Tag:`,
  key1004502: `Distribution status:`,
  key1004503: `Order type:`,
  key1004504: `Source:`,
  key1004505: `Performing Party:`,
  key1004506: `Whether there is a platform for self-supporting goods:`,
  key1004507: `Only when the data is from Yunmai Logistics or its source is its own channels can the logistics method be modified!`,
  key1004508: `Parcels that need to be sent by courier to the collection point will be subject to an additional domestic courier fee.`,
  key1004509: `Retrieve again`,
  key1004510: `Real Weight Import`,
  key1004511: `The number of the products:`,
  key1004512: `Status update time:`,
  key1004513: `Order Creation Time:`,
  key1004514: `Order delivery time:`,
  key1004515: `Order cancellation time:`,
  key1004516: `See more (`,
  key1004517: `surplus`,
  key1004518: `a)`,
  key1004519: `Domestic express delivery fee:`,
  key1004520: `Amount of goods:`,
  key1004521: `Pre-Received Handling Fee:`,
  key1004522: `Paid-in processing fee:`,
  key1004523: `Actual logistics fee:`,
  key1004524: `Prepaid logistics fee:`,
  key1004525: `Customs clearance fee:`,
  key1004526: `Remote area delivery fee:`,
  key1004527: `Logistics return fee:`,
  key1004528: `Secondary delivery fee:`,
  key1004529: `Logistic document cancellation fee:`,
  key1004530: `Domestic Express Single Number:`,
  key1004531: `Customer logistics:`,
  key1004532: `Supplier Sub-Doc`,
  key1004533: `Issue logistics`,
  key1004534: `Order number:`,
  key1004535: `(to be manually issued)`,
  key1004536: `(Not matched to basic logistics, please manually modify the logistics channel)`,
  key1004537: `Getting waybill number, please wait`,
  key1004538: `Failed to obtain the waybill number, please try to obtain it manually.`,
  key1004539: `Download the menu`,
  key1004540: `View Sublist`,
  key1004541: `Print logistics face sheet`,
  key1004542: `Notify distributors`,
  key1004543: `1. If the waybill number in the document matches the order waybill number in the list, it will be regarded as invalid;`,
  key1004544: `2. If the waybill number in the document matches the uploaded logistics fee entry in the list, it will also be regarded as invalid content;`,
  key1004545: `3. Only xls and xlsx format files are supported`,
  key1004546: `Cancellation processing fee cannot be empty`,
  key1004547: `Packing status allows cancellation of order confirmation`,
  key1004548: `Cancellation processing fee:`,
  key1004549: `This order has been packed, please be sure to confirm whether the site has not been issued, after the cancellation of the need to promptly contact the relevant personnel to take out the package.`,
  key1004550: `Allow Order Cancellation`,
  key1004551: `Product Image`,
  key1004552: `(Original SKU:`,
  key1004553: `Out of stock information`,
  key1004554: `Supplier order number:`,
  key1004555: `Outbound order status:`,
  key1004556: `Quantity of goods:`,
  key1004557: `Received`,
  key1004558: `Sku, supports multiple commas or line breaks`,
  key1004559: `Stock order number`,
  key1004560: `Outbound order type`,
  key1004561: `Please enter the stock order number, which supports multiple commas or line breaks for separation`,
  key1004562: `Stock order status`,
  key1004563: `Supplier Delivery Order Status`,
  key1004564: `Supplier delivery order type`,
  key1004565: `Shipment date`,
  key1004566: `Cancel Time`,
  key1004567: `Please select the status of the backup order`,
  key1004568: `Supplier delivery order status:`,
  key1004569: `Please select the status of the outbound order`,
  key1004570: `Supplier delivery order type:`,
  key1004571: `Please select the type of supplier's outbound order`,
  key1004572: `Export Order`,
  key1004573: `Order/Distributor stocking number:`,
  key1004574: `The actual received quantity in the warehouse is insufficient. Please check the details in the shipping record`,
  key1004575: `It has been invalidated and needs to be reshipped.`,
  key1004576: `Order/Distributor stocking number`,
  key1004577: `Order/distributor stocking document number, which supports multiple commas or line breaks.`,
  key1004578: `second`,
  key1004579: `Supplier Sub-Order No:`,
  key1004580: `Remaining delivery time`,
  key1004581: `Timed out`,
  key1004582: `Barcode:`,
  key1004583: `Received quantity:`,
  key1004584: `Timeout time`,
  key1004585: `End Time`,
  key1004586: `End time refers to the node when all the order processes have ended. The time at this node will be included in the corresponding accounting period for the order.`,
  key1004587: `Mark arrival`,
  key1004588: `Update tags`,
  key1004589: `Supplier Sub-Order No.`,
  key1004590: `Enter the supplier sub-order number. Multiple entries can be separated by commas or line breaks.`,
  key1004591: `Please enter the supplier SKU, which supports multiple commas or line breaks for separation`,
  key1004592: `Please enter the supplier name, supporting multiple commas or line breaks for separation`,
  key1004593: `Supplier Merchant Number`,
  key1004594: `total amount of the order`,
  key1004595: `Sub-Doc Type`,
  key1004596: `Not recorded`,
  key1004597: `In the settlement`,
  key1004598: `Paid`,
  key1004599: `The start duration of the timeout cannot be greater than the end duration`,
  key1004600: `Failed to obtain marked out of stock details data!`,
  key1004601: `Timed out`,
  key1004602: `Order Status:`,
  key1004603: `Please select order status.`,
  key1004604: `Settlement status:`,
  key1004605: `Please select settlement status`,
  key1004606: `Time out:`,
  key1004607: `Payment channel cannot be empty`,
  key1004608: `The receiving account cannot be empty`,
  key1004609: `The payment currency cannot be empty`,
  key1004610: `Edit & View Receiving Account`,
  key1004611: `Please enter the payment channel`,
  key1004612: `Please enter the payment account`,
  key1004613: `Receipt currency:`,
  key1004614: `Supplementary payment information:`,
  key1004615: `You can enter the necessary information required for payment using the payment channel in "Supplement payment information" according to the payment channel;`,
  key1004616: `Payment Batch Number`,
  key1004617: `Total amount payable for order`,
  key1004618: `Payment channels`,
  key1004619: `Operational collection account`,
  key1004620: `Distributor Account Number`,
  key1004621: `Business Order Number`,
  key1004622: `Business amount`,
  key1004623: `Payment voucher picture`,
  key1004624: `Reconciliation status`,
  key1004625: `Reconciliation`,
  key1004626: `Awaiting reconciliation`,
  key1004627: `Reconciliation passed`,
  key1004628: `Reconciliation return`,
  key1004629: `Please check the data to be operated first!`,
  key1004630: `Please select the payment data to be reconciled`,
  key1004631: `Please enter the business order number, multiple numbers can be separated by lines`,
  key1004632: `Payment Batch Number:`,
  key1004633: `Please enter the payment batch number, multiple numbers can be separated by lines`,
  key1004634: `Business Order Number:`,
  key1004635: `Reconciliation status:`,
  key1004636: `Batch reconciliation`,
  key1004637: `Add Remarks:`,
  key1004638: `Order amount modification`,
  key1004639: `Modify the item amount`,
  key1004640: `Please choose logistics mode`,
  key1004641: `Waybill No. cannot be empty`,
  key1004642: `Modify waybill number`,
  key1004643: `Shipping method:`,
  key1004644: `Please enter the waybill number`,
  key1004645: `Please enter the logistics tracking number`,
  key1004646: `A reconciliation return means that the operator has not received the payment for this order or the actual amount received does not match the amount receivable. The distributor is required to make payment again. Only after the review is passed can the operator fulfill the order.`,
  key1004647: `The reconciliation is passed, which means that the operator has received the payment for this order and the order will be subsequently fulfilled by the operator.`,
  key1004648: `Order payment reconciliation`,
  key1004649: `Please enter the reason for return`,
  key1004650: `Message`,
  key1004651: `Reconciliation results:`,
  key1004652: `Reason for return:`,
  key1004653: `Start interval cannot be greater`,
  key1004654: `End interval`,
  key1004655: `Import products`,
  key1004656: `SKU`,
  key1004657: `Specification attribute values`,
  key1004658: `Owner role`,
  key1004659: `Merchant ID of the shipper`,
  key1004660: `By product`,
  key1004661: `Search by SKU / storage bin`,
  key1004662: `Total Inventory`,
  key1004663: `Void Quantity`,
  key1004664: `Must be a positive integer greater than or equal to 0`,
  key1004665: `Details`,
  key1004666: `SKUs, separated by commas or newlines`,
  key1004667: `SPUs, separated by commas or newlines`,
  key1004668: `Multiple supplier merchant accounts separated by commas or line breaks`,
  key1004669: `Storage bin:`,
  key1004670: `Please enter storage bin code.`,
  key1004671: `Please enter the merchant number`,
  key1004672: `Total quantity of allocated inventory and available inventory`,
  key1004673: `Void Quantity:`,
  key1004674: `Export inventory surplus`,
  key1004675: `Export Inventory Details`,
  key1004676: `Export inventory balance data`,
  key1004677: `Export inventory detail data`,
  key1004678: `1. After importing inventory, it will overwrite the original inventory. Please be cautious when importing;`,
  key1004679: `Inventory Details`,
  key1004680: `Display data with inventory 0`,
  key1004681: `You have unfinished packaging tasks, picking order number:`,
  key1004682: `Do you want to continue with the assignment?`,
  key1004683: `In packaging`,
  key1004684: `Packed`,
  key1004685: `Order number`,
  key1004686: `Picking order type`,
  key1004687: `Number of outbound orders`,
  key1004688: `Picking list type`,
  key1004689: `Picking/sorting completion time`,
  key1004690: `Picker/Sorter`,
  key1004691: `Packager`,
  key1004692: `Picking list source`,
  key1004693: `Start homework`,
  key1004694: `Picking order no.`,
  key1004695: `Operation operator`,
  key1004696: `Start homework time`,
  key1004697: `End homework time`,
  key1004698: `Reminder for regular packaging operations`,
  key1004699: `Reminder for stocking and packaging operations`,
  key1004700: `Processing`,
  key1004701: `Please enter the pick order number!`,
  key1004702: `Conventional packaging`,
  key1004703: `Stock packaging`,
  key1004704: `Picking order staus:`,
  key1004705: `Packager:`,
  key1004706: `Pick list No.:`,
  key1004707: `Please enter the picking list number, which supports multiple line separation`,
  key1004708: `Export multiple item sorting`,
  key1004709: `Scan picking list number/container number:`,
  key1004710: `sort by storage bin in ascending order`,
  key1004711: `Only in descending order by product location`,
  key1004712: `Please select at least one regular picking rack!`,
  key1004713: `Please select at least one stocking and picking shelf!`,
  key1004714: `The input sequence of the list of goods when the single-item picking list is printed:`,
  key1004715: `The input order of the product list when printing the multi-product pick list:`,
  key1004716: `Collection timeout:`,
  key1004717: `Print the address sheet when sorting:`,
  key1004718: `Print product compliance labels when sorting:`,
  key1004719: `Print product compliance labels when packaging:`,
  key1004720: `Pick order Setup`,
  key1004721: `Collection timeout setting`,
  key1004722: `Packaging job settings`,
  key1004723: `Conventional sorting rack settings (only available when the automatic sorting function for multiple items and packages is enabled)`,
  key1004724: `Enable left-side sorting rack`,
  key1004725: `Shelf matrix`,
  key1004726: `row`,
  key1004727: `column`,
  key1004728: `Enabling intermediate sorting shelves`,
  key1004729: `Enable right-hand sorting rack`,
  key1004730: `Preparation and sorting rack settings (only available when the automatic sorting function for multiple items and packages is enabled)`,
  key1004731: `Save the setting of see goods issuance`,
  key1004732: `You have unfinished sorting tasks, picking list number:`,
  key1004733: `Picking finish time`,
  key1004734: `Order picker`,
  key1004735: `Sorter`,
  key1004736: `Scan/enter the picking list number to start multiple item sorting:`,
  key1004737: `Reminder for regular sorting operations`,
  key1004738: `Reminder for stocking and sorting operations`,
  key1004739: `Sorter:`,
  key1004740: `Not printed`,
  key1004741: `Printed`,
  key1004742: `Creation time`,
  key1004743: `By picking order type`,
  key1004744: `Query the packed picking list, the creation time cannot be empty!`,
  key1004745: `Marking Success`,
  key1004746: `Please select`,
  key1004747: `Picking status`,
  key1004748: `Print status`,
  key1004749: `Number of SKUs`,
  key1004750: `No logistics selected`,
  key1004751: `Unspecified logistic channel`,
  key1004752: `Picking order no.:`,
  key1004753: `Print status：`,
  key1004754: `Bulk operation`,
  key1004755: `print pick list`,
  key1004756: `Mark as picked`,
  key1004757: `The weight of the package cannot be empty`,
  key1004758: `Small knot bag`,
  key1004759: `Package weight (g):`,
  key1004760: `The current SKU in the small package is shown in the following figure, totaling`,
  key1004761: `After confirming the quantity, please weigh it first and then perform the bagging operation.`,
  key1004762: `Printing labels and bagging`,
  key1004763: `Inventory`,
  key1004764: `Counting quantity`,
  key1004765: `Gains and losses`,
  key1004766: `To be inventory`,
  key1004767: `processing`,
  key1004768: `Inventory order:`,
  key1004769: `Warehouse:`,
  key1004770: `Picking reminder:`,
  key1004771: `Inventory order status:`,
  key1004772: `Dynamic inventory:`,
  key1004773: `Random inventory:`,
  key1004774: `Inventory operator:`,
  key1004775: `Staff:`,
  key1004776: `(signature/date)`,
  key1004777: `(Signature date)`,
  key1004778: `cancel printing`,
  key1004779: `Picking order no.`,
  key1004780: `Warehouse`,
  key1004781: `Success`,
  key1004782: `Picking orders`,
  key1004783: `The maximum number of packages per stocking and picking list cannot be empty!`,
  key1004784: `The maximum number of packages per regular picking list cannot be empty!`,
  key1004785: `Generating picking list`,
  key1004786: `Picking order generation rules:`,
  key1004787: `Go to the list of picking order`,
  key1004788: `Warehouse Management`,
  key1004789: `See the manifest`,
  key1004790: `Sorting list`,
  key1004791: `Temu Sample Order`,
  key1004792: `Temu Shipping Order`,
  key1004793: `SKU/Name/Variation`,
  key1004794: `Total quantity of items`,
  key1004795: `Number of items sorted`,
  key1004796: `Picking order`,
  key1004797: `outbound order`,
  key1004798: `package`,
  key1004799: `All outbound orders under the picking list have been changed`,
  key1004800: `Please scan the correct SKU/UPC`,
  key1004801: `No picking basket available`,
  key1004802: `The current product has no label address`,
  key1004803: `Multi item stocking sorting - end sorting`,
  key1004804: `Prompt for cancellation of picking list`,
  key1004805: `There is no outbound order in the picking list, and the picking list has been cancelled. Clicking the button will automatically end this operation.`,
  key1004806: `Failed to print`,
  key1004807: `Printing label successfully!`,
  key1004808: `Completed`,
  key1004809: `The quantity that should be shipped`,
  key1004810: `Container quantity of goods`,
  key1004811: `Quantity to be sorted`,
  key1004812: `print label`,
  key1004813: `Successfully printed Temu middle label!`,
  key1004814: `Failed to obtain Temu intermediate label address!`,
  key1004815: `Unable to obtain the address of the Temu middle label face sheet`,
  key1004816: `Product label selection`,
  key1004817: `Picking order no.:{pickingGoodsNo} After sorting, click【End the sorting】End this assignment`,
  key1004818: `Products you scan{sku}，The packages in the current picking list are not required or the required quantity has been met。`,
  key1004819: `Pick list of current sorting operation:`,
  key1004820: `End this sorting work`,
  key1004821: `SKU/UPC`,
  key1004822: `All sorting completed`,
  key1004823: `Product abnormal warning`,
  key1004824: `Possible reasons:`,
  key1004825: `1. You picked the products by mistake or picked too many products.`,
  key1004826: `2. The barcode of the product is pasted incorrectly.`,
  key1004827: `Please send the item to the exception handling department。`,
  key1004828: `Continue to scan other items (Enter)`,
  key1004829: `Pick list information:`,
  key1004830: `Outbound order information:`,
  key1004831: `Reset the package to not start sorting`,
  key1004832: `Remove the package from the current picking order and wait for a new picking order`,
  key1004833: `Print Temu Middle Label`,
  key1004834: `Please select product tag:`,
  key1004835: `Scanned quantity`,
  key1004836: `Unpicked quantity`,
  key1004837: `Packaged packages number`,
  key1004838: `Packaged items number`,
  key1004839: `Statistics project`,
  key1004840: `Picking order number`,
  key1004841: `Actual completion number`,
  key1004842: `Operator`,
  key1004843: `Total number of packages`,
  key1004844: `Working time (minutes)`,
  key1004845: `Packages (per minute)`,
  key1004846: `Items (per minute)`,
  key1004847: `Addressee`,
  key1004848: `Scanning time`,
  key1004849: `Printed`,
  key1004850: `unPrinted`,
  key1004851: `Subtotal of items`,
  key1004852: `Product information`,
  key1004853: `Picking review-end operation`,
  key1004854: `You are about to end the picking review of the pick list {pickingGoodsNo}`,
  key1004855: `A total of {scannedCount} people participated in this picking review`,
  key1004856: `Total packaging time {scannedTime} minutes`,
  key1004857: `Total (person.time) {userScannedTime} minutes`,
  key1004858: `You are about to end the picking review of the pick list {pickingGoodsNo}, but the system detects the following exception`,
  key1004859: `The following package have been scanned but the address label is being printed`,
  key1004860: `Save as Excel`,
  key1004861: `Manually confirm whether the address label has been printed normally.`,
  key1004862: `If you mark it as printed, the parcels will be deemed to have been packed normally when the picking review is mandatorily completed, and no new pick list can be generated for the parcels.`,
  key1004863: `If you mark as unprinted, these packages will be deemed unprinted when the picking review is mandatorily ended, and the system will remove these packages from the pick list, and you can regenerate a new pick list.`,
  key1004864: `The following packages have not been printed or the package was invalidated before printing.`,
  key1004865: `Unprinted packages will be removed from the pick list when the picking review is forced to end, and a new pick list will be generated again.`,
  key1004866: `If the package is voided during the packing of the picking order, there may be a surplus of the physical item.`,
  key1004867: `Under normal circumstances, the total quantity of this item should be equal the actual quantity your picked.`,
  key1004868: `The following packages are void after printing.`,
  key1004869: `After the address label is printed, the package is voided，It will cause the package to be packed normally. It is recommended to intercept it immediately，And in the[Recycle package]For confirmation。`,
  key1004870: `End current job`,
  key1004871: `Return to continue packaging`,
  key1004872: `waiting for operation`,
  key1004873: `Carrier / shipping method`,
  key1004874: `SKU & quantity`,
  key1004875: `Print product labels`,
  key1004876: `Failed to obtain barcode for fully managed goods on AliExpress!`,
  key1004877: `Name/Specification`,
  key1004878: `Check`,
  key1004879: `The current SKU corresponding order is a AliExpress fully managed JIT order, and the corresponding product barcode needs to be printed. Please note that the paper size needs to be 60mm * 30mm.`,
  key1004880: `The address of the compliance label sheet has not been obtained.`,
  key1004881: `The address of the sheet has not been obtained.`,
  key1004882: `Print successfully`,
  key1004883: `Scan SKU`,
  key1004884: `Load package information`,
  key1004885: `Checking quantity`,
  key1004886: `Send to printer`,
  key1004887: `Mark printed`,
  key1004888: `SKU error`,
  key1004889: `The SKU [ {warnSku} ] that you scanned or entered was not found in the current picking order`,
  key1004890: `Not matched to specified`,
  key1004891: `Current picking review pick list:`,
  key1004892: `Current operator:`,
  key1004893: `Exit current job`,
  key1004894: `Automatically match packages:`,
  key1004895: `Empty scanned items and rescan`,
  key1004896: `Outbound order for picking order`,
  key1004897: `You need to process the currently unprinted package first.`,
  key1004898: `As a result of the scan you submitted, the package information could not be found in the current pick list. Possible reasons:`,
  key1004899: `*There is an error in the products of the current package.`,
  key1004900: `*There are omissions or duplications in your scanning process.`,
  key1004901: `The picking order does not exist or the status has changed. Please refresh and try again.`,
  key1004902: `The outbound order scanned by the picking review does not exist`,
  key1004903: `Picking review and scanning outbound order is invalid`,
  key1004904: `SKU does not match the appropriate outbound order.`,
  key1004905: `Picking review is over`,
  key1004906: `There are delivery orders with incomplete packaging`,
  key1004907: `Name/Specification`,
  key1004908: `Scanned quantity cannot be empty!`,
  key1004909: `Scanned/Unscanned`,
  key1004910: `Already Screened`,
  key1004911: `Unscanned`,
  key1004912: `Print Temu labels`,
  key1004913: `(Partial packaging)`,
  key1004914: `(Packaged)`,
  key1004915: `(Completed)`,
  key1004916: `Exceeding the quantity on the picking list, please check the actual quantity of goods!`,
  key1004917: `SKU is not a required item for this order. Please confirm the order to which the item belongs!`,
  key1004918: `SKU cannot be empty!`,
  key1004919: `There are unfinished delivery orders. Please mark them as completed before ending the operation.`,
  key1004920: `All goods have been scanned, please end the assignment`,
  key1004921: `Exceeding the quantity on the picking list, please check the actual quantity of goods`,
  key1004922: `This delivery order has been marked as completed, please do not repeat the marking!`,
  key1004923: `Complete the entire order`,
  key1004924: `After the entire order editing is completed, no changes can be made. Please confirm that there are no errors before marking.`,
  key1004925: `Mark completion`,
  key1004926: `Abnormal completion prompt`,
  key1004927: `At the end of the current outbound order, the packaging operation will be carried out. After the marking is completed, the status will be transferred to the picking list to be generated. Please confirm that there are no errors before marking.`,
  key1004928: `Please mark the completion of the entire order after completing the small package.`,
  key1004929: `Print Temu barcode`,
  key1004930: `Current outbound order:`,
  key1004931: `Quantity of goods loaded:`,
  key1004932: `Sorting containers and corresponding outbound orders`,
  key1004933: `Picking box`,
  key1004934: `Unassigned`,
  key1004935: `Goods (picked/to be picked)`,
  key1004936: `Error reason`,
  key1004937: `Have not started sorting yet`,
  key1004938: `Sorting not completed`,
  key1004939: `Picked`,
  key1004940: `Unpicked`,
  key1004941: `You are about to end the picking list {{pickingGoodsNo}} But the system detected the following exception`,
  key1004942: `The following packages have not been sorted`,
  key1004943: `1.The product quantity are less than the quantity required by the pick list.`,
  key1004944: `2. In the previous sorting process, too many products were placed in a pick basket.`,
  key1004945: `3.The remaining products in the awaiting sorting area that have not been scanned.`,
  key1004946: `Under the condition that the quantity of goods to be picked is accurate, the quantity of the goods to be picked should be consistent with the quantity of the remaining goods in the waiting area。`,
  key1004947: `If you feel that there are too many mistakes to trace back，You can put all the items in the picking box back to the waiting area，`,
  key1004948: `and`,
  key1004949: `Cancel the sorting`,
  key1004950: `Picking list can start sorting operation again。`,
  key1004951: `Return to continue sorting`,
  key1004952: `Quantity to be scanned`,
  key1004953: `Actual scanning quantity`,
  key1004954: `Prompt for abnormal quantity of goods`,
  key1004955: `In this assignment, the following SKUs have not been scanned yet. Please double check the quantity of goods. If there is any loss of goods, please contact the management personnel in a timely manner.`,
  key1004956: `Return to Job`,
  key1004957: `The quantity of items that should be shipped`,
  key1004958: `The quantity of items in Picking box`,
  key1004959: `Reset successful!`,
  key1004960: `Multi item conventional sorting - end sorting`,
  key1004961: `Failed to obtain product barcode!`,
  key1004962: `Print product barcode`,
  key1004963: `No picking order details exist`,
  key1004964: `Mark printed successfully`,
  key1004965: `View by outbound order`,
  key1004966: `View by SKU`,
  key1004967: `Logistics distribution status`,
  key1004968: `Not issued`,
  key1004969: `Issued`,
  key1004970: `Remove from picking order`,
  key1004971: `Picked quantity`,
  key1004972: `Volume`,
  key1004973: `Unpicked`,
  key1004974: `Enter the outbound order no. to query`,
  key1004975: `Picking order details`,
  key1004976: `Whether to print:`,
  key1004977: `Created by:`,
  key1004978: `Delete the last entry？If the picking list is deleted, it will also be deleted！`,
  key1004979: `By shipping method`,
  key1004980: `Please check the data that needs to generate a picking list first!`,
  key1004981: `There is currently no data available for the current filtering results, unable to generate a picking list!`,
  key1004982: `Multiple outbound orders separated by commas`,
  key1004983: `Category:`,
  key1004984: `Generate picking list based on selection`,
  key1004985: `Generate picking orders (all)`,
  key1004986: `Download print control`,
  key1004987: `The barcode was not generated successfully. Please click again to print.`,
  key1004988: `Print SKU`,
  key1004989: `Delete`,
  key1004990: `Do not close automatically`,
  key1004991: `Show more`,
  key1004992: `Longer than input limit`,
  key1004993: `Add notes successfully!`,
  key1004994: `Failed to add notes!`,
  key1004995: `Failed to add`,
  key1004996: `Order number, support multiple separated by line`,
  key1004997: `Please enter the distributor merchant account, which supports multiple separate lines`,
  key1004998: `Please enter the distributor order number, which supports multiple separate lines`,
  key1004999: `Please enter the waybill number, which supports multiple separate lines`,
  key1005000: `Outbound person`,
  key1005001: `Generate Picker`,
  key1005002: `Logistics Sorter`,
  key1005003: `Shipment quantity (pieces)`,
  key1005004: `Allocate inventory time`,
  key1005005: `Generate picking list time`,
  key1005006: `Completion of picking time`,
  key1005007: `Sort completion time`,
  key1005008: `Packaging completion time`,
  key1005009: `Time to complete logistics sorting`,
  key1005010: `Outbound time`,
  key1005011: `Logistics carrier waybill number`,
  key1005012: `Quantity of shipments`,
  key1005013: `Operator`,
  key1005014: `SKU, support for multiple row-separated`,
  key1005015: `Export outbound details`,
  key1005016: `Active picture`,
  key1005017: `Activity Name`,
  key1005018: `Activity status`,
  key1005019: `Activity start time`,
  key1005020: `Event End Time`,
  key1005021: `Long term effectiveness`,
  key1005022: `Start Now`,
  key1005023: `Start activity confirmation immediately`,
  key1005024: `After confirmation, the activity will immediately start and be displayed on the mall. Please confirm whether to start?`,
  key1005025: `End Now`,
  key1005026: `Immediately End Activity Confirmation`,
  key1005027: `After confirmation, the activity will immediately end. Please confirm if it ends?`,
  key1005028: `Activity Name:`,
  key1005029: `Please enter the activity name keyword`,
  key1005030: `Activity status:`,
  key1005031: `New Activity`,
  key1005032: `entrance`,
  key1005033: `The image of Jingang District is empty. Please upload and try again.`,
  key1005034: `Name cannot be empty!`,
  key1005035: `Please upload first`,
  key1005036: `Picture of!`,
  key1005037: `The click to redirect address cannot be empty!`,
  key1005038: `Image successful`,
  key1005039: `Image failed`,
  key1005040: `Please enter the entrance name`,
  key1005041: `Image:`,
  key1005042: `Click to jump to:`,
  key1005043: `replace`,
  key1005044: `Renderings`,
  key1005045: `Jingang District`,
  key1005046: `Upload images`,
  key1005047: `(Recommended size: 60 * 60)`,
  key1005048: `Not filled in`,
  key1005049: `Effect Preview`,
  key1005050: `Jump target type cannot be empty`,
  key1005051: `The specified link address must be a link starting with https://or http://!`,
  key1005052: `Do not jump`,
  key1005053: `Jump target cannot be empty!`,
  key1005054: `Click to jump`,
  key1005055: `Jump Target Type:`,
  key1005056: `Jump target:`,
  key1005057: `Site Name`,
  key1005058: `Site Domain Name`,
  key1005059: `Site Description`,
  key1005060: `Please enter a site name`,
  key1005061: `View site information`,
  key1005062: `Edit Site Information`,
  key1005063: `Site domain name:`,
  key1005064: `Please enter a site domain name`,
  key1005065: `Site Description:`,
  key1005066: `Please enter a site description`,
  key1005067: `Homepage rotation chart`,
  key1005068: `Top advertising space`,
  key1005069: `Side advertising space`,
  key1005070: `Home page - advertising space below personal information`,
  key1005071: `Change Enable Status Prompt`,
  key1005072: `This operation will change whether the advertising space is visible on the mall end. Please confirm whether to continue with the change.`,
  key1005073: `Banner image:`,
  key1005074: `The advertising image is empty. Please upload and try again.`,
  key1005075: `Clicking on the redirect address cannot be empty!`,
  key1005076: `(Recommended size: 70 * 228)`,
  key1005077: `The banner image is empty. Please upload and try again.`,
  key1005078: `(Recommended height: 80px)`,
  key1005079: `(Recommended size: 228 * 70)`,
  key1005080: `The start time of the activity cannot be empty`,
  key1005081: `Match by new days`,
  key1005082: `Matching rule cannot be empty`,
  key1005083: `The number of new days cannot be empty`,
  key1005084: `activity`,
  key1005085: `Slogan:`,
  key1005086: `Product activities`,
  key1005087: `The end time of the activity cannot be empty`,
  key1005088: `Please check the products participating in the activity first!`,
  key1005089: `Please configure matching rules first!`,
  key1005090: `Unified pricing cannot be empty!`,
  key1005091: `The end time of the activity cannot be less than the start time of the activity!`,
  key1005092: `Unified pricing（`,
  key1005093: `Add as homepage tab:`,
  key1005094: `Is supplier information displayed`,
  key1005095: `Event start time:`,
  key1005096: `Select activity start time`,
  key1005097: `Event End Time:`,
  key1005098: `Select activity end time`,
  key1005099: `Is the price set uniformly`,
  key1005100: `Configure matching rules`,
  key1005101: `Matching rules:`,
  key1005102: `New Days:`,
  key1005103: `Remove Product Confirmation`,
  key1005104: `Event Information`,
  key1005105: `(Recommended size: 1200 * 160)`,
  key1005106: `Event Pricing`,
  key1005107: `Activity products`,
  key1005108: `Configuration Rules`,
  key1005109: `Batch removal`,
  key1005110: `Rule description:`,
  key1005111: `1. The system will automatically match products that meet a certain number of new days. For example, if you fill in 7 days, the system will match products that are within 7 days of today according to the approved time and add them to the activity.`,
  key1005112: `After removal, the product will no longer participate in this event, and the price may change. The system will remind the subscribed distributors.`,
  key1005113: `Remove products`,
  key1005114: `Rotation item`,
  key1005115: `The rotation chart is empty. Please upload and try again.`,
  key1005116: `Rotation item 1`,
  key1005117: `(Recommended size: 644 * 324)`,
  key1005118: `Delete Poll Entry`,
  key1005119: `Add carousel item`,
  key1005120: `Subsidy Rule Name`,
  key1005121: `Rule Status`,
  key1005122: `Add Subrule`,
  key1005123: `Freight subsidy`,
  key1005124: `Create subsidy rules`,
  key1005125: `Order Continuation`,
  key1005126: `piece`,
  key1005127: `Fee rules`,
  key1005128: `General accounting`,
  key1005129: `Handling fee = weight * unit price`,
  key1005130: `Continuous recosting`,
  key1005131: `Weight less than or equal to the first weight: handling fee = first weight charge`,
  key1005132: `Weight greater than first weight: handling fee = first weight charge rounded up (total weight-first weight)/unit weight of continued weight * unit price of continued weight`,
  key1005133: `fixed charges`,
  key1005134: `Handling fee = fee`,
  key1005135: `Add fee configuration`,
  key1005136: `Subsidy object cannot be empty`,
  key1005137: `Subsidy type cannot be empty`,
  key1005138: `Create sub rules`,
  key1005139: `Edit subsidy rules`,
  key1005140: `Edit Subrules`,
  key1005141: `The subsidy rules are not complete. Please fill them out completely and try again.`,
  key1005142: `The quantity of goods in the bill of lading must be an integer greater than or equal to 0`,
  key1005143: `The order delivery rate must be greater than or equal to 0`,
  key1005144: `The subsidy amount is not complete. Please fill it out completely and try again.`,
  key1005145: `Subsidy recipients:`,
  key1005146: `Subsidy type:`,
  key1005147: `Select time`,
  key1005148: `Multiple merchant accounts should be separated by commas or line breaks in English`,
  key1005149: `condition`,
  key1005150: `This name is visible to the customer, please name it reasonably`,
  key1005151: `Subsidy conditions:`,
  key1005152: `Add conditions`,
  key1005153: `Subsidy amount:`,
  key1005154: `The subrule subsidy will be superimposed with the main rule, please configure it reasonably`,
  key1005155: `Single bill of lading subsidy:`,
  key1005156: `0-1 kg subsidy:`,
  key1005157: `Subsidy per kilogram of continued weight:`,
  key1005158: `Maximum subsidy for single bill of lading:`,
  key1005159: `Successfully settled`,
  key1005160: `Enter Merchant ID`,
  key1005161: `Server selection`,
  key1005162: `Search:`,
  key1005163: `Yunmai Publishing`,
  key1005164: `By Name`,
  key1005165: `By Email`,
  key1005166: `More Roles`,
  key1005167: `Last Login Time`,
  key1005168: `Do you want to delete the current role?`,
  key1005169: `Search for character name`,
  key1005170: `Enter employee's name, mailbox, mobile phone number`,
  key1005171: `Account status:`,
  key1005172: `Manage staff roles`,
  key1005173: `Add new staff`,
  key1005174: `Add Roles`,
  key1005175: `Role name cannot be empty`,
  key1005176: `Edit Roles`,
  key1005177: `Role Name:`,
  key1005178: `Input Role Name`,
  key1005179: `Assembly and processing- `,
  key1005180: `Picking- `,
  key1005181: `Module`,
  key1005182: `New employee`,
  key1005183: `E-mail can not be empty`,
  key1005184: `View employees`,
  key1005185: `Edit Employees`,
  key1005186: `Basic Information`,
  key1005187: `Role`,
  key1005188: `Data permission`,
  key1005189: `Warehouse authority`,
  key1005190: `All data permissions in the warehouse`,
  key1005191: `Access to customer data`,
  key1005192: `All data permissions`,
  key1005193: `Please enter rule name.`,
  key1005194: `Please add a shipping method.`,
  key1005195: `At least choose one of delivery time or waybill number`,
  key1005196: `The real shipping method cannot be null.`,
  key1005197: `The account cannot be null.`,
  key1005198: `Rule name:`,
  key1005199: `Actual shipping method:`,
  key1005200: `Account:`,
  key1005201: `choose assigned logistics`,
  key1005202: `choose suitable logistics`,
  key1005203: `Deactivated, please modify and save again`,
  key1005204: `logistics setup`,
  key1005205: `time of arrival：less than`,
  key1005206: `Null`,
  key1005207: `have`,
  key1005208: `API docking`,
  key1005209: `Add logistics`,
  key1005210: `Logistics type:`,
  key1005211: `Choose logistics:`,
  key1005212: `Designated code of receiver:`,
  key1005213: `Sending address`,
  key1005214: `Collect address`,
  key1005215: `Return address`,
  key1005216: `Please check the logistics mode to be enabled.`,
  key1005217: `Copy this logistics channel?`,
  key1005218: `Input Name Search`,
  key1005219: `Logistics channel name/code:`,
  key1005220: `Add logistics channels`,
  key1005221: `Logistics mode not enabled`,
  key1005222: `Logistics only supports binding one channel!`,
  key1005223: `Are you sure you want to unlink?`,
  key1005224: `Unlink`,
  key1005225: `Please add the logistics first!`,
  key1005226: `Added successfully!`,
  key1005227: `Please choose a complete logistics method first!`,
  key1005228: `Linked logistics`,
  key1005229: `Add association`,
  key1005230: `Edit custom logistics`,
  key1005231: `Standard quotation`,
  key1005232: `Operating fee (yuan/ticket)`,
  key1005233: `Priority (g)`,
  key1005234: `Continuous weight unit weight (g)`,
  key1005235: `Continuous unit price (yuan)`,
  key1005236: `Special Country cannot be empty`,
  key1005237: `Logistics Service Provider (Carrier) cannot be empty`,
  key1005238: `You cannot add a delivery service with the same name!`,
  key1005239: `Partition`,
  key1005240: `Default partition`,
  key1005241: `Accessible country`,
  key1005242: `All countries`,
  key1005243: `Billing mode`,
  key1005244: `Weighting method`,
  key1005245: `Accounting formula`,
  key1005246: `manually synchronize`,
  key1005247: `synchronize after successfully creating logistics order`,
  key1005248: `synchronize after acquiring waybill number`,
  key1005249: `synchronize after successfully shipping out`,
  key1005250: `Discount price`,
  key1005251: `return address`,
  key1005252: `Address of recipient`,
  key1005253: `Return recipient address`,
  key1005254: `Delivered by buyer`,
  key1005255: `Domestic express delivery fee cannot be empty`,
  key1005256: `Edit Logistics Channel`,
  key1005257: `View logistics channels`,
  key1005258: `copy channel name`,
  key1005259: `Logistics channel code cannot be null.`,
  key1005260: `Receiver specified commit code cannot be empty`,
  key1005261: `shipCompanyId cannot be empty`,
  key1005262: `Performance Method cannot be blank`,
  key1005263: `Please improve the logistics document cancellation fee configuration first!`,
  key1005264: `The default out-of-zone billing model country cannot be empty`,
  key1005265: `Import failed, please check the import template content and try again!`,
  key1005266: `Not Bound`,
  key1005267: `Bound`,
  key1005268: `First priority`,
  key1005269: `Yuan`,
  key1005270: `Continuous weight`,
  key1005271: `Can not add the same name of the logistics provider service!`,
  key1005272: `Payment void fee cannot be empty!`,
  key1005273: `Order logistics fee can not be empty!`,
  key1005274: `Delivery method cannot be empty`,
  key1005275: `Collection time cannot be empty`,
  key1005276: `Delivery method:`,
  key1005277: `Domestic express delivery fee:`,
  key1005278: `If the "third party overseas warehouse" central warehouse is selected as the applicable warehouse (e. g. Wanyitong and Miyun warehouse), it is necessary to bind the logistics of the overseas warehouse platform in the "logistics channel binding" below, otherwise the distribution will fail;`,
  key1005279: `Carrier:`,
  key1005280: `Shipping country:`,
  key1005281: `Collection method:`,
  key1005282: `Delivery Services:`,
  key1005283: `Shipping method:`,
  key1005284: `Surface single template`,
  key1005285: `Waybill size`,
  key1005286: `Notes:`,
  key1005287: `(h) (excluding`,
  key1005288: `Basic information of channels`,
  key1005289: `type of custom logistics:`,
  key1005290: `no docking`,
  key1005291: `Excel docking`,
  key1005292: `Logistics solution code:`,
  key1005293: `Receiver specifies the commit code:`,
  key1005294: `Mode of performance:`,
  key1005295: `Logistics Carrier:`,
  key1005296: `Timeliness for reference:`,
  key1005297: `Insurance service:`,
  key1005298: `Size limit(cm):`,
  key1005299: `Applicable weight`,
  key1005300: `Perimeter limit(cm):`,
  key1005301: `The limitation of the longest side (cm):`,
  key1005302: `Volume limit(cm³):`,
  key1005303: `URL of tracking information:`,
  key1005304: `Collection point address information`,
  key1005305: `Domestic express delivery address selection:`,
  key1005306: `Using fixed address templates`,
  key1005307: `Use order address`,
  key1005308: `Logistics provider optional settings (default settings)`,
  key1005309: `Distribution scope and freight`,
  key1005310: `Delivery scope`,
  key1005311: `Billing model`,
  key1005312: `Quote from other channels`,
  key1005313: `Bulk import`,
  key1005314: `Add partition`,
  key1005315: `Freight Currency:`,
  key1005316: `Please note that when there is no discount, please enter 1, 20% discount, please enter 0.8.`,
  key1005317: `This fee is applied to the logistics after the order has been issued and the waybill number has been obtained, and the distributor will charge the logistics document voiding fee according to the time period by default when canceling;`,
  key1005318: `If the time at which the reseller cancels is not within the time frame below, this fee will not be charged.`,
  key1005319: `Whether to charge this fee:`,
  key1005320: `No charge`,
  key1005321: `collect`,
  key1005322: `Fee collection method:`,
  key1005323: `Fixed amount charged`,
  key1005324: `Charged in proportion to the order logistics fee`,
  key1005325: `Billing Currency:`,
  key1005326: `After successfully obtaining the waybill number`,
  key1005327: `Cancellation of orders requires a void fee`,
  key1005328: `To cancel an order, you need to pay the order logistics fee.`,
  key1005329: `make payment`,
  key1005330: `Applicable warehouse`,
  key1005331: `All self-owned warehouses`,
  key1005332: `Platform standard delivery settings`,
  key1005333: `No-fill-in bill number`,
  key1005334: `(default)`,
  key1005335: `Adding exceptional countries`,
  key1005336: `Side sheet printing settings`,
  key1005337: `Print the distribution list`,
  key1005338: `More warehouses`,
  key1005339: `Drag`,
  key1005340: `Logistics vendor/logistics channel`,
  key1005341: `Scope of application`,
  key1005342: `Platform/Account`,
  key1005343: `Freight area`,
  key1005344: `sku included`,
  key1005345: `Quantity range`,
  key1005346: `All`,
  key1005347: `New rules`,
  key1005348: `designated order source by rule`,
  key1005349: `/The designated shipping country/region by rules include`,
  key1005350: `Designated shipping method by rule`,
  key1005351: `Applicable platform:`,
  key1005352: `Applicable stores:`,
  key1005353: `Applicable package amount ($):`,
  key1005354: `Range of Shipping fee (buyer pay) ($):`,
  key1005355: `Included SKU:`,
  key1005356: `Support multiple SKUs, separated by commas or spaces`,
  key1005357: `Range of total quantity of products:`,
  key1005358: `Explanation of intelligent logistics matching rules`,
  key1005359: `the basic attribute of matching logistics channel`,
  key1005360: `Necessary process: find available logistics provider`,
  key1005361: `The order match  in the basic attribute of logistics channel`,
  key1005362: `1.size limit`,
  key1005363: `2.weight limit`,
  key1005364: `3.type limit`,
  key1005365: `4.delivery area limit`,
  key1005366: `=1，>1matching result=1, over; matching result>1, move on to the next step`,
  key1005367: `5. Logistics channels supported by the shipping warehouse`,
  key1005368: `logistics matching rules`,
  key1005369: `The result set that was successfully matched in the previous step runs logistics matching rules, matches through the rule engine, and matches from top to bottom`,
  key1005370: `Match the scope of application of logistics`,
  key1005371: `Optional process: Range of application`,
  key1005372: `，Users can customize the scope of application of logistics channels to match the scope of application of all channels`,
  key1005373: `freight/timeliness priority`,
  key1005374: `：necessary process: choose the lowest freight or fastest shipping`,
  key1005375: `Calculate the freight/timeliness of all eligible logistics channels, and select the lowest freight or the fastest logistics according to the priority that you have set`,
  key1005376: `Add Logistics Rules`,
  key1005377: `Selected shipping method:`,
  key1005378: `The scope of application of logistics channels`,
  key1005379: `Logistics name`,
  key1005380: `Associated logistics channels`,
  key1005381: `Link`,
  key1005382: `Distributor Logistics`,
  key1005383: `Logistics name:`,
  key1005384: `Associated logistics channels:`,
  key1005385: `tax rate`,
  key1005386: `The tax rate must be greater than or equal to 0 and a maximum of 2 decimal places are allowed`,
  key1005387: `The billing model country outside the default partition cannot be empty!`,
  key1005388: `Required fields cannot be empty!`,
  key1005389: `Content cannot be empty`,
  key1005390: `Scope of application:`,
  key1005391: `Applicable weight (g):`,
  key1005392: `Volume limit (cm):`,
  key1005393: `Province/State`,
  key1005394: `Street:`,
  key1005395: `AliTM:`,
  key1005396: `Pickup time:`,
  key1005397: `Proxy`,
  key1005398: `Withholding logistics fee configuration`,
  key1005399: `Basic information of the plan`,
  key1005400: `Delivery Settings on Express Line`,
  key1005401: `EDIS Logistics Settings`,
  key1005402: `Logistics Settings`,
  key1005403: `Select a shipping address:`,
  key1005404: `Please select a pickup address:`,
  key1005405: `Address:`,
  key1005406: `Select return address:`,
  key1005407: `Shipping mode and package time`,
  key1005408: `Delivery by sellers`,
  key1005409: `Customs clearance fee configuration`,
  key1005410: `Whether to charge customs clearance fees:`,
  key1005411: `Proportional configuration: declared value in`,
  key1005412: `At a rate of 150 EUR, calculated at the following tax rates`,
  key1005413: `Parcels exceeding 150 euros will be issued with logistics failure.`,
  key1005414: `Available:`,
  key1005415: `Applicable platforms cannot be empty.`,
  key1005416: `Carrier name`,
  key1005417: `Is the distributor available`,
  key1005418: `Logistics account`,
  key1005419: `Applicable platform`,
  key1005420: `Docking type`,
  key1005421: `Edit account`,
  key1005422: `Modify the scope of application`,
  key1005423: `Is the distributor available:`,
  key1005424: `Logistics company name:`,
  key1005425: `Failed to obtain the application of authorization callback address!`,
  key1005426: `Account name cannot be empty`,
  key1005427: `Personal name/company name cannot be empty!`,
  key1005428: `Address information cannot be empty!`,
  key1005429: `Account Name:`,
  key1005430: `Authorization status:`,
  key1005431: `Personal Name/Company Name:`,
  key1005432: `Phone:`,
  key1005433: `Address information:`,
  key1005434: `Authorize again`,
  key1005435: `Authorize`,
  key1005436: `Authorized`,
  key1005437: `Unauthorized`,
  key1005438: `EU agent`,
  key1005439: `Please select the IOSS to use`,
  key1005440: `Please choose the shop.`,
  key1005441: `Add Rule`,
  key1005442: `IOSS used:`,
  key1005443: `Condition type:`,
  key1005444: `Platform:`,
  key1005445: `Shop:`,
  key1005446: `This name is only used to better distinguish different IOSS`,
  key1005447: `By Store`,
  key1005448: `By platform`,
  key1005449: `manual order`,
  key1005450: `IOSS management`,
  key1005451: `IOSS rule configuration`,
  key1005452: `IOSS name`,
  key1005453: `IOSS number`,
  key1005454: `Use IOSS name`,
  key1005455: `Use IOSS number`,
  key1005456: `Applicable platforms/stores`,
  key1005457: `Applicable stores`,
  key1005458: `Enable IOSS confirmation`,
  key1005459: `Deactivate IOSS confirmation`,
  key1005460: `After enabling IOSS, relevant rules will be able to be matched. Please confirm whether to enable IOSS?`,
  key1005461: `After deactivating IOSS, the rules using this IOSS number will also be deactivated. Please confirm whether to deactivate IOSS?`,
  key1005462: `Enable IOSS rules`,
  key1005463: `Deactivate IOSS rule`,
  key1005464: `Please confirm whether to enable the rule?`,
  key1005465: `Please confirm whether to deactivate the rule?`,
  key1005466: `will be in accordance with the product in`,
  key1005467: `The sales price in the corresponding`,
  key1005468: `The price of the goods in the order is declared.`,
  key1005469: `When there is an IOSS number in the platform order,`,
  key1005470: `The IOSS number returned by the platform will be used first. If the IOSS number cannot be matched, the system will intercept the order.`,
  key1005471: `Add IOSS`,
  key1005472: `Declaration instructions:`,
  key1005473: `View tax rates`,
  key1005474: `Original price`,
  key1005475: `Sales Price:`,
  key1005476: `Adjusted price`,
  key1005477: `rate`,
  key1005478: `Image verification code cannot be empty`,
  key1005479: `Phone number format is incorrect!`,
  key1005480: `The phone number and picture verification code cannot be empty!`,
  key1005481: `E-mail format is incorrect!`,
  key1005482: `E-mail can not be empty!`,
  key1005483: `The verification code has been sent!`,
  key1005484: `E-mail format is incorrect.`,
  key1005485: `Verify identidy`,
  key1005486: `Set up a new mailbox`,
  key1005487: `Verification code:`,
  key1005488: `Phone verification code:`,
  key1005489: `Please enter the phone verification code`,
  key1005490: `new mail box:`,
  key1005491: `E-mail verification code:`,
  key1005492: `Please enter the email verification code`,
  key1005493: `mention`,
  key1005494: `cross`,
  key1005495: `Phone verification`,
  key1005496: `E-mail verification`,
  key1005497: `login password`,
  key1005498: `Changing passwords regularly helps account security`,
  key1005499: `Order exception notification`,
  key1005500: `Notice of discontinuation`,
  key1005501: `Price adjustment notice`,
  key1005502: `New notifications on the store`,
  key1005503: `Automatic Rule Notification`,
  key1005504: `Please check the data to be marked first!`,
  key1005505: `New date:`,
  key1005506: `New SPU:`,
  key1005507: `collected`,
  key1005508: `Mark all read`,
  key1005509: `Mark read`,
  key1005510: `Read Only Unread`,
  key1005511: `Distributor Name:`,
  key1005512: `currency：`,
  key1005513: `Modify Currency`,
  key1005514: `Modify phone`,
  key1005515: `Modify email`,
  key1005516: `IOSS name cannot be empty`,
  key1005517: `Edit IOSS`,
  key1005518: `IOSS number cannot be empty`,
  key1005519: `Please enter IM+10 digits`,
  key1005520: `IOSS Name:`,
  key1005521: `IOSS number:`,
  key1005522: `The original password cannot be empty`,
  key1005523: `New password cannot be empty`,
  key1005524: `update completed!`,
  key1005525: `The new password is inconsistent with the confirmed new password`,
  key1005526: `old password:`,
  key1005527: `New password:`,
  key1005528: `Confirm the new password again:`,
  key1005529: `The email and picture verification code cannot be empty!`,
  key1005530: `The phone number format is incorrect!`,
  key1005531: `The phone number cannot be empty!`,
  key1005532: `Set up a new phone`,
  key1005533: `New phone number:`,
  key1005534: `Please enter a new phone number`,
  key1005535: `Comprehensive`,
  key1005536: `Sales Volume`,
  key1005537: `Last New Time`,
  key1005538: `Please check the items that need to be cancelled as favorites`,
  key1005539: `Cancel collection successful!`,
  key1005540: `Please check the items you want to bookmark`,
  key1005541: `Product collection successful`,
  key1005542: `Please tick the products that need to download data`,
  key1005543: `Minimum inventory`,
  key1005544: `Maximum inventory`,
  key1005545: `¥ Lowest price`,
  key1005546: `¥ Maximum price`,
  key1005547: `Price:`,
  key1005548: `Associated Region/Country`,
  key1005549: `Related Commodity Details`,
  key1005550: `Please enter full manufacturer name`,
  key1005551: `Please enter a detailed address.`,
  key1005552: `Please enter your telephone number.`,
  key1005553: `Please enter an email`,
  key1005554: `Please enter your postal code`,
  key1005555: `Create Manufacturer`,
  key1005556: `Full name of manufacturer (consistent with registration document):`,
  key1005557: `Manufacturer Address-Country:`,
  key1005558: `Detailed address, specific to house number`,
  key1005559: `Telephone number:`,
  key1005560: `Email:`,
  key1005561: `Manufacturer's official website:`,
  key1005562: `Manufacturer Information`,
  key1005563: `Please enter the information you want to create a manufacturer.`,
  key1005564: `Responsible person name cannot be empty`,
  key1005565: `Please select a region`,
  key1005566: `Please select responsible country`,
  key1005567: `Responsible person mailbox cannot be empty`,
  key1005568: `Please enter the information of the overseas responsible person you want to create. (Enter at least one of the following)`,
  key1005569: `Please enter the compliance responsible person information you want to create.`,
  key1005570: `Create Compliance Leader`,
  key1005571: `Enter at least one of the responsible person's telephone number, email address and official website.`,
  key1005572: `Region:`,
  key1005573: `Name of responsible person:`,
  key1005574: `Country of Responsible Person:`,
  key1005575: `Telephone number of responsible person:`,
  key1005576: `Responsible Person Mailbox:`,
  key1005577: `Responsible official website:`,
  key1005578: `Responsible area/region`,
  key1005579: `Please select the region/address of the overseas compliance responsible person you created`,
  key1005580: `Compliance Responsible Person Information`,
  key1005581: `Bulk selected`,
  key1005582: `Manufacturer information, do you confirm to delete this information? After deletion, the association between the product and the product will also be removed.`,
  key1005583: `Manufacturer Information Name`,
  key1005584: `Associated Goods`,
  key1005585: `Are you sure to delete this information? After deletion, the product and its association will also be removed.`,
  key1005586: `Please select the manufacturer information to delete first`,
  key1005587: ` Confirm`,
  key1005588: `Manufacturer Information Name:`,
  key1005589: `Please provide the manufacturer information of products sold to the EU, the United States and Turkey on this page as soon as possible, and it should be consistent with the manufacturer information in the physical label of the product.`,
  key1005590: `Note: AliExpress the manufacturer information of the goods corresponding to the fully managed order, subject to the manufacturer information associated with the AliExpress backend goods.`,
  key1005591: `Region/Country`,
  key1005592: `Region/country selection`,
  key1005593: `The region/country for which you have selected the compliance owner is:`,
  key1005594: `Please select the region/country corresponding to the product's associated manufacturer.`,
  key1005595: `Region/Country:`,
  key1005596: `Please select the product you need to associate (multiple choices are available)`,
  key1005597: `If the product has been associated with other information in the above region/country, this operation will overwrite the previously associated content.`,
  key1005598: `The information of the responsible person, do you confirm to delete this information? After deletion, the relationship between the product and the product will also be removed.`,
  key1005599: `Name of Compliance Responsible Person`,
  key1005600: `Responsible area`,
  key1005601: `Please select the compliance owner information to delete first`,
  key1005602: `Name of Compliance Responsible Person:`,
  key1005603: `The European General Product Safety Regulation (GPSR) and the Turkish Regulation on Market Surveillance and Auditing of Products Provided on the Market by Means of Telecommunication have been enforced,`,
  key1005604: `Please provide the information of the EU responsible person and Turkey responsible person of the goods and the online goods sold to Europe and Turkey in the affiliated stores as soon as possible.`,
  key1005605: `(Please ensure that the associated goods are within the scope of the responsibilities of the EU responsible person and the Turkish responsible person). At the same time, the information of the EU responsible person and the Turkish responsible person needs to be reflected in the physical label of the goods.`,
  key1005606: `Note: The information of the overseas compliance responsible person of the commodity corresponding to the AliExpress fully managed order shall be subject to the information of the overseas compliance responsible person associated with the commodity in the AliExpress background.`,
  key1005607: `Create Compliance Owner`,
  key1005608: `Product information`,
  key1005609: `Platform Order`,
  key1005610: `Stock List`,
  key1005611: `commodity alias`,
  key1005612: `Commodity association`,
  key1005613: `Order Rules`,
  key1005614: `every other`,
  key1005615: `Every minute`,
  key1005616: `Available quantity=`,
  key1005617: `Order Exceeds`,
  key1005618: `Automatically cancel when hours are not boxed`,
  key1005619: `Inventory synchronization rules`,
  key1005620: `Product status synchronization rules`,
  key1005621: `Shop`,
  key1005622: `Listings Template`,
  key1005623: `Synchronization time`,
  key1005624: `Enable`,
  key1005625: `Inventory synchronization`,
  key1005626: `Product status synchronization`,
  key1005627: `Price synchronization`,
  key1005628: `Automatically adjust inventory to 0 when the product is discontinued`,
  key1005629: `Automatically synchronize the status to the listing tool when the product is discontinued`,
  key1005630: `After deletion, it will not be recoverable. Are you sure you want to delete it?`,
  key1005631: `Please select the applicable platform`,
  key1005632: `Please select an applicable store`,
  key1005633: `Add price synchronization rule`,
  key1005634: `Modify price synchronization rules`,
  key1005635: `Price synchronization rules`,
  key1005636: `This rule applies to automatic approval when there is a change in product price`,
  key1005637: `Adjust the price. By default, the delivery warehouse price selected at the time of publication is used for synchronization.`,
  key1005638: `Available quantity cannot be empty`,
  key1005639: `Add inventory rules`,
  key1005640: `Edit inventory rules`,
  key1005641: `Platforms`,
  key1005642: `Inventory quantity of regional warehouse`,
  key1005643: `It may be because the inventory quantity base is small, causing the inventory to be zero after floating. It may also be because the inventory base is large, and there is no change in the inventory after floating compared to before floating. Please set the floating ratio carefully.`,
  key1005644: `The formula calculates the result to be rounded, for example: the calculated result is 9.5, and the actual value is 10.`,
  key1005645: `Float Down:`,
  key1005646: `Synchronization time:`,
  key1005647: `Order timeout cannot be empty`,
  key1005648: `Order synchronization rules`,
  key1005649: `Add product status synchronization rule`,
  key1005650: `Modify product status synchronization rules`,
  key1005651: `This rule applies to the automatic adjustment of inventory to zero and synchronization with the status of the listed tools when the product is discontinued.`,
  key1005652: `When this option is checked in any rule, the product's suspension status will be synchronized to the listing tool.`,
  key1005653: `Change type`,
  key1005654: `Purchase arrival`,
  key1005655: `Allocate inventory`,
  key1005656: `Stock taking`,
  key1005657: `Change time`,
  key1005658: `Upload Status`,
  key1005659: `Uploaded`,
  key1005660: `Not uploaded`,
  key1005661: `The upload file format is incorrect. Please upload a barcode PDF file or PNG image`,
  key1005662: `Temu Store:`,
  key1005663: `Published`,
  key1005664: `Not published`,
  key1005665: `Number of published items`,
  key1005666: `Publication status`,
  key1005667: `Publish Store`,
  key1005668: `Listing status:`,
  key1005669: `Publication platform:`,
  key1005670: `Set up an alias`,
  key1005671: `Please enter an alias`,
  key1005672: `The alias has been associated `,
  key1005673: `After setting the commodity alias, the platform order appears, and the SKU and`,
  key1005674: `When the commodity SKU matching fails, the order commodity SKU can be matched`,
  key1005675: `The alias of the product is matched, and the order automatically matches the product after the match is successful, without the need for the distributor to manually select the match;`,
  key1005676: `Duplicate aliases are not allowed`,
  key1005677: `1. After setting the commodity alias, a platform order will appear, and the SKU and`,
  key1005678: `When the commodity SKU matching fails, the order commodity SKU can be used again.`,
  key1005679: `with`,
  key1005680: `The alias of the product is matched, and the order automatically matches the product after the match is successful, without the need for the distributor to manually select the match;`,
  key1005681: `2. The alias information of different SKU cannot be the same. Please do not enter the same alias information in the template file. If there is the same alias information entry, the system only takes the first entry into effect by default;`,
  key1005682: `1. After setting the commodity association relationship, a platform order will appear, and the SKU and`,
  key1005683: `When the commodity SKU matching fails, the order commodity can be passed.`,
  key1005684: `The relationship between the relationship and`,
  key1005685: `The product is matched, and the order automatically matches the product after the match is successful, without the need for the distributor to manually select the match; when`,
  key1005686: `When both "Alias" and "Association" are set for a product, "Association" is preferred for matching;`,
  key1005687: `2. The platform SKU in the same platform store is only allowed to establish an association relationship with one YMSSKU. Please do not enter the same platform store in the template file.`,
  key1005688: `Shop SKU information. If there are SKU information entries on the same platform, the system only takes the first entry into effect by default;`,
  key1005689: `Checked`,
  key1005690: `There are items in the list`,
  key1005691: `Sales records have been generated. Please choose whether to regenerate them?`,
  key1005692: `Partially discontinued`,
  key1005693: `Own inventory`,
  key1005694: `Sales within the past 30 days`,
  key1005695: `Compliance Responsible Person`,
  key1005696: `(Associated)`,
  key1005697: `(not associated)`,
  key1005698: `On-shelf time`,
  key1005699: `Collection time`,
  key1005700: `Sales Information`,
  key1005701: `Generate sales time`,
  key1005702: `Export product information`,
  key1005703: `Cancel Favorite`,
  key1005704: `Republish`,
  key1005705: `Set up associations`,
  key1005706: `Please enter the product SPU, which supports multiple line separations`,
  key1005707: `Product SKU`,
  key1005708: `Please enter the product SKU, which supports multiple line separations`,
  key1005709: `Please enter the product title, which supports multiple line separations`,
  key1005710: `Please enter the supplier name, supporting multiple line separated names`,
  key1005711: `Please enter the supplier number, which supports multiple separate lines`,
  key1005712: `Basic information of the product`,
  key1005713: `Basic Product Information Table`,
  key1005714: `Product Image`,
  key1005715: `Rotation chart`,
  key1005716: `Attribute Graph`,
  key1005717: `Published Platform`,
  key1005718: `Published stores`,
  key1005719: `Unpublished Platform`,
  key1005720: `Unpublished shop`,
  key1005721: `Exceeding the number of single downloads`,
  key1005722: `You can download up to 10 products at a time. Please reselect and download.`,
  key1005723: `Please check the data to cancel the collection first!`,
  key1005724: `Please check the data to be operated first!`,
  key1005725: `Favorite status:`,
  key1005726: `Collection time:`,
  key1005727: `Sales Information:`,
  key1005728: `No child option`,
  key1005729: `please enter an integer`,
  key1005730: `Generate sales information prompt`,
  key1005731: `Import Product Alias`,
  key1005732: `Import Commodity Association Relationship`,
  key1005733: `Batch generation of sales materials`,
  key1005734: `Batch export of product information`,
  key1005735: `Batch Cancel Favorites`,
  key1005736: `Ignore generated`,
  key1005737: `Generate`,
  key1005738: `3. Support extensions:`,
  key1005739: `After setting the commodity association relationship, the platform order appears, and the SKU and`,
  key1005740: `When the item SKU matching fails,`,
  key1005741: `Order goods can be associated`,
  key1005742: `The goods are matched, and the order automatically matches the goods after the match is successful,`,
  key1005743: `No need for distributors to manually select matches; when`,
  key1005744: `When both Alias and Association are set for the product,`,
  key1005745: `Priority is given to "association relationship" for matching; "platform", "store" and "platform commodity SKU" need to be completed,`,
  key1005746: `The corresponding association relationship will be created;`,
  key1005747: `Please input SKU`,
  key1005748: `This SKU has been associated`,
  key1005749: `Forming an association`,
  key1005750: `Platform product SKU:`,
  key1005751: `Only one binding relationship is allowed for a platform product`,
  key1005752: `Available quantity of goods`,
  key1005753: `Not generated`,
  key1005754: `Generating`,
  key1005755: `Generated successfully`,
  key1005756: `Generation failed`,
  key1005757: `Generate Status`,
  key1005758: `To be generated`,
  key1005759: `Initiate generation of sales time`,
  key1005760: `Failure reason`,
  key1005761: `Initiator`,
  key1005762: `Stop generating`,
  key1005763: `Only the status to be generated can stop generating sales data`,
  key1005764: `Please check the data you want to stop generating first!`,
  key1005765: `Stop generating sales information confirmation`,
  key1005766: `We are currently working to stop generating sales data. Once confirmed, all tasks that have not been generated will be cancelled. If you need to regenerate them, you will need to redo the operation in your favorite products. Please confirm if you want to stop generating them?`,
  key1005767: `Please enter the product SPU, which supports multiple line separations`,
  key1005768: `Product title:`,
  key1005769: `Initiated generation time:`,
  key1005770: `Originator:`,
  key1005771: `Expected`,
  key1005772: `Generate completed in minutes`,
  key1005773: `Batch stop generating sales information`,
  key1005774: `Inventory priority configuration`,
  key1005775: `Use inventory priority`,
  key1005776: `Whether to wait for in transit inventory`,
  key1005777: `Prioritize the use of other`,
  key1005778: `Stock in warehouse`,
  key1005779: `Prioritize the use of my own inventory with ownership rights`,
  key1005780: `wait for`,
  key1005781: `Don't wait`,
  key1005782: `View & Edit Custom Content`,
  key1005783: `On the 7th:`,
  key1005784: `On the 14th:`,
  key1005785: `Recent sales`,
  key1005786: `My available inventory`,
  key1005787: `My in transit inventory`,
  key1005788: `Average cost of goods`,
  key1005789: `The starting range of SKU inventory cannot be greater than the ending range of SKU inventory`,
  key1005790: `SKU inventory range:`,
  key1005791: `Export inventory`,
  key1005792: `Original SKU`,
  key1005793: `Available quantity of original customized goods`,
  key1005794: `The commodity is a customized commodity, and the original SPU represents the SPU of the original basic customized commodity template.`,
  key1005795: `Original SPU:`,
  key1005796: `get the original product id exception!`,
  key1005797: `Custom goods inventory (pieces)`,
  key1005798: `Sales volume in the past 30 days (pieces)`,
  key1005799: `Original SPU`,
  key1005800: `Please enter the original SPU, support multiple separated by line`,
  key1005801: `Please enter the original SKU, support multiple separated by rows`,
  key1005802: `Please enter the product name, support multiple separated by line`,
  key1005803: `Custom goods inventory`,
  key1005804: `Custom goods inventory:`,
  key1005805: `Custom goods sales status:`,
  key1005806: `Select Duration`,
  key1005807: `Store duration`,
  key1005808: `Price CNY`,
  key1005809: `1 month`,
  key1005810: `3 months`,
  key1005811: `6 months`,
  key1005812: `12 months`,
  key1005813: `Open shop`,
  key1005814: `Renewal Confirmation`,
  key1005815: `Confirm renewal`,
  key1005816: `Recharge in...`,
  key1005817: `Successful opening`,
  key1005818: `Renewal success`,
  key1005819: `Failed to open`,
  key1005820: `Renewal failed`,
  key1005821: `Authorization status`,
  key1005822: `Go to Authorization`,
  key1005823: `First authorization time`,
  key1005824: `Authorization update time`,
  key1005825: `Thoroughfare`,
  key1005826: `Expiration time`,
  key1005827: `Permanently Effective`,
  key1005828: `Not opened`,
  key1005829: `Expired`,
  key1005830: `Open`,
  key1005831: `Renewal`,
  key1005832: `Authorization successful!`,
  key1005833: `Successfully added account!`,
  key1005834: `Please enter the code and account name`,
  key1005835: `If you need eDIS to ship without adding a store, please bind the eBay ID to eDIS before adding a store.`,
  key1005836: `When a store has been added, if eDIS shipment is required, please bind eDIS to eBay ID before re authorizing the store.`,
  key1005837: `New Role`,
  key1005838: `View Role`,
  key1005839: `Role description:`,
  key1005840: `Please enter a role description`,
  key1005841: `Permission allocation`,
  key1005842: `Role Name`,
  key1005843: `Role Description`,
  key1005844: `Number of users (enabled)`,
  key1005845: `When a user is already associated with a role, the role cannot be deleted.`,
  key1005846: `Are you sure you want to delete this role?`,
  key1005847: `After deleting this role, it will not be recoverable. Are you sure you want to delete it?`,
  key1005848: `Successfully deleted the role!`,
  key1005849: `Add Role`,
  key1005850: `account type`,
  key1005851: `Main account`,
  key1005852: `Sub account`,
  key1005853: `Account Role`,
  key1005854: `View Users`,
  key1005855: `Add User`,
  key1005856: `Edit User`,
  key1005857: `Successfully added, failed to update user role authorization for the shelved tool!`,
  key1005858: `Generate password`,
  key1005859: `Shop permissions`,
  key1005860: `change Password`,
  key1005861: `Please enter your phone number, email, or name`,
  key1005862: `After changing the password, the original password will no longer be usable. Please modify it with caution!`,
  key1005863: `Are you sure to unfollow?`,
  key1005864: `Please enter the supplier name`,
  key1005865: `Number of fans:`,
  key1005866: `enter a shop`,
  key1005867: `Refund of goods cost`,
  key1005868: `Refund for package handling`,
  key1005869: `Logistics refund`,
  key1005870: `Domestic express refund`,
  key1005871: `Order Cancellation Fee`,
  key1005872: `Cost of goods`,
  key1005873: `Parcel handling fee`,
  key1005874: `Logistics fees`,
  key1005875: `Initialized quota`,
  key1005876: `Remaining balance`,
  key1005877: `Continue to pay`,
  key1005878: `The payment is successful and the account is being credited`,
  key1005879: `Recharge successfully`,
  key1005880: `Recharge failed`,
  key1005881: `Third party voucher number:`,
  key1005882: `When the order is not shipped, the order consumption amount is the withheld amount.`,
  key1005883: `When your available balance is insufficient, the system will automatically use your credit limit to pay for you; when you recharge, the recharge amount will be used to repay your credit limit first;`,
  key1005884: `Event description`,
  key1005885: `Credit limit modification record`,
  key1005886: `Your current available balance is`,
  key1005887: `The withholding amount is`,
  key1005888: `The total credit limit is`,
  key1005889: `Record`,
  key1005890: `The current amount used is`,
  key1005891: `Current exchange rate: 1`,
  key1005892: `The account currency is`,
  key1005893: `Recharge amount cannot be empty`,
  key1005894: `The top-up amount format is incorrect.`,
  key1005895: `The recharge amount cannot be less than or equal to 0`,
  key1005896: `The recharge amount cannot exceed 100,000,000`,
  key1005897: `=== Payment failed ===`,
  key1005898: `Recharge your balance`,
  key1005899: `Other amounts`,
  key1005900: `"Processing has already started. Cancellation of the order will not be refunded.`,
  key1005901: `Order Cancellation Fee`,
  key1005902: `The logistics waybill number was successfully obtained when the order was canceled.`,
  key1005903: `min, need to charge logistics document void fee`,
  key1005904: `Withholding logistics fee refund`,
  key1005905: `Logistics fee deduction`,
  key1005906: `Withholding service fee refund`,
  key1005907: `Deduction of actual service fee`,
  key1005908: `Deduction`,
  key1005909: `refund`,
  key1005910: `Serial number of transaction`,
  key1005911: `Transaction Type`,
  key1005912: `Trading Hours`,
  key1005913: `Transaction amount`,
  key1005914: `Balance before transaction`,
  key1005915: `Balance after transaction`,
  key1005916: `Available credit before transaction`,
  key1005917: `Available credit after transaction`,
  key1005918: `Please enter the transaction serial number, multiple numbers can be separated by lines`,
  key1005919: `Please enter the relevant document number, multiple numbers can be separated by lines`,
  key1005920: `Trading hours:`,
  key1005921: `Transaction Type:`,
  key1005922: `Export expense details`,
  key1005923: `item pricing`,
  key1005924: `Actual paid unit price`,
  key1005925: `Order quantity`,
  key1005926: `Received quantity`,
  key1005927: `Some goods have not arrived in the warehouse, and some have been refunded.`,
  key1005928: `Number of items canceled by user`,
  key1005929: `Total weight of goods (g)`,
  key1005930: `Total value of goods`,
  key1005931: `Paid`,
  key1005932: `Supplier has shipped`,
  key1005933: `Completed`,
  key1005934: `To be prepared`,
  key1005935: `Not completed`,
  key1005936: `(Cancelled)`,
  key1005937: `Stock up to `,
  key1005938: `Cancellation Amount:`,
  key1005939: `Commodity delivery warehouse selection`,
  key1005940: `Matching goods delivery warehouse`,
  key1005941: `Goods delivery warehouse can not be empty!`,
  key1005942: `Matching delivery warehouse cannot be empty`,
  key1005943: `Match shipping warehouse:`,
  key1005944: `Quantity (piece)`,
  key1005945: `Subtotal`,
  key1005946: `Temu store cannot be empty`,
  key1005947: `Temu order number cannot be empty`,
  key1005948: `Please check the items to be removed first!`,
  key1005949: `Edit shipping address`,
  key1005950: `Do you want to delete the current shipping address?`,
  key1005951: `Cancel prompt`,
  key1005952: `After canceling, the already filled content will not be saved. Are you sure you want to cancel?`,
  key1005953: `Continue filling in`,
  key1005954: `The order information is incomplete. Please complete the order information before submitting!`,
  key1005955: `Please select a Temu store`,
  key1005956: `Please fill in the Temu order number`,
  key1005957: `You haven't added any products yet`,
  key1005958: `Processing fee=3+(quantity of goods -1) * 0.5`,
  key1005959: `The total amount payable will be withheld when submitting the order, please ensure that the account has sufficient balance.`,
  key1005960: `2. For shipping orders, please be sure to place orders according to the TEMU backstage stock order. Multiple stock orders cannot be placed in the same place.`,
  key1005961: `order under.`,
  key1005962: `Collapse Address`,
  key1005963: `More addresses`,
  key1005964: `Shipping Order`,
  key1005965: `Sample order`,
  key1005966: `Delete product`,
  key1005967: `Please note:`,
  key1005968: `1. For sample orders, if multiple SKUs need to be shipped under one SPU, please ensure that the SKUs are placed within one order for order placement.`,
  key1005969: `Product quantity:`,
  key1005970: `Total weight of goods (g):`,
  key1005971: `Shipping Address`,
  key1005972: `Set as default address`,
  key1005973: `Click to select the picture customized by the third-party platform buyer below to customize the customized information configuration of the product. (Multiple choices available)`,
  key1005974: `The responsible person and manufacturer of compliance information cannot be empty!`,
  key1005975: `Please select shipping address!`,
  key1005976: `Commodity quantity and commodity delivery warehouse can not be empty!`,
  key1005977: `Please add products first!`,
  key1005978: `Please select the delivery method first!`,
  key1005979: `Please configure IOSS first!`,
  key1005980: `The account balance is sufficient and the withholding is successful`,
  key1005981: `Identify goods and shipping information`,
  key1005982: `Select the order item and its corresponding shipping warehouse`,
  key1005983: `Order identification and logistics selection`,
  key1005984: `The system will automatically split the order according to the corresponding delivery warehouse of the goods.`,
  key1005985: `Click Submit to create order`,
  key1005986: `Responsible Person:`,
  key1005987: `Quantity:`,
  key1005988: `Subtotal:`,
  key1005989: `Compliance Information`,
  key1005990: `Due to the mandatory implementation of the European General Product Safety Regulation (GPSR) and the Turkish Regulation on Market Surveillance and Auditing of Products on the Market by Means of Telecommunication, the shipping address is required by this order,`,
  key1005991: `The order product needs to be pasted with the corresponding compliance label. The system detects that you have not associated the product with compliance information (or some compliance information is missing ", and the label cannot be generated;`,
  key1005992: `Click here to create`,
  key1005993: `Order Logistics Selection`,
  key1005994: `IOSS Configuration`,
  key1005995: `Log Details`,
  key1005996: `Before adjustment:`,
  key1005997: `After adjustment:`,
  key1005998: `Enter IOSS`,
  key1005999: `Using IOSS:`,
  key1006000: `Additional costs will be incurred when logistics is remitted,`,
  key1006001: `will be charged on behalf.`,
  key1006002: `Go to configuration`,
  key1006003: `This order will be subject to additional charges`,
  key1006004: `Matching logistics can not be empty!`,
  key1006005: `Match logistics`,
  key1006006: `Matching logistics:`,
  key1006007: `Order Shipment Warehouse:`,
  key1006008: `After changing the logistics, the customs clearance fee will be recalculated, and the originally charged fee will be refunded to this order`,
  key1006009: `Customs clearance fees`,
  key1006010: `Reason for failure:`,
  key1006011: `Address update failed`,
  key1006012: `Tag processed`,
  key1006013: `Retry`,
  key1006014: `Modify logistics address`,
  key1006015: `The buyer modifies the address. The information before and after the modification is as follows. Please confirm whether to modify the address of Ali International Order?`,
  key1006016: `Original Address:`,
  key1006017: `receiver's name`,
  key1006018: `Contact information`,
  key1006019: `New address:`,
  key1006020: `No goods in the order`,
  key1006021: `After the order is canceled, the order will not be shipped, and a handling fee will be charged for the cancellation of the boxed order.`,
  key1006022: `Fees, OK to cancel the order?`,
  key1006023: `Whole order cancellation`,
  key1006024: `Cancel some products`,
  key1006025: `When canceling some products, the cancelled quantity cannot be all empty!`,
  key1006026: `When canceling some products, the total quantity of cancellations cannot be greater than or equal to the total order quantity!`,
  key1006027: `Confirm Cancel Order`,
  key1006028: `Order reason, this reason is only`,
  key1006029: `Visible.`,
  key1006030: `Cancel product:`,
  key1006031: `Please note that this order will be voided after partial cancellation and a new`,
  key1006032: `Order!`,
  key1006033: `Collection, sending to ymsWarehouseName warehouse`,
  key1006034: ` Order trajectory`,
  key1006035: `Order confirmed, waiting for merchant to pick up`,
  key1006036: `The order has been picked and is awaiting merchant review`,
  key1006037: `The order has been reviewed and completed, waiting for the merchant to package it`,
  key1006038: `Express delivery in transit, currently being sent to ymsWarehouseName, tracking number: expressageNo`,
  key1006039: `YmsWarehouseName has been received and is awaiting warehouse processing`,
  key1006040: `YmsWarehouseName is being stocked`,
  key1006041: `Goods picking completed, waiting for warehouse packaging`,
  key1006042: `The goods are packaged and waiting for the warehouse to pack them`,
  key1006043: `The warehouse has shipped and ShippingMethodName has been notified for logistics pickup`,
  key1006044: `The order has been shipped out and the final logistics trajectory is required. Please check the official logistics website or third-party platform by yourself`,
  key1006045: `Order cancelled`,
  key1006046: `Order trajectory`,
  key1006047: `Please choose to cancel the scope`,
  key1006048: `Please select the reason for cancellation`,
  key1006049: `Cancel platform order`,
  key1006050: `Platform order transaction number`,
  key1006051: `When canceling some products, canceling all products cannot be checked!`,
  key1006052: `Please check the data that needs to be cancelled first!`,
  key1006053: `There are currently no products in the current platform order`,
  key1006054: `There is an issue with the buyer providing the address`,
  key1006055: `Cancel the order at the buyer's request`,
  key1006056: `Buyer unpaid`,
  key1006057: `Product out of stock or other performance issues`,
  key1006058: `The buyer no longer wants the product`,
  key1006059: `The buyer bought the wrong product`,
  key1006060: `There is a dispute between the buyer and seller regarding this product`,
  key1006061: `Product out of stock`,
  key1006062: `Only defective products remain`,
  key1006063: `Arbitration cancellation`,
  key1006064: `Other reasons`,
  key1006065: `The buyer did not collect the order`,
  key1006066: `Unable to deliver to the region`,
  key1006067: `The order was lost during transportation`,
  key1006068: `Customer requests cancellation`,
  key1006069: `Pricing error`,
  key1006070: `Fraudulent transactions, cancellation of orders`,
  key1006071: `Buyer address not available`,
  key1006072: `Unable to deliver`,
  key1006073: `The item is damaged`,
  key1006074: `Item returned to sender`,
  key1006075: `Cancel scope:`,
  key1006076: `Please select the reason for platform order cancellation, which is visible to buyers.`,
  key1006077: `When canceling a platform order, the system will automatically call the platform interface to cancel the order and refund the buyer at the same time!`,
  key1006078: `A handling fee will be charged for cancellation of a packed order, and this order will be charged after cancellation.`,
  key1006079: `Matching warehouse`,
  key1006080: `Warehouse selection:`,
  key1006081: `Payment Status`,
  key1006082: `Go to pay`,
  key1006083: `Update Status`,
  key1006084: `Payment Confirmation`,
  key1006085: `Is the payment successful?`,
  key1006086: `State Not Updated Prompt`,
  key1006087: `The status of the obtained Ali international order information is still unpaid, please try again later or manually mark it as successful.`,
  key1006088: `Manual marking`,
  key1006089: `Since this order is fulfilled by Ali International's multi-merchant, it has been automatically split into different orders and needs to be paid according to the order.`,
  key1006090: `Quantity to be replaced`,
  key1006091: `Must be less than the order quantity`,
  key1006092: `SKU information in the original order`,
  key1006093: `Replace SKU information`,
  key1006094: `Replace the product with the current one`,
  key1006095: `The quantity of replacement products must be less than the order quantity`,
  key1006096: `No replacement order item selected`,
  key1006097: `No replacement quantity entered for the selected product`,
  key1006098: `Please select a replacement product`,
  key1006099: `Submitting`,
  key1006100: `Replace order item`,
  key1006101: `Order!`,
  key1006102: `Confirm replacement`,
  key1006103: `Please select the product and quantity to be replaced`,
  key1006104: `calibration in...`,
  key1006105: `Address Change Prompt`,
  key1006106: `The current logistics mode does not support this region. The logistics mode will be left empty after the address is changed. Please re-match the logistics in the pending status. Please confirm whether to change the address?`,
  key1006107: `Identify changes`,
  key1006108: `Modifying`,
  key1006109: `Modify receipient information`,
  key1006110: `Buyer's name:`,
  key1006111: `Address 1:`,
  key1006112: `Address 2:`,
  key1006113: `Province / State:`,
  key1006114: `The currently selected destination country needs to enter IOSS related information`,
  key1006115: `The current selected destination country needs to configure the order commodity compliance information.`,
  key1006116: `Please note that after modifying the address information, this order will be voided and a new order will be generated!`,
  key1006117: `Processing Completed`,
  key1006118: `Expected `,
  key1006119: ` Arrival of products`,
  key1006120: `This time is the estimated arrival time of the supplier's warehouse, and it will take 2-3 days until the final package is sent out.`,
  key1006121: `Outbound order no.`,
  key1006122: `Name of consignee`,
  key1006123: `Buyer identification number`,
  key1006124: `Detailed Address 1`,
  key1006125: `Detailed Address 2`,
  key1006126: `Shipping method`,
  key1006127: `Logistics provider weighing (g)`,
  key1006128: `Freight for logistics providers`,
  key1006129: `Waiting for logistics collection`,
  key1006130: `Supplier Stocking`,
  key1006131: `Logistics collected`,
  key1006132: `Automatic platform order creation`,
  key1006133: `There are customized goods in the order. Before the operation system does not mark the cancellation, only the non-customized goods in the order are allowed to be replaced.`,
  key1006134: `There are customized products in the order. If you need to cancel the order, please contact the platform operation.`,
  key1006135: `order details`,
  key1006136: `Billing weight (`,
  key1006137: `Due to price adjustment, payment cannot be made at the moment when the supplier accepts the order`,
  key1006138: `The product has been discontinued`,
  key1006139: `Partial cancellation successful!`,
  key1006140: `Cancellation quantity cannot be empty`,
  key1006141: `Partial cancellation`,
  key1006142: `Order Commodity Information`,
  key1006143: `Order number, support multiple separated by line`,
  key1006144: `Third party tracking number:`,
  key1006145: `Failed to obtain the waybill number, please contact the platform operation`,
  key1006146: `Parcels that need to be sent by courier to the collection point will be subject to an additional domestic courier fee. The specific fees can be viewed by clicking on the corresponding channel in the self owned logistics module.`,
  key1006147: `Order Remark`,
  key1006148: `Destination And Buyer Information`,
  key1006149: `Destination:`,
  key1006150: `Buyer ID:`,
  key1006151: `Auto cancel countdown:`,
  key1006152: `Product fee:`,
  key1006153: `Deduction of processing fee:`,
  key1006154: `Withholding processing fee:`,
  key1006155: `Actual deduction of logistics fee:`,
  key1006156: `Customs clearance fees:`,
  key1006157: `Logistics fees withheld:`,
  key1006158: `Cancel order confirmation`,
  key1006159: `Whether to confirm the cancellation of the order, the canceled order will be moved to the "canceled" list, the order information cannot be directly restored, please operate with caution!`,
  key1006160: `All `,
  key1006161: `Failed to issue logistics`,
  key1006162: `Please enter a third-party tracking number, which supports multiple separate lines`,
  key1006163: `Please enter the waybill number, which supports multiple separate lines`,
  key1006164: `Deduction processing fee (CNY)`,
  key1006165: `Withholding Processing Fee (CNY)`,
  key1006166: `Pending`,
  key1006167: `Third Party Orders:`,
  key1006168: `Please enter a third-party order, support multiple separated by lines`,
  key1006169: `Order Notes:`,
  key1006170: `Payment Status:`,
  key1006171: `Add Order`,
  key1006172: `Bulk Import Orders`,
  key1006173: `Batch Payment`,
  key1006174: `Additional account information:`,
  key1006175: `Complete account information`,
  key1006176: `Non`,
  key1006177: `Confirm`,
  key1006178: `Orders?`,
  key1006179: `After execution of the shipment,`,
  key1006180: `The status of the Temu order will be automatically transferred, and the checked order will be sent as a logistics package.`,
  key1006181: `Confirming pass`,
  key1006182: `Fulfillment AliExpress fully managed JIT orders, due to more restrictions on JIT orders, in the event of platform penalties,`,
  key1006183: `Will be handled in accordance with the after-sales terms, no additional compensation, please confirm whether to receive the order?`,
  key1006184: ` Platform order information`,
  key1006185: `PO Number:`,
  key1006186: `Platform order product information`,
  key1006187: `Pending orders`,
  key1006188: `Is there a refund:`,
  key1006189: `Whether to label shipment:`,
  key1006190: `Execution Shipment Status:`,
  key1006191: `Order quantity:`,
  key1006192: `Buyer's note:`,
  key1006193: `Platform order exception`,
  key1006194: `Distribution Order Information`,
  key1006195: `Ali International Station Order`,
  key1006196: `Shipping logistics:`,
  key1006197: `Distribution Order Commodity Information`,
  key1006198: `Distribution Order Status`,
  key1006199: `Distribution Order Amount`,
  key1006200: `Abnormal distribution order`,
  key1006201: `Match products`,
  key1006202: `Process orders`,
  key1006203: `Mark as shipped`,
  key1006204: `Confirm waiting`,
  key1006205: `Taking orders`,
  key1006206: `Modify Logistics`,
  key1006207: `Temu delivery warehouse match`,
  key1006208: `Associated Compliance Information`,
  key1006209: `Order placed`,
  key1006210: `Marked for shipment`,
  key1006211: `Platform order has been cancelled`,
  key1006212: `Unmatched goods`,
  key1006213: `Failed to match logistics`,
  key1006214: `PO Number`,
  key1006215: `Affiliated platform`,
  key1006216: `Platform order label shipping status`,
  key1006217: `Order Original SKU * Quantity`,
  key1006218: `Is there a refund for platform orders`,
  key1006219: `Platform order abnormal status`,
  key1006220: `Customer ID`,
  key1006221: `Customer Name`,
  key1006222: `Buyer Notes`,
  key1006223: `Distribution Order Number`,
  key1006224: `Distribution order SKU information`,
  key1006225: `Pay-as-you-go processing fee (CNY)`,
  key1006226: `Logistics fee (CNY)`,
  key1006227: `Distribution Order Creation Time`,
  key1006228: `Distribution Order Shipment Time`,
  key1006229: `Distribution Order Delivery Time`,
  key1006230: `You can enter the platform order number, PO number, distribution order number, parcel number, buyer ID, buyer name, SKU, platform product code`,
  key1006231: `You can enter the platform order number, distribution order number, package number, buyer ID, buyer name, SKU, platform product code`,
  key1006232: `Please enter the platform order number, which supports multiple commas or line breaks for separation`,
  key1006233: `Please enter a PO document number. Multiple commas or line breaks are supported.`,
  key1006234: `Please tick the data to be marked as shipped first!`,
  key1006235: `Marked for shipment, please refresh the page later to view.`,
  key1006236: `Please tick the data that you want to place an order for first!`,
  key1006237: `Order Tips`,
  key1006238: `Partially failed to place orders`,
  key1006239: `Orders from different stores cannot be shipped simultaneously!`,
  key1006240: `Only orders awaiting shipment can be shipped. Please reselect!`,
  key1006241: `Execute shipment`,
  key1006242: `Successfully executed shipment!`,
  key1006243: `Manual orders and platform orders cannot be shipped simultaneously. Please proceed in batches!`,
  key1006244: `Sample orders and shipment orders cannot be shipped simultaneously. Please proceed in batches!`,
  key1006245: `Please check the data to be shipped first!`,
  key1006246: `Confirm waiting order`,
  key1006247: `We are currently confirming and waiting for the order. If the order does not arrive on time, a second reminder will still be sent. Please confirm whether to wait for the order to arrive?`,
  key1006248: `Manual marking of shipments`,
  key1006249: `The system failed to mark the shipment to the platform. Please go to the platform backend to mark the shipment. After marking the shipment in the platform backend, you can click the confirm marked shipment button here to eliminate the abnormal status of this order.`,
  key1006250: `Confirm marked shipment`,
  key1006251: `Only pending orders can be accepted!`,
  key1006252: `Please check the data that needs to be accepted first!`,
  key1006253: `Confirm order acceptance`,
  key1006254: `Order accepted successfully!`,
  key1006255: `Some orders received are abnormal`,
  key1006256: `Sample order`,
  key1006257: `Goods order`,
  key1006258: `Regular orders`,
  key1006259: `AliExpress fully managed orders`,
  key1006260: `The platform order has been canceled. Please go to Ali International to cancel the order. After cancellation, please manually mark the order as processed.`,
  key1006261: `Platform:`,
  key1006262: `Distribution Order Status:`,
  key1006263: `Store:`,
  key1006264: `Platform order abnormal status:`,
  key1006265: `Distribution Order Exception Status:`,
  key1006266: `Export platform orders`,
  key1006267: `Batch Mark Non`,
  key1006268: `Batch order acceptance`,
  key1006269: `Standard shipping settings`,
  key1006270: `Stock order information`,
  key1006271: `Procurement status:`,
  key1006272: `Stock up warehouse:`,
  key1006273: `Purchasing Product Information`,
  key1006274: `Total value of goods:`,
  key1006275: `Time information`,
  key1006276: `Cancellation time:`,
  key1006277: `Partial replenishment in progress`,
  key1006278: `Cancel transaction`,
  key1006279: `Out of stock - restocking in progress`,
  key1006280: `Out of stock - discontinued`,
  key1006281: `Procurement status`,
  key1006282: `Warehouse`,
  key1006283: `Cancelled amount`,
  key1006284: `Refunded amount`,
  key1006285: `SKU paid unit price`,
  key1006286: `Cancel transaction prompt`,
  key1006287: `Canceling the stock order, please confirm if you want to cancel it?`,
  key1006288: `Cancel transaction successful!`,
  key1006289: `Can search product name,`,
  key1006290: `Keyword search:`,
  key1006291: `Export stock document`,
  key1006292: `This channel account has been deactivated. Please contact the operator or choose another payment channel account.`,
  key1006293: `Edit Payment Credentials`,
  key1006294: `View payment receipt`,
  key1006295: `Modify payment voucher`,
  key1006296: `The payment transaction picture cannot be empty!`,
  key1006297: `Please select the responsible person and manufacturer!`,
  key1006298: `Missing barcode prompt`,
  key1006299: `None of the following products`,
  key1006300: `Information, please enter`,
  key1006301: `My product`,
  key1006302: `Try again after uploading in.`,
  key1006303: `Source notes can only be entered in English!`,
  key1006304: `The file format is incorrect. Only xls and xlsx files are supported.`,
  key1006305: `Please enter order notes`,
  key1006306: `3. After the file is uploaded successfully, the corresponding order content will be stored in the"`,
  key1006307: `Order-Pending Payment status list, user required two times`,
  key1006308: `It will not be created until the order is confirmed.`,
  key1006309: `Order.`,
  key1006310: `1, please ensure that the file content of the order commodity information and the file header field correspondence is accurate, if there is no`,
  key1006311: `Effective content, will cause the file upload failure;`,
  key1006312: `2. Currently, only xls and xlsx format files are supported.`,
  key1006313: `Total Amount Due`,
  key1006314: `Reason for return`,
  key1006315: `Cancel payment`,
  key1006316: `Cancel confirmation`,
  key1006317: `Are you sure you want to cancel this payment information?`,
  key1006318: `Warehouse arrival details`,
  key1006319: `Platform commodity matching`,
  key1006320: `Customized goods have entered the processing phase and cannot delete/modify any of their information. Please contact the operator if you need to adjust.`,
  key1006321: `Adjustment Order`,
  key1006322: `Submit Adjustments`,
  key1006323: `Click Submit Adjustment Order`,
  key1006324: `Click Submit to add an order`,
  key1006325: `Adjustment success`,
  key1006326: `Are you sure you want to mark the last item in this order as "YMSSKU not matched"?`,
  key1006327: `If determined, since all items in this order are marked as "unmatched YMSSKU", the Department`,
  key1006328: `The system will automatically mark this platform order as"`,
  key1006329: `Domestic express tracking number`,
  key1006330: `Temu Backstage Shipping Warehouse`,
  key1006331: `Download Order`,
  key1006332: `Marked for shipment`,
  key1006333: `To be marked for shipment`,
  key1006334: `The entire order has been cancelled`,
  key1006335: `The order has been partially cancelled`,
  key1006336: `Ali international merchants have delivered goods`,
  key1006337: `Expected delivery time:`,
  key1006338: `, discontinued`,
  key1006339: `Tag confirmation prompt`,
  key1006340: `Match successful!`,
  key1006341: `If the platform goods are not matched, online logistics delivery may fail.`,
  key1006342: `Successfully matched SKU`,
  key1006343: `Successfully matched SKU (manually matched)`,
  key1006344: `No match`,
  key1006345: `The order is not received, the system will automatically match after you receive the order.`,
  key1006346: `Hint: Matched`,
  key1006347: `There are products that support customization in the product, please configure the corresponding customization information first;`,
  key1006348: `(Original SKU:`,
  key1006349: `ali international single number:`,
  key1006350: `Distribution Number:`,
  key1006351: `launch`,
  key1006352: `Original SKU:`,
  key1006353: `Logistics service:`,
  key1006354: `Price and quantity`,
  key1006355: `Decoded SKU:`,
  key1006356: `The product is null, which cannot be associated.`,
  key1006357: `Rematch`,
  key1006358: `Matching SKU failed`,
  key1006359: `Manual matching`,
  key1006360: `SKU has been discontinued, please cancel or replace the product`,
  key1006361: `Click to configure custom information`,
  key1006362: `Click Associate Compliance Information`,
  key1006363: `Total cost = Product + Handling fee + Logistics fee`,
  key1006364: `Handling fee = 3 + (Quantity of products - 1) * 0.5`,
  key1006365: `Total cost（`,
  key1006366: `Commodity fee（`,
  key1006367: `Processing fee（`,
  key1006368: `Logistics fees（`,
  key1006369: `Domestic express delivery fee（`,
  key1006370: `Customs clearance fees（`,
  key1006371: `Split Order`,
  key1006372: `platform commodity matching:`,
  key1006373: `The corresponding delivery warehouse of the goods is insufficient, please adjust the order quantity of this goods or the delivery warehouse of the goods.`,
  key1006374: `Receiving address information:`,
  key1006375: `View & Modify`,
  key1006376: `Ali International Order Information`,
  key1006377: `Platform order address information`,
  key1006378: `No more data available at the moment`,
  key1006379: `Delete Template Confirmation`,
  key1006380: `Confirm to delete the template. The information cannot be restored after deletion. Please operate carefully!`,
  key1006381: `Date Created:`,
  key1006382: `New Template`,
  key1006383: `Third Party Order Number`,
  key1006384: `Distribution to (country)`,
  key1006385: `Consignee's Name`,
  key1006386: `Email address`,
  key1006387: `IOSS No.`,
  key1006388: `Content Nature`,
  key1006389: `Processing method`,
  key1006390: `mapping`,
  key1006391: `Excelcolumn heading of Excel`,
  key1006392: `Mapped Excel file column header cannot be empty!`,
  key1006393: `Order multi-SKU import method:`,
  key1006394: `Template Field Mapping`,
  key1006395: `When there are many commodities, the SKU column title of the second commodity is incremented by the number of the SKU column title of the first commodity;`,
  key1006396: `For example, the original column title of commodity SKU is "commodity SKU". if there are multiple commodities, then the first`,
  key1006397: `The title name of the SKU column is set to "SKU1",`,
  key1006398: `Second item SKU column header name`,
  key1006399: `Set to "commodity SKU2", increasing by this;`,
  key1006400: `Note: only the first SKU column title needs to be entered in the input box, "quantity`,
  key1006401: `The content is the same;`,
  key1006402: `When the same order number appears in the file:`,
  key1006403: `considered to be an order containing multiple SKUs`,
  key1006404: `Error`,
  key1006405: `When the order number in the file already exists in the same note in the system:`,
  key1006406: `ignore and import other orders`,
  key1006407: `Warehouse Storage`,
  key1006408: `Please select a stocking warehouse!`,
  key1006409: `The account balance is sufficient and the payment is successful`,
  key1006410: `Stock warehouse`,
  key1006411: `Automatic payment after placing an order`,
  key1006412: `You can choose any of the following`,
  key1006413: `Order node as standard delivery node:`,
  key1006414: `Configuration method:`,
  key1006415: `Global unified configuration`,
  key1006416: `Configure by platform`,
  key1006417: `Logistics cannot be empty`,
  key1006418: `Logistics:`,
  key1006419: `This information needs to be confirmed with the buyer. If not filled in, no additional shipping information will be pasted on the package`,
  key1006420: `Consignee:`,
  key1006421: `Please fill in the recipient`,
  key1006422: `Receiving Group:`,
  key1006423: `Please fill in the receiving group`,
  key1006424: `The shipping cost will be attached to the first order that executes the shipment`,
  key1006425: `Step 1: Choose logistics`,
  key1006426: `Step 2: Fill in the receiving information`,
  key1006427: `Package number`,
  key1006428: `Package weight (g)`,
  key1006429: `Total number of package items`,
  key1006430: `Upload packaging labels`,
  key1006431: `No need to upload tags`,
  key1006432: `Please upload the packaging label first!`,
  key1006433: `The logistics tracking number cannot be empty!`,
  key1006434: `Please fill in the logistics tracking number`,
  key1006435: `Step 1: Upload packaging labels`,
  key1006436: `Step 2: Fill in the logistics tracking number`,
  key1006437: `Orders need to keep the delivery warehouse unique!`,
  key1006438: `The order needs to keep the delivery warehouse unique, if there is special demand, please add a new order operation.`,
  key1006439: `Commodity quantity cannot be empty`,
  key1006440: `The person in charge and the manufacturer cannot be empty!`,
  key1006441: `Split order successfully`,
  key1006442: `Split Order Confirmation`,
  key1006443: `Weight:`,
  key1006444: `Original quantity:`,
  key1006445: `Quantity after split:`,
  key1006446: `Post-Split Order Information`,
  key1006447: `Increase Order`,
  key1006448: `Logistics channel to be selected`,
  key1006449: `Delete Order`,
  key1006450: `The quantity of goods before and after the order is split is inconsistent, please confirm whether to unpack?`,
  key1006451: `Warehouse delivery available logistics`,
  key1006452: `Rule status:`,
  key1006453: `Please enter specification name`,
  key1006454: `Add Warehouse Rule`,
  key1006455: `Rule name cannot be empty.`,
  key1006456: `Order goods delivery warehouse cannot be empty`,
  key1006457: `Order goods delivery warehouse selection:`,
  key1006458: `Delivery scope:`,
  key1006459: `Account name cannot be empty`,
  key1006460: `Account Authorization`,
  key1006461: `Account name:`,
  key1006462: `Enabling`,
  key1006463: `Account, please confirm before proceeding.`,
  key1006464: `Deactivate this`,
  key1006465: `After the account is completed, the associated stores will not be able to distribute logistics. Please confirm whether to deactivate the account?`,
  key1006466: `Logistics Channel Code`,
  key1006467: `Logistics type`,
  key1006468: `Associated stores`,
  key1006469: `Disable logistics reminder`,
  key1006470: `After disabling this logistics, it will not be applicable for distribution. Please confirm whether to disable it?`,
  key1006471: `Enable logistics reminder`,
  key1006472: `Enabling logistics, please confirm before proceeding.`,
  key1006473: `Enable channel prompts`,
  key1006474: `Enabling logistics channel, please confirm before proceeding.`,
  key1006475: `Enable account prompt`,
  key1006476: `Deactivate channel prompt`,
  key1006477: `After disabling this logistics channel, it will not be applicable for distribution. Please confirm whether to disable it?`,
  key1006478: `Deactivate account prompt`,
  key1006479: `Account`,
  key1006480: `Platform Store:`,
  key1006481: `Not Enabled`,
  key1006482: `Please upload your business license according to the following requirements. If you do not upload it as required, your application may be rejected`,
  key1006483: `Please ensure that the font of the business license image is clear, the edges and corners are complete, and there are no irrelevant watermarks. Do not intentionally cover up the QR code or information. If the shooting is blurry, it is recommended to upload a scanned copy.`,
  key1006484: `Please check the Unified Social Credit Identifier/registration number you filled in by yourself in the national enterprise credit information publicity system to ensure that your subject information can be found, and the registration status is "existing (in operation, opening, registered)".`,
  key1006485: `If there has been a change in the company name or legal representative information, please upload a business license image with the latest approval date.`,
  key1006486: `Example image`,
  key1006487: `Please upload according to the following requirements. Failure to meet the following specifications will result in review rejection`,
  key1006488: `Please ensure that the name on your uploaded legal representative's ID card matches the name of the legal representative on your business license.`,
  key1006489: `Please confirm that the font of the legal representative's ID card is clear, without reflection, with complete edges and corners, and without any irrelevant watermarks or intentional covers.`,
  key1006490: `Platform Privacy Policy`,
  key1006491: `Please select [jpg, jpeg, png]`,
  key1006492: `Company name cannot be empty`,
  key1006493: `Corporate Identity Card National Emblem Face`,
  key1006494: `Face of legal representative witness`,
  key1006495: `Please upload the national emblem of the legal person's ID card first`,
  key1006496: `Please upload the profile of the legal representative witness first`,
  key1006497: `Specification for Identity Card of Legal Representative`,
  key1006498: `Business License Specification`,
  key1006499: `Please fill in the full name of the company on the business license`,
  key1006500: `The password length must be 8-26 digits`,
  key1006501: `Please fill in your phone number and graphic verification code first!`,
  key1006502: `Account registration successful`,
  key1006503: `Your account has been successfully registered. Please continue to improve the registration information and complete the registration!`,
  key1006504: `Please check first that I have read and agree`,
  key1006505: `Setting password cannot be empty`,
  key1006506: `The set password and confirmed password are inconsistent`,
  key1006507: `Graphic verification code:`,
  key1006508: `Please enter the SMS verification code`,
  key1006509: `Set password:`,
  key1006510: `8-26 digits (it is recommended to use two or more character combinations)`,
  key1006511: `Confirm password:`,
  key1006512: `Please enter the password again`,
  key1006513: `This phone number has already been registered as a distributor. If you continue, it will be considered as using this account to join the supplier`,
  key1006514: `I have read and agree`,
  key1006515: `Fill in account information`,
  key1006516: `Fill in enterprise information`,
  key1006517: `Review of entry materials`,
  key1006518: `login was successful`,
  key1006519: `Existing account?`,
  key1006520: `log in immediately`,
  key1006521: `Submitted successfully`,
  key1006522: `Your application materials have been submitted, and we usually take 3 working days`,
  key1006523: `Please be patient and wait for the internal audit to be completed. If you have any questions, please`,
  key1006524: `Contact online customer service!`,
  key1006525: `Entry information review in progress, please be patient and wait~`,
  key1006526: `After approval, the supplier backend can be used normally. If you have`,
  key1006527: `If you have any questions, please contact online customer service!`,
  key1006528: `Your application has not been approved`,
  key1006529: `Please verify and modify the following information before resubmitting.`,
  key1006530: `Revise`,
  key1006531: `Everything is ready`,
  key1006532: `Your application has been approved!`,
  key1006533: `Go and publish the product`,
  key1006534: `Exiting`,
  key1006535: `Mobile phone number/email/travel account cannot be empty`,
  key1006536: `SMS verification code cannot be empty`,
  key1006537: `Account login`,
  key1006538: `Mobile phone number/email/travel account`,
  key1006539: `Password`,
  key1006540: `Verification code`,
  key1006541: `SMS login`,
  key1006542: `SMS verification code`,
  key1006543: `Authorize now`,
  key1006544: `Retrieve password`,
  key1006545: `registration success!`,
  key1006546: `Mobile number registration`,
  key1006547: `Email registration`,
  key1006548: `Email (optional)`,
  key1006549: `Thoroughfare login`,
  key1006550: `Login will be opened for you`,
  key1006551: `Mall distribution authority.`,
  key1006552: `Welcome to register`,
  key1006553: `Already have an account, please log in`,
  key1006554: `Login Tongtool account`,
  key1006555: `If you already have a Tongtool account, you can log in with your Tongtool account directly.`,
  key1006556: `Mobile phone number/email cannot be empty`,
  key1006557: `confirm password can not be blank`,
  key1006558: `Submit`,
  key1006559: `set password`,
  key1006560: `Please enter email / verified phone number`,
  key1006561: `Go to log in`,
  key1006562: `Home Page`,
  key1006563: `Suppliers only need to ship`,
  key1006564: `Centralization warehouse`,
  key1006565: `Assist in product research to determine that products meet market demand and have a competitive price advantage.`,
  key1006566: `After the entry data is submitted,`,
  key1006567: `The audit will be completed within 3 working days.`,
  key1006568: `special`,
  key1006569: `Focus on cross-border e-commerce`,
  key1006570: `Over 10 years of professional cross-border e-commerce clothing product team`,
  key1006571: `wide`,
  key1006572: `Covering mainstream e-commerce platforms`,
  key1006573: `Distribution stores cover mainstream e-commerce platforms such as Amazon and eBay`,
  key1006574: `collection`,
  key1006575: `Centralized processing of orders`,
  key1006576: `Exemption`,
  key1006577: `Free storage service fee`,
  key1006578: `Receive free warehousing services upon entry`,
  key1006579: `Quick delivery`,
  key1006580: `One stop delivery system hosting, saving storage energy and controlling labor costs`,
  key1006581: `Women's clothing`,
  key1006582: `Men's clothing`,
  key1006583: `Girls`,
  key1006584: `Boys`,
  key1006585: `Infants and children`,
  key1006586: `Product research`,
  key1006587: `Register an account`,
  key1006588: `Fill in account information as required and register a corporate account.`,
  key1006589: `Fill in the entry information`,
  key1006590: `Submit business license, legal representative ID card, and fill in relevant store information.`,
  key1006591: `Completion of settlement`,
  key1006592: `After the review is approved, the supplier logs in to the backend and publishes the product for sale.`,
  key1006593: `Welcome to join`,
  key1006594: `Distribution Platform`,
  key1006595: `It is China's leading one-stop distribution platform for cross-border apparel. The founding team members have been deeply involved in the cross-border industry for more than ten years and have rich and high-quality cross-border e-commerce supply chain resources,`,
  key1006596: `Quantity standard and`,
  key1006597: `Shelf specification;`,
  key1006598: `• Identification`,
  key1006599: `Development concept, have a sincere long-term cooperation attitude.`,
  key1006600: `Ensure that the goods arrive within the shipping period.`,
  key1006601: `Warehouse.`,
  key1006602: `Immediate entry`,
  key1006603: `Suppliers, enjoy the new model of rapid distribution.`,
  key1006604: `You are cordially invited to join us and become our high-quality partner. Click to enter quickly!`,
  key1006605: `Supplier Entry Guidelines`,
  key1006606: `Immediate entry`,
  key1006607: `We can provide integrated services such as cargo collection, warehousing, logistics, distribution, etc. We can help source factories, brand agents, industry and trade integrated enterprises and other types of suppliers expand their overseas sales,`,
  key1006608: `Adhering to the business philosophy of "win-win cooperation and common development", we sincerely invite high-quality cross-border e-commerce suppliers to join us and assist you in your overseas market.`,
  key1006609: `Our Advantages`,
  key1006610: `Investment category`,
  key1006611: `Supplier Qualification Requirements`,
  key1006612: `Enterprise Information`,
  key1006613: `Entry materials`,
  key1006614: `Material requirements`,
  key1006615: `Enterprise business license with three certificates in one;`,
  key1006616: `Ensure that the enterprise applying to settle in is not listed in the "Abnormal Business List" and that the sales`,
  key1006617: `The goods are within its business scope;`,
  key1006618: `The deadline for expiration should be greater than 3 months.`,
  key1006619: `ID card`,
  key1006620: `Corporate ID card;`,
  key1006621: `The deadline for expiration should be greater than 1 month.`,
  key1006622: `Support bank card or Alipay.`,
  key1006623: `Product requirements`,
  key1006624: `Product Qualification`,
  key1006625: `Legal and compliant products`,
  key1006626: `The promised goods are legal and compliant, and comply with the laws, regulations, and quality of the sales destination`,
  key1006627: `For patented products, a sales area patent certificate is required;`,
  key1006628: `Suppliers with a brand need to provide a brand authorization letter;`,
  key1006629: `Having stable supply channels and willing to follow platform rules.`,
  key1006630: `Sincere long-term cooperation`,
  key1006631: `Ensure the lowest commodity prices on the entire network;`,
  key1006632: `order fulfillment`,
  key1006633: `Entry process`,
  key1006634: `Help Home`,
  key1006635: `Please describe your problem, eg: Logistics`,
  key1006636: `Video tutorial`,
  key1006637: `Self Service`,
  key1006638: `Changing your password regularly helps keep your account secure`,
  key1006639: `Modify mobile number`,
  key1006640: `The mobile phone number is involved in key businesses such as login and authentication to ensure account security`,
  key1006641: `The mailbox involves key businesses such as login and message notification, and ensures account security`,
  key1006642: `search"`,
  key1006643: `” related results, a total of`,
  key1006644: `No matching search results`,
  key1006645: `Daily Update`,
  key1006646: `Hot Selling Products`,
  key1006647: `Trendy women's clothing`,
  key1006648: `Fashion men's clothing`,
  key1006649: `Boutique children's clothing`,
  key1006650: `Good Product Recommendation`,
  key1006651: `Login to view prices`,
  key1006652: `Please check the data you want to delete first!`,
  key1006653: `Total number of products:`,
  key1006654: `This product is no longer available. Click`,
  key1006655: `This product information`,
  key1006656: `Please add the product to the shopping cart first`,
  key1006657: `Immediate Settlement`,
  key1006658: `Mall (www.yms.com) is a supply chain service platform established by Shenzhen cloud selling supply chain management co., ltd. focusing on cross-border e-commerce clothing categories. The platform integrates the source factory clothing mall, the thoroughfare Listing publishing platform, the thoroughfare ERP platform and the thoroughfare logistics platform, opening up an efficient order fulfillment link between cross-border e-commerce sellers and the source factory, and customer orders from foreign sales terminals are directly sent by the source factory.`,
  key1006659: `Register for free,`,
  key1006660: `Mall Subscription Goods`,
  key1006661: `After the store orders, you can`,
  key1006662: `Mall orders, support a generation of hair`,
  key1006663: `Mall cross-border e-commerce, focusing on clothing distribution`,
  key1006664: `Now you can take thousands of apparel items from`,
  key1006665: `The mall is published on major overseas platforms to win more sales opportunities.`,
  key1006666: `The mall provides an open interface, which can realize many functions such as commodity management, order management, warehouse management, etc.`,
  key1006667: `Just 3 steps to make cross-border business easier`,
  key1006668: `You just need to focus on operations, and we'll help you with the rest`,
  key1006669: `Selection`,
  key1006670: `Publication`,
  key1006671: `Directly connected to the listing and publishing system, quick listing to multi platform stores such as eBay and Amazon with just one click`,
  key1006672: `Massive product selection`,
  key1006673: `40000+clothing SKUs, 1000+monthly updates`,
  key1006674: `0 inventory risk`,
  key1006675: `No need for domestic stock preparation, zero inventory risk`,
  key1006676: `No financial pressure`,
  key1006677: `First issue documents and then pay to improve Asset turnover`,
  key1006678: `You just need to focus on product sales, and even if you only sell one product, we will kindly help you ship it`,
  key1006679: `Quick listing to multiple platforms`,
  key1006680: `Private label logo makes customers more reliable`,
  key1006681: `Private label can be identified through packages and packages to make customers more reliable`,
  key1006682: `Automatic tracking of orders`,
  key1006683: `The sales order system automatically tracks customer order details without the need to copy and paste them`,
  key1006684: `Fast delivery with guaranteed delivery time`,
  key1006685: `Open API interface`,
  key1006686: `Introduction to Platform Business`,
  key1006687: `① Register`,
  key1006688: `Mall Distributor`,
  key1006689: `stay`,
  key1006690: `The mall selects and collects goods, and the transit Listing system is quickly published on eBay, Walmart, AliExpress and other platforms for sale.`,
  key1006691: `Tongtu ERP captures platform orders, matches the international logistics method set by the distributor, and sends them`,
  key1006692: `Mall. The order can be fulfilled and sent to foreign customers on behalf of one.`,
  key1006693: `1) Service content: cross-border e-commerce clothing category factory settled`,
  key1006694: `The mall opens direct stores.`,
  key1006695: `1) Service content:`,
  key1006696: `Store suppliers provide warehousing services.`,
  key1006697: `Mall suppliers open cloud warehouse.`,
  key1006698: `② central warehouse stocking and shipping, suppliers create stocking plans, paste`,
  key1006699: `Mall commodity bar code into the warehouse, the central warehouse automatically match the order delivery.`,
  key1006700: `Distributor Business`,
  key1006701: `1) Service content: Provide one-stop shipping services for cross-border e-commerce clothing sellers' orders on platforms such as eBay, Walmart, AliExpress, Wish, Shopify, etc.`,
  key1006702: `2) Service process:`,
  key1006703: `Option 1: Through an ERP account (http:`,
  key1006704: `Option 2: Register and activate directly with your phone number.`,
  key1006705: `Publish sales`,
  key1006706: `Order shipment`,
  key1006707: `Supplier Business`,
  key1006708: `The clothing factory contacted the supplier's investment manager to register and settle in.`,
  key1006709: `Manage stores, standardize product listings, manage inventory, and operate order shipments.`,
  key1006710: `Central warehouse warehousing business`,
  key1006711: `Shenzhen Yunmai Supply Chain Management Co., Ltd.`,
  key1006712: `Contact address: 6th floor, Building C1, Nanshan Zhiyuan, Xueyuan Avenue, Nanshan District, Shenzhen`,
  key1006713: `Contact number: 400-0600-405`,
  key1006714: `Follow the shop`,
  key1006715: `Customizable parts`,
  key1006716: `Customizable area (length * width cm)`,
  key1006717: `Customizable area`,
  key1006718: `(length * width cm)`,
  key1006719: `Customized process`,
  key1006720: `Customization fee`,
  key1006721: `Cost: Show after login`,
  key1006722: `Custom Description`,
  key1006723: `Products that have been discontinued cannot be collected.`,
  key1006724: `Cancel Collection Successfully`,
  key1006725: `This product has been discontinued!`,
  key1006726: `★ Followed`,
  key1006727: `Not enough stock to buy!`,
  key1006728: `Added to cart successfully!`,
  key1006729: `Free`,
  key1006730: `Official Lightning Delivery Quality Worry-Free Choice`,
  key1006731: `Platform supplier straight hair warehouse`,
  key1006732: `Goods are not in stock, please buy other goods first.`,
  key1006733: `View after reaching the previous sales volume`,
  key1006734: `Tripartite warehouse`,
  key1006735: `Single Package Size (cm):`,
  key1006736: `Estimated Delivery Time (days):`,
  key1006737: `Freight (`,
  key1006738: `Zip code`,
  key1006739: `Current Location：`,
  key1006740: `Publishing time:`,
  key1006741: `Inventory: Display after login`,
  key1006742: `Price: Display after login`,
  key1006743: `Discount`,
  key1006744: `Accumulated distribution within 30 days`,
  key1006745: `fracture`,
  key1006746: `reduce`,
  key1006747: `More than pieces`,
  key1006748: `No logistics can reach`,
  key1006749: `collection`,
  key1006750: `One click publishing supports the following platforms`,
  key1006751: `Customize the design in advance and easily handle it later.`,
  key1006752: `Price: Visible after login`,
  key1006753: `Product Details`,
  key1006754: `Item parameters`,
  key1006755: `Supplier Recommendations`,
  key1006756: `I currently do not have permission to view. Please contact customer service to activate permissions.`,
  key1006757: `Getting Started Video`,
  key1006758: `New User Introduction Operations`,
  key1006759: `New User Registration`,
  key1006760: `Authorized Store`,
  key1006761: `One click publishing process`,
  key1006762: `One click publishing success prerequisite: Successfully authorized store`,
  key1006763: `Set store publishing template`,
  key1006764: `One click publishing rules`,
  key1006765: `Step 1: Publish Template Settings`,
  key1006766: `Publication template settings`,
  key1006767: `Step 2: Setting Publication Rules`,
  key1006768: `Publishing Rule Settings`,
  key1006769: `Step 3: One click publishing`,
  key1006770: `Replacement successful!`,
  key1006771: `Operation failed!`,
  key1006772: `Replacement specifications`,
  key1006773: `Create Success Tips`,
  key1006774: `The order was created successfully. Do you want to click to view the order list?`,
  key1006775: `Company Profile`,
  key1006776: `Address:`,
  key1006777: `Favorite Or Not:`,
  key1006778: `One Click Publishing Support Platform:`,
  key1006779: `Whether To Support Customization:`,
  key1006780: `Modify the origin of goods`,
  key1006781: `Set the origin of goods`,
  key1006782: `You change the submitted`,
  key1006783: `It has been rejected by the platform! Please review the reasons for rejection and resubmit for review.`,
  key1006784: `The platform is under review......`,
  key1006785: `The platform has been approved!`,
  key1006786: `Merchant business information`,
  key1006787: `Industrial and commercial information is already under review and modification is not supported for the time being!`,
  key1006788: `Store information is already under review and modification is not supported for the time being!`,
  key1006789: `Don't save edited information after confirmation`,
  key1006790: `Settlement Currency:`,
  key1006791: `commodity default origin:`,
  key1006792: `Change of Origin>`,
  key1006793: `Please set the country of origin>`,
  key1006794: `View reasons for rejection >>>`,
  key1006795: `Bind Collection Account`,
  key1006796: `(Recommended)`,
  key1006797: `binding`,
  key1006798: `Bind Account`,
  key1006799: `Change account`,
  key1006800: `Replace binding`,
  key1006801: `Change time`,
  key1006802: `Not added yet`,
  key1006803: `Add Collection Account`,
  key1006804: `Not currently bound`,
  key1006805: `Replacing the receiving account`,
  key1006806: `The collection information is already under review and cannot be modified yet!`,
  key1006807: `(Recommended)`,
  key1006808: `Change Log`,
  key1006809: `Modification failed`,
  key1006810: `Role`,
  key1006811: `During the review, the subsidy amount will be displayed after the review.`,
  key1006812: `accord with`,
  key1006813: `Does not meet the existing subsidy rules, if you have any questions, please contact your`,
  key1006814: `Docking personnel`,
  key1006815: `Receiving time`,
  key1006816: `Actual quantity to be shipped`,
  key1006817: `Multiple quantity`,
  key1006818: `Sent to warehouse`,
  key1006819: `Additional goods`,
  key1006820: `Voided bill of lading`,
  key1006821: `Invalid bill of lading reminder`,
  key1006822: `After the bill of lading is invalidated, all orders in the bill of lading will be transferred to the status of waiting for resend, and the outbound order will be transferred to the status of waiting for picking. Please confirm whether to invalidate the bill of lading?`,
  key1006823: `Tripartite Bill of Lading No.`,
  key1006824: `Logistics tracking number`,
  key1006825: `Please enter the bill of lading number, support multiple commas or line breaks separated`,
  key1006826: `Please enter the order number, which supports multiple commas or line breaks for separation`,
  key1006827: `Voided successfully!`,
  key1006828: `Operator operation`,
  key1006829: `Unable to stock prompt`,
  key1006830: `The following goods are unmaintained target stocking warehouses"`,
  key1006831: `"Corresponding country"`,
  key1006832: `"The supply price, please.`,
  key1006833: `Commodity List-Commodity Details-Price Inventory`,
  key1006834: `"Information module for maintenance;`,
  key1006835: `Go to maintenance`,
  key1006836: `Modified quantity`,
  key1006837: `Treat as not modified when not entered`,
  key1006838: `Please enter the quantity of products to be modified`,
  key1006839: `Successfully modified the stock quantity!`,
  key1006840: `Modify stock quantity`,
  key1006841: `The destination warehouse or delivery warehouse cannot be empty!`,
  key1006842: `Purchase Doc Import`,
  key1006843: `Destination warehouse:`,
  key1006844: `1. Uploading too much stocking information at one time is easy to read and fails to time out. It is recommended to upload no more than 100 stocking information in a single batch;`,
  key1006845: `2. If there is no matching item of commodity SKU in the file content SKU, or the corresponding quantity content of SKU is not a positive integer, it will be regarded as invalid content;`,
  key1006846: `3. Only xls and xlsx format files are supported;`,
  key1006847: `4. If there is invalid content in the file, the upload will fail;`,
  key1006848: `Only stock documents with issue document type of self-owned warehouse stock can be printed`,
  key1006849: `Barcode!`,
  key1006850: `Scan SKU printing`,
  key1006851: `Print the selected order barcode`,
  key1006852: `Please check the data that needs to be marked for shipment first!`,
  key1006853: `There is currently no data in the current filtering results, unable to mark shipment!`,
  key1006854: `Only orders with an outbound status of pending shipment in the current order can be shipped!`,
  key1006855: `Only orders with a stock status of pending shipment in the current order can be shipped!`,
  key1006856: `Please select the stock order of the same delivery warehouse for bulk shipment.`,
  key1006857: `There are currently no products in the shipping desk, and the distribution list cannot be printed.`,
  key1006858: `Please check the order barcode data that needs to be printed first!`,
  key1006859: `There is currently no data available for the current filtering results! Unable to print order barcode`,
  key1006860: `Cancel goods preparation`,
  key1006861: `Please confirm whether to cancel stocking?`,
  key1006862: `Initiate stocking`,
  key1006863: `Batch shipment`,
  key1006864: `Selected orders`,
  key1006865: `Filter result orders`,
  key1006866: `Distribution List Format`,
  key1006867: `List format:`,
  key1006868: `Paper checklist`,
  key1006869: `Table file`,
  key1006870: `sku cannot be empty!`,
  key1006871: `Failed to get print address!`,
  key1006872: `Scan and exchange orders`,
  key1006873: `Please scan/input SKU`,
  key1006874: `Please scan/input SKU:`,
  key1006875: `Batch printing:`,
  key1006876: `Close Popup`,
  key1006877: `Receiving information`,
  key1006878: `Country/Province State/City:`,
  key1006879: `Logistics fees:`,
  key1006880: `Warehouse handling fee:`,
  key1006881: `Commodity processing status`,
  key1006882: `Factory Name`,
  key1006883: `Reject`,
  key1006884: `Receiver`,
  key1006885: `Country/Province State/City`,
  key1006886: `Total amount of goods`,
  key1006887: `Please ensure that the corresponding logistics in the selected multiple orders are third-party logistics and do not need to be delivered to the collection point.`,
  key1006888: `Out of stock orders need to be marked as received before shipping!`,
  key1006889: `Only orders with a pending shipment status in the current order can be shipped!`,
  key1006890: `Mark the delivery success!`,
  key1006891: `There is currently no data available for the current filtering results, unable to operate!`,
  key1006892: `Please check the data that needs to be marked first!`,
  key1006893: `Mark arrival reminder`,
  key1006894: `After marking the arrival, the order will be transferred to pending shipment. Please confirm whether to mark the arrival?`,
  key1006895: `Only out of stock orders can be marked with arrival, please reselect!`,
  key1006896: `Only non out of stock orders can be marked as out of stock. Please reselect!`,
  key1006897: `Order confirmation`,
  key1006898: `Refusal to accept order confirmation`,
  key1006899: `We are in the process of accepting the order. After confirming the acceptance, the settlement will be based on the amount of this order. We need to wait for the customer to make payment. Please confirm if you want to accept the order?`,
  key1006900: `After rejecting the order, the order may be cancelled. Please confirm if you want to reject the order?`,
  key1006901: `Refuse to accept orders`,
  key1006902: `Successful order acceptance`,
  key1006903: `Rejected order successfully`,
  key1006904: `Factory Name:`,
  key1006905: `Please enter a factory name`,
  key1006906: `Switching delivery warehouse`,
  key1006907: `Selection of delivery warehouse:`,
  key1006908: `Shipment reminder`,
  key1006909: `The destination warehouse cannot be empty!`,
  key1006910: `The product quantity cannot be empty or 0`,
  key1006911: `The quantity must be an integer greater than 0`,
  key1006912: `The delivery warehouse cannot be empty!`,
  key1006913: `Encoding Information`,
  key1006914: `Packing reminder`,
  key1006915: `The outbound tracking number you scanned is different from the warehouse where the current outbound tracking has been packed. Please scan the outbound tracking number of the same warehouse for packing.`,
  key1006916: `Please enter sku`,
  key1006917: `Screen`,
  key1006918: `Please scan or enter a scan`,
  key1006919: `Bill of Lading Number:`,
  key1006920: `Please enter the delivery note number`,
  key1006921: `Complete addition`,
  key1006922: `The outbound order has been scanned`,
  key1006923: `Domestic Express Number cannot be empty`,
  key1006924: `Logistics waybill number:`,
  key1006925: `Print quantity cannot be empty`,
  key1006926: `Settlement amount:`,
  key1006927: `Received Warehouse:`,
  key1006928: `Receiving Name:`,
  key1006929: `Contact information:`,
  key1006930: `To be paid by the customer`,
  key1006931: `Receiving warehouse`,
  key1006932: `Receiving Name`,
  key1006933: `Please select an order whose receiving information is consistent with the shipping warehouse information for bulk shipment.`,
  key1006934: `Please maintain the warehouse address in Warehouse Management before doing this`,
  key1006935: `Statistics of shops completed this month (natural month)`,
  key1006936: `Warehouse issued`,
  key1006937: `The total amount of the order.`,
  key1006938: `Statistics completed this month (natural month)`,
  key1006939: `The total number of orders.`,
  key1006940: `Last month's sales revenue`,
  key1006941: `Order quantity this month (orders)`,
  key1006942: `Last month's order quantity`,
  key1006943: `Yesterday's order volume`,
  key1006944: `Today's order volume`,
  key1006945: `Total number of SPUs on sale`,
  key1006946: `Calculate the total number of SPUs on sale, excluding SPUs in suspended or temporary storage status.`,
  key1006947: `Total number of SKUs on sale`,
  key1006948: `Calculate the total number of SKUs on sale, excluding SKUs in suspended or temporary storage status.`,
  key1006949: `Number of subscribed products (SPU)`,
  key1006950: `Count the total number of products subscribed by distributors, and only calculate once for multiple distributors subscribing to the same product.`,
  key1006951: `Number of subscriptions this month`,
  key1006952: `Number of subscriptions yesterday`,
  key1006953: `Number of subscriptions today`,
  key1006954: `Calculate the total number of SPUs that have been listed on the platform by distributors, and calculate the same SPU with different items only once.`,
  key1006955: `Calculate the total number of SPUs published by distributors, based on the number of items.`,
  key1006956: `Delivery time in the past 30 days (hours)`,
  key1006957: `Calculate the average time taken for all orders in the past 30 days from waiting to be picked to being shipped (courier pickup)`,
  key1006958: `Delivery time in the past 7 days`,
  key1006959: `Delivery time in the past 3 days`,
  key1006960: `On sale`,
  key1006961: `Sold out`,
  key1006962: `Rejected`,
  key1006963: `Last 7 days`,
  key1006964: `In the past 30 days`,
  key1006965: `Sales amount (CNY): ¥ `,
  key1006966: `Order quantity (order):`,
  key1006967: `Commodity Management`,
  key1006968: `Publish new products`,
  key1006969: `Sales Run chart`,
  key1006970: `Hot selling product ranking list`,
  key1006971: `Inventory Details Log`,
  key1006972: `Bill of Lading`,
  key1006973: `Listing/Discontinuation`,
  key1006974: `sku, supports multiple row-separated`,
  key1006975: `Updated on:`,
  key1006976: `Please enter the supplier sku, support multiple lines separated`,
  key1006977: `Modify the price`,
  key1006978: `Batch price change`,
  key1006979: `Batch listing/discontinuation`,
  key1006980: `This product is currently being used by a mapped product and cannot be deleted`,
  key1006981: `SKU does not exist`,
  key1006982: `This SKU has inventory and cannot be deleted`,
  key1006983: `The system is busy, please try again`,
  key1006984: `Please enter Chinese title`,
  key1006985: `Approval Status:`,
  key1006986: `Export Product`,
  key1006987: `Tips for improving warehouse information`,
  key1006988: `Obtain 1688 items`,
  key1006989: `Collect 1688 items`,
  key1006990: `1. After importing the sales price, the original price will be overwritten, please import carefully;`,
  key1006991: `1. According to the SKU dimension for listing/discontinuation, after discontinuation, distributors will not be able to continue placing orders;`,
  key1006992: `You have not configured the shipping warehouse, or the operator has not configured the warehouse permission for the shipping warehouse you created,`,
  key1006993: `Goods cannot be added for the time being. Please create a warehouse and contact the operator to configure the warehouse permission before adding goods.`,
  key1006994: `To configure the delivery warehouse`,
  key1006995: `The mapping will be replenished as soon as possible.`,
  key1006996: `Matching mapping failed,`,
  key1006997: `SKU Duplicate`,
  key1006998: `The time range cannot be empty`,
  key1006999: `Store cannot be empty`,
  key1007000: `1688 store not bound`,
  key1007001: `1688 store is not currently bound. Please bind and try again.`,
  key1007002: `Failed to obtain product`,
  key1007003: `Failed to obtain the product section`,
  key1007004: `Copy failed SPU`,
  key1007005: `Matching mapping failed, you can click`,
  key1007006: `Successfully obtained product`,
  key1007007: `View products`,
  key1007008: `Successfully obtained the product, which can be found on the product page`,
  key1007009: `Product acquisition in progress, please wait!`,
  key1007010: `Product link cannot be empty!`,
  key1007011: `The specified link address must be a link starting with https://or http://!`,
  key1007012: `Acquisition type:`,
  key1007013: `Select a store:`,
  key1007014: `Product link:`,
  key1007015: `Please enter the 1688 product link, such as: https://detail.1688.com/offer/673838787879.html Support for multiple row separations`,
  key1007016: `Please select 1688 product creation time`,
  key1007017: `Designated product`,
  key1007018: `obtain`,
  key1007019: `Product collection in progress, please wait!`,
  key1007020: `Class 1688:`,
  key1007021: `Batch collection`,
  key1007022: `Transactions in the past 90 days:`,
  key1007023: `By brand status`,
  key1007024: `By brand name`,
  key1007025: `Brand Logo`,
  key1007026: `Brand name`,
  key1007027: `Brand description`,
  key1007028: `Brand website`,
  key1007029: `Brand status`,
  key1007030: `Do you want to delete the current brand?`,
  key1007031: `Add brand`,
  key1007032: `Editorial brand`,
  key1007033: `Brand name cannot be empty`,
  key1007034: `brand name:`,
  key1007035: `Please enter brand name.`,
  key1007036: `Brand description:`,
  key1007037: `Please enter brand description.`,
  key1007038: `Brand status:`,
  key1007039: `Brand URL:`,
  key1007040: `Please enter URL of the brand.`,
  key1007041: `Brand logo:`,
  key1007042: `Click or drag here to upload files`,
  key1007043: `Price cannot be empty!`,
  key1007044: `Waiting for payment`,
  key1007045: `Received payments`,
  key1007046: `Original price of goods`,
  key1007047: `Goods amount (receivable):`,
  key1007048: `Subsidy amount (receivable):`,
  key1007049: `Domestic logistics costs (payable):`,
  key1007050: `Own logistics expenses (A/R):`,
  key1007051: `Domestic logistics costs are payable by suppliers, and the amount of goods, subsidies and own logistics costs are receivable by suppliers. Please pay attention to the calculation.`,
  key1007052: `Confirming the bill means that the contents and amount of the bill have been checked correctly. Please confirm the bill and then operate.`,
  key1007053: `The background will initiate the payment process and the funds will be transferred to the bound collection account.`,
  key1007054: `Settlement amount of goods (CNY)`,
  key1007055: `Collection account not bound`,
  key1007056: `The current account is not bound to a receiving account and cannot complete the receiving process. Please bind and try again.`,
  key1007057: `Unbind`,
  key1007058: `Bill number`,
  key1007059: `Bill status update time`,
  key1007060: `Please enter the billing number, which supports multiple commas or line breaks for separation`,
  key1007061: `At least one of the unpicked quantities in the same outbound order must be greater than 0.`,
  key1007062: `Unpicked/printed outbound order details`,
  key1007063: `Logistics waybill`,
  key1007064: `Yuncang noodles`,
  key1007065: `No waybill`,
  key1007066: `Mixed waybill`,
  key1007067: `Packaging material`,
  key1007068: `Labels reprint`,
  key1007069: `Picking review`,
  key1007070: `No pick list being scanned`,
  key1007071: `The currently selected data has been printed!`,
  key1007072: `pick baskets`,
  key1007073: `Print address label (selected)`,
  key1007074: `Inbound order`,
  key1007075: `Freeze order`,
  key1007076: `Product ID`,
  key1007077: `Storage bin for use`,
  key1007078: `Storage bin for receipt`,
  key1007079: `Storage bin for picking`,
  key1007080: `Frozen quantity`,
  key1007081: `Freeze distribution`,
  key1007082: `Unfreeze and distribute`,
  key1007083: `Outbound quantity`,
  key1007084: `items(Picked/Unpicked)`,
  key1007085: `Multi-product sorting - end sorting`,
  key1007086: `Number of reprints`,
  key1007087: `Quantity printed`,
  key1007088: `Scan completed`,
  key1007089: `Match failed`,
  key1007090: `There is an empty Tongtool sku.`,
  key1007091: `There is an emptyskuCode`,
  key1007092: `TongdaoskuThe system does not exist`,
  key1007093: `skuCode The system does not exist`,
  key1007094: `The first journey cost must be a number`,
  key1007095: `Select files to import:`,
  key1007096: `Select file`,
  key1007097: `Download template`,
  key1007098: `Cancel package`,
  key1007099: `Check reset delivery order to generate an issue document again`,
  key1007100: `Reset delivery order`,
  key1007101: `This is the record after the delivery order has been reset，Will return to【Waiting for allocation】state,At the same time, the delivery order will perform the following operations：`,
  key1007102: `1.If the delivery order has been successfully distributed, it will try to call the logistics provider interface to cancel the order`,
  key1007103: `2.If the inventory has been allocated successfully in the issue document, the allocated inventory will be returned`,
  key1007104: `Supply Priority Configuration`,
  key1007105: `If there are multiple warehouses that can supply goods to the same platform warehouse at the same time, the system will check the warehouse inventory according to the supply sequence set by the distribution, and issue the collection order to the corresponding warehouse.`,
  key1007106: `Exchange Rate: 1CNY = `,
  key1007107: `Set up logistics channels`,
  key1007108: `New logistics provider`,
  key1007109: `Set up logistics provider`,
  key1007110: `Please enter the name of the logistics provider`,
  key1007111: `Enable status cannot be empty`,
  key1007112: `Shipping address template selection cannot be empty`,
  key1007113: `Return address template selection cannot be empty`,
  key1007114: `Add warehouse`,
  key1007115: `Please select the supply target to collect goods/stock warehouse`,
  key1007116: `Please select straight hair available logistics`,
  key1007117: `Please select the warehouse shipping place first`,
  key1007118: `On-site collection or self-delivery`,
  key1007119: `Express delivery to pickup point`,
  key1007120: `View & Edit Logistics`,
  key1007121: `Reference time limit (days):`,
  key1007122: `Applicable weight (g):`,
  key1007123: `Are you sure you want to deactivate this logistics method?`,
  key1007124: `Please select the logistics method to enable first`,
  key1007125: `Enable logistics method`,
  key1007126: `Are you sure you want to enable this logistics?`,
  key1007127: `Confirm to disable this flow?`,
  key1007128: `Are you sure you want to deactivate this warehouse?`,
  key1007129: `After confirming the deactivation, only the goods in the delivery warehouse will be stopped selling at the same time.`,
  key1007130: `Warehouse Code`,
  key1007131: `Are you sure you want to enable this warehouse?`,
  key1007132: `Account name`,
  key1007133: `Authorization time`,
  key1007134: `Data synchronization`,
  key1007135: `Authorization`,
  key1007136: `New products`,
  key1007137: `Code:`,
  key1007138: `Input Code Name`,
  key1007139: `Account Name:`,
  key1007140: `Please enter an authorized platform account`,
  key1007141: `Expiration time:`,
  key1007142: `Main warehouse actual inventory`,
  key1007143: `Order occupancy`,
  key1007144: `Warehouse waiting quantity`,
  key1007145: `Virtual Inventory`,
  key1007146: `Procurement in transit quantity`,
  key1007147: `Sales return inventory`,
  key1007148: `Incoming warehouse inventory`,
  key1007149: `Defective inventory`,
  key1007150: `Inventory = `,
  key1007151: `Rule item cannot be empty!`,
  key1007152: `Inventory =`,
  key1007153: `Select a warehouse`,
  key1007154: `Third-party platform warehouse`,
  key1007155: `Supplier warehouse`,
  key1007156: `Synchronize inventory`,
  key1007157: `You do not have permission to access this resource, please contact the administrator`,
  key1007158: `The system is busy, please try again (the interface reports an error, please check the interface error on the console)`,
  key1007159: `The account has been disabled.`,
  key1007160: `The supplier settlement status must be Pending Settlement and`,
  key1007161: `The issue status must be issued`,
  key1007162: `The customer's settlement status must be Pending Settlement and`,
  key1007163: `Failed to confirm payment of the bill, the bill has been voided`,
  key1007164: `The package does not exist.`,
  key1007165: `Category ID already exists`,
  key1007166: `Parent node does not exist`,
  key1007167: `Category name cannot contain ->`,
  key1007168: `The name cannot contain spaces.`,
  key1007169: `Maximum classification level reached`,
  key1007170: `Category name at the same level already exists`,
  key1007171: `The email is already occupied`,
  key1007172: `The phone number is already used`,
  key1007173: `The package is not collected`,
  key1007174: `No relevant outbound order`,
  key1007175: `The bill of lading is not sorted`,
  key1007176: `There are multiple packages`,
  key1007177: `The status of the bill of lading must be collected or sorted`,
  key1007178: `Existing non-sorting status`,
  key1007179: `The outbound order is not in the picked state`,
  key1007180: `The handover order is not in the packed state`,
  key1007181: `Already a customer`,
  key1007182: `Graphic verification code error`,
  key1007183: `Verification code error`,
  key1007184: `Email not registered`,
  key1007185: `Repeat page submission`,
  key1007186: `SMS failed to be sent`,
  key1007187: `Failed to query user`,
  key1007188: `Mobile phone number is empty`,
  key1007189: `wrong password`,
  key1007190: `SMS verification code verification error`,
  key1007191: `Graphic verification code is invalid`,
  key1007192: `The number of errors exceeded, please enter the graphic verification code and try again`,
  key1007193: `repeated submit`,
  key1007194: `Non-current user mailbox`,
  key1007195: `Non-current user phone`,
  key1007196: `Login failed, user does not exist`,
  key1007197: `Please log in to register a distribution account with the admin account`,
  key1007198: `Successfully created a customer account by logging in to the Tongtu account. Once approved, access the account again`,
  key1007199: `The current user, please log in after passing the review`,
  key1007200: `Product does not exist`,
  key1007201: `Customer level is already bound to supplier level`,
  key1007202: `The supplier has set the supplier level`,
  key1007203: `The queried picking order number does not exist`,
  key1007204: `Brand name already exists`,
  key1007205: `Non-draft status cannot be deleted`,
  key1007206: `The Chinese name, English name, title, picture cannot be modified pending review`,
  key1007207: `cannot contain commas`,
  key1007208: `SKU with the same attributes exists.`,
  key1007209: `Duplicate SPU or SKU`,
  key1007210: `Variable parameter commodity SKU cannot repeat with SPU`,
  key1007211: `The product is being used by the mapped product and cannot be deleted.`,
  key1007212: `The package has a replenishment order to be completed.`,
  key1007213: `SKU does not exist`,
  key1007214: `Logistics channel name cannot be repeated`,
  key1007215: `There is a normal picking package in the abnormal package.`,
  key1007216: `The package has been cancelled.`,
  key1007217: `Failed to mark as shipped, this package has been cancelled for recycling`,
  key1007218: `Failed to complete the packaging, the packaging status has been changed!`,
  key1007219: `It is not a picking list for multi-products one package, and the sorting operation cannot be started.`,
  key1007220: `Each operator of the system is only allowed to start one sorting operation at the same time`,
  key1007221: `The picking list is currently being sorted by someone else`,
  key1007222: `The sorting operation has been completed, and you can restart the sorting operation for the pick list.`,
  key1007223: `There are common print delivery orders.`,
  key1007224: `The pick basket cannot find the only pick list that is not packaged.`,
  key1007225: `There is no pick list to be completed in the pick basket.`,
  key1007226: `The pick list is not printed and the picking review cannot be started`,
  key1007227: `Pick list completed.`,
  key1007228: `There is no outbound order under the pick list.`,
  key1007229: `There is no valid outbound order under the pick order.`,
  key1007230: `There is a product note under the pick list.`,
  key1007231: `There is an ordinary-print outbound list under the pick list.`,
  key1007232: `The pick list has not been multi-product sorting.`,
  key1007233: `There is an outbound order which is not issued to the logistics provider successfully under the pick list.`,
  key1007234: `The pick list is not completed.`,
  key1007235: `Sorting operation only supports pick lists for sales.`,
  key1007236: `sku and upc cannot be repeated`,
  key1007237: `upcupc has existed`,
  key1007238: `UPCDuplicate UPC`,
  key1007239: `Duplicate SKUs`,
  key1007240: `The pick list of non-sale outbound order does not support picking review.`,
  key1007241: `The package has been intercepted.`,
  key1007242: `The user is packing other pick lists.`,
  key1007243: `No inventory can be allocated, unable to allocate`,
  key1007244: `The package has been shipped out.`,
  key1007245: `Package information does not exist`,
  key1007246: `Box No. cannot be empty.`,
  key1007247: `SKU cannot be empty`,
  key1007248: `No corresponding outbound order found`,
  key1007249: `Outbound order No. error`,
  key1007250: `The SKU does not exist.`,
  key1007251: `Pick list does not exist.`,
  key1007252: `Failed to clear scan. The package has been scanned.`,
  key1007253: `Wrong boxing quantity`,
  key1007254: `There is only one package under the picking list, which cannot be removed`,
  key1007255: `The pick list has completed the picking review and cannot be re-sorted`,
  key1007256: `The warehouse is in inventory allocation, please try again later.`,
  key1007257: `The package has no items awaiting re-picking.`,
  key1007258: `The inbound order has been closed and cannot be received!`,
  key1007259: `The current package is not printed`,
  key1007260: `The number of scanned SKU does not match the number of packages`,
  key1007261: `Did not match a suitable outbound order`,
  key1007262: `Invalid key`,
  key1007263: `The number of scanned sku is inconsistent with the number of ID codes.`,
  key1007264: `The current bill of lading status is not in packing and cannot continue packing`,
  key1007265: `The sorting status of the picking list that ends the sorting is not sorting, and the sorting cannot be ended`,
  key1007266: `The package has been billed`,
  key1007267: `Cannot be repeatedly marked as picked`,
  key1007268: `Package status has changed and operation is abnormal`,
  key1007269: `Bill of lading number does not exist`,
  key1007270: `Bill of Lading not waiting for collection/packing status,`,
  key1007271: `Cannot delete`,
  key1007272: `The current attribute is being referenced and cannot be deleted`,
  key1007273: `Property with the same name already exists`,
  key1007274: `Please stop selling the deleted SKU and try again`,
  key1007275: `The SKU with inventory cannot be deleted.`,
  key1007276: `SKU already exists.`,
  key1007277: `Order Voided`,
  key1007278: `There is a non-waiting collection state`,
  key1007279: `The number of packages received by the bill of lading is not uniform`,
  key1007280: `Illegal attributes`,
  key1007281: `The Chinese name of the color already exists`,
  key1007282: `Duplicate library code`,
  key1007283: `Duplicate library area name`,
  key1007284: `Duplicate warehouse name`,
  key1007285: `Duplicate warehouse code`,
  key1007286: `The`,
  key1007287: `The order has been exchanged and cannot be canceled.`,
  key1007288: `The operator has completed the picking, please do not submit repeatedly`,
  key1007289: `It has been sorted and is in a packed state, please do not submit repeatedly`,
  key1007290: `Has been withdrawn successfully, please do not submit repeatedly`,
  key1007291: `Duplicate location number`,
  key1007292: `The pick list is being sorted`,
  key1007293: `No match to be packed`,
  key1007294: `The current pick order status is not waiting for picking/picking status`,
  key1007295: `Picking list is not to be packaged or in package`,
  key1007296: `The status has changed, please refresh and try again!`,
  key1007297: `Only packages that have been changed can be scanned`,
  key1007298: `There are commodities under the category`,
  key1007299: `There are sub-categories under category`,
  key1007300: `Weight cannot be empty.`,
  key1007301: `When there is one sku left`,
  key1007302: `Can not be deleted`,
  key1007303: `Obtaining classification information is abnormal`,
  key1007304: `Non-logistics face order types are not allowed to be marked out of the warehouse`,
  key1007305: `Surface single anomaly`,
  key1007306: `It cannot map deleted attributes`,
  key1007307: `There is a mapping attribute, so it is not allowed to delete`,
  key1007308: `Bill of lading has been deleted`,
  key1007309: `There are mapping attributes under the changed category, please delete the mapping attributes first`,
  key1007310: `The customer number currently being recharged does not exist`,
  key1007311: `Under the same platform, the same site cannot exist/without a site, the same classification cannot exist`,
  key1007312: `There is no picture of the product, please upload in time`,
  key1007313: `The product has no color picture information, please upload it in time`,
  key1007314: `The logistics provider did not exist.`,
  key1007315: `The logistics provider name already exists.`,
  key1007316: `Platform account has been shut down.`,
  key1007317: `Duplicate service name or number`,
  key1007318: `The logistics provider code has existed.`,
  key1007319: `The name already exists.`,
  key1007320: `Duplicate association of freight forwarding`,
  key1007321: `Store number already exists`,
  key1007322: `The store name already exists`,
  key1007323: `The store name and number already exist`,
  key1007324: `Authorized stores cannot switch stores`,
  key1007325: `Abnormal order status`,
  key1007326: `Not satisfied`,
  key1007327: `Special rules of logistics`,
  key1007328: `Logistics scope rules`,
  key1007329: `Cancel order exception`,
  key1007330: `Failed to update user information`,
  key1007331: `Update logistics information abnormal`,
  key1007332: `Failed to create order`,
  key1007333: `Order has been placed`,
  key1007334: `The package has been out of the warehouse`,
  key1007335: `Processing the operation of placing logistics orders`,
  key1007336: `failed to cancel logistics`,
  key1007337: `Failed to void the sub-order in the supplier system`,
  key1007338: `The specified product information to be queried is empty`,
  key1007339: `Manual order failed`,
  key1007340: `Failed to generate shipping information`,
  key1007341: `Failed to deactivate logistics channel, associated`,
  key1007342: `Logistics cannot be deactivated`,
  key1007343: `The logistics channel code cannot be repeated`,
  key1007344: `The package is not waiting for outbound`,
  key1007345: `The specified list of pick lists is empty`,
  key1007346: `The issue document of the central warehouse has generated a picking list and cannot be voided.`,
  key1007347: `The face list is under picking review.`,
  key1007348: `The issue document is not`,
  key1007349: `The issue document of the central warehouse stock.`,
  key1007350: `There is a supplier sub-order that has been outbound`,
  key1007351: `No product information corresponding to sku was found`,
  key1007352: `Central warehouse stock picking list is being scanned`,
  key1007353: `A notification message template of the same type already exists`,
  key1007354: `The merchant has not set a Listing address`,
  key1007355: `Role name already exists`,
  key1007356: `The role is being used.`,
  key1007357: `Default customer level not set`,
  key1007358: `The outbound order has been marked as "Out of stock"`,
  key1007359: `The supplier has not set up shipping directly, and shipping directly is not allowed`,
  key1007360: `The warehousing status of the current container is not "To switch bill"`,
  key1007361: `A container type with the same name already exists`,
  key1007362: `The current container type is already bound`,
  key1007363: `The container is not in the same warehouse as the bill of lading`,
  key1007364: `This does not exist in the sorting container`,
  key1007365: `The container does not exist`,
  key1007366: `The container is bound`,
  key1007367: `The container status is abnormal or changed`,
  key1007368: `The container is empty and the sorting cannot be ended`,
  key1007369: `The number of bills of lading is abnormal, and there are SKU or waybills that have not been sorted`,
  key1007370: `The current container warehousing status is not "In switching bill".`,
  key1007371: `Order has been sorted`,
  key1007372: `The bill of lading is in sorting`,
  key1007373: `Container status does not exist`,
  key1007374: `The bill of lading status needs to be either received or sorted`,
  key1007375: `There is a bill of lading in sorting`,
  key1007376: `This bill of lading is in sorting by other  users`,
  key1007377: `A container of the same type has been bound`,
  key1007378: `Please complete the sticker job of the current container`,
  key1007379: `The container is in sticking waybill`,
  key1007380: `Please complete the publishing operation of the current container`,
  key1007381: `Containers are in publishing`,
  key1007382: `There is a container in the processing`,
  key1007383: `The sorting handover document already exists`,
  key1007384: `Orders need to go through commodity sorting first.`,
  key1007385: `Order has been shipped and cannot be removed`,
  key1007386: `The logistics is being processed, please try again later`,
  key1007387: `The current size type is being used`,
  key1007388: `The template is already in use, so deletion is not allowed`,
  key1007389: `The Chinese name of the body part has been used, and modification is not allowed`,
  key1007390: `The size value already exists`,
  key1007391: `The specification attribute is already in use, and the deletion is not allowed`,
  key1007392: `The specification attribute is already in use, modification is not allowed`,
  key1007393: `The current size value is in use and cannot be deleted`,
  key1007394: `The specification of the main attribute is already used, and modification is not allowed`,
  key1007395: `Export template exception`,
  key1007396: `Unauthorized Jushuitan Merchant`,
  key1007397: `Jushuitan Merchant not added`,
  key1007398: `No Jushuitan merchants with synchronized inventory checked and enabled were found`,
  key1007399: `Sku value is empty`,
  key1007400: `SPUs that are not for sale cannot be discontinued`,
  key1007401: `The number of shelves and picking quantity are inconsistent`,
  key1007402: `The exported bill information is empty`,
  key1007403: `Phone is not registered`,
  key1007404: `SPU cannot contain Chinese`,
  key1007405: `The current size attribute template is currently in use`,
  key1007406: `An attribute with the same name already exists. Please modify the attribute name before submitting`,
  key1007407: `No warehouse has been created. Please create a warehouse first`,
  key1007408: `This order has been cancelled. Please replenish the goods offline to the central warehouse`,
  key1007409: `The packaged delivery note cannot be voided`,
  key1007410: `Multiple primary attributes present`,
  key1007411: `Failure to meet the conditions for duplicate publication`,
  key1007412: `The settled merchant does not exist`,
  key1007413: `Password verification error`,
  key1007414: `No recipient information found`,
  key1007415: `The picking list is not pending or in sorting`,
  key1007416: `The picking list has been cancelled`,
  key1007417: `The picking list is not in the packaging`,
  key1007418: `The delivery note being packed cannot be voided`,
  key1007419: `The end time of the activity cannot be less than the start time of the activity`,
  key1007420: `This product already exists in another activity`,
  key1007421: `Could not find a container of the corresponding type for the product. Please bind and rescan.`,
  key1007422: `WishPost is currently not authorized. Please authorize and associate the store in your own logistics management and try again`,
  key1007423: `The store corresponding to the order is not currently associated with a WishPost account. Please associate it in your own logistics management and try again`,
  key1007424: `WishPost authorization is invalid. Please re authorize in your own logistics management and try again`,
  key1007425: `The store is already associated with another account`,
  key1007426: `Associated store not enabled`,
  key1007427: `A questionnaire with the same name already exists`,
  key1007428: `A question with the same name already exists in the current questionnaire`,
  key1007429: `The warehouse has been associated with a supplier`,
  key1007430: `The scanned package and delivery note are shipped from different warehouses`,
  key1007431: `1688 platform unauthorized store`,
  key1007432: `Link does not exist`,
  key1007433: `Currency configuration already exists`,
  key1007434: `This picking list is a regular order, please go to the regular packaging module for operation`,
  key1007435: `This picking list is a preparation picking list. Please proceed to the preparation sorting for operation`,
  key1007436: `The customer has not yet executed the shipment. Please try again in the next round of operations`,
  key1007437: `No relevant package information found`,
  key1007438: `The current small package has been sorted and scanned`,
  key1007439: `There are small packages that have not been packaged yet`,
  key1007440: `There are small packages that have not been sorted by logistics. Please complete the sorting before closing the bags`,
  key1007441: `Failed to modify the order synchronization status to 'synchronizing'`,
  key1007442: `The warehouse where the logistics handover order is located is not authorized. Please apply for the corresponding warehouse permission`,
  key1007443: `The handover form does not exist`,
  key1007444: `Please activate Temu virtual logistics first`,
  key1007445: `Platform order already exists`,
  key1007446: `The logistics tracking number already exists`,
  key1007447: `Recharged currency cannot be modified`,
  key1007448: `Currency cannot be modified after product creation`,
  key1007449: `The ongoing operation is not in sorting or packaging`,
  key1007450: `The number of SKUs scanned exceeds the expected picking quantity on the picking list`,
  key1007451: `This attribute is already used as a specification attribute by an existing product and cannot be deleted`,
  key1007452: `Failed to restore inventory`,
  key1007453: `The bill has been generated, but the subsidy review failed`,
  key1007454: `Logistics only supports binding one channel`,
  key1007455: `Failed to upload package`,
  key1007456: `Failed to acquire waybills`,
  key1007457: `Warehouse address does not exist`,
  key1007458: `Logistics Not Associated with Basic Logistics`,
  key1007459: `Logistics provider failed to obtain token`,
  key1007460: `Scanning temu outbound orders is not allowed`,
  key1007461: `AliExpress OAID does not exist`,
  key1007462: `Decryption failed`,
  key1007463: `The bill has been generated, but the subsidy re review failed`,
  key1007464: `Abnormal barcode printing for the selected order`,
  key1007465: `Abnormal printing of SKU barcode`,
  key1007466: `Items that are not out of stock cannot be marked as arrival`,
  key1007467: `No order for this product, please verify the order`,
  key1007468: `The bill of lading is not in a waiting for collection status`,
  key1007469: `The delivery order has been issued and no other operations are allowed`,
  key1007470: `There are orders in the current order with an outbound order that is not in a pending shipment status`,
  key1007471: `There is only one order in this picking list, and there is no need to sort it. Please proceed with the preparation and packaging operation`,
  key1007472: `This picking list is a regular order, please proceed to the regular sorting for operation`,
  key1007473: `This picking list is a backup list. Please proceed to the backup sorting for operation`,
  key1007474: `Failed to add goods and synchronize bill of lading operation`,
  key1007475: `There are orders with out of stock status in the current order`,
  key1007476: `The middle label code cannot be empty`,
  key1007477: `No shipping orders`,
  key1007478: `The picking list exists in`,
  key1007479: `Manual orders and platform orders cannot be shipped simultaneously`,
  key1007480: `Goods orders and sample orders cannot be shipped simultaneously`,
  key1007481: `Orders from different stores cannot be shipped simultaneously`,
  key1007482: `Orders with different shipping addresses cannot be shipped simultaneously`,
  key1007483: `There are small bags with open bags in this order`,
  key1007484: `The order has been completed and cannot be scanned again.`,
  key1007485: `The number of manually modified scans must be a positive integer greater than 0`,
  key1007486: `The selected batch of outbound orders exceeds the maximum limit. Please adjust the maximum number of packages`,
  key1007487: `The maximum number of outbound orders per picking list cannot be empty or less than 1`,
  key1007488: `The picking list is currently being processed by another user and cannot be processed again`,
  key1007489: `temu_s Picking Doc Existence Not Printed`,
  key1007490: `The bill of lading and container belong to different warehouses. Please check and try again`,
  key1007491: `Failed to create order, insufficient customer balance`,
  key1007492: `Non-matching goods or matching logistics failure or order failure status, cannot be marked as non-`,
  key1007493: `Order Actions`,
  key1007494: `The title guide for this title already exists in the same system and module. Please redefine the title`,
  key1007495: `Logistics/basic logistics cannot be transmitted at the same time`,
  key1007496: `Logistics/Basic Logistics Must Pass One`,
  key1007497: `Basic logistics trackingNumber, labelPath must be passed`,
  key1007498: `SKU has been discontinued`,
  key1007499: `Multiple warehouse matches for product shipment. Please split the platform order before placing the order`,
  key1007500: `Failed to match warehouse`,
  key1007501: `The available inventory of the product is empty or illegal`,
  key1007502: `Account not bound to store, or account has expired`,
  key1007503: `Customer label with the same name already exists`,
  key1007504: `The customer group name already exists`,
  key1007505: `The user has already started other picking operations`,
  key1007506: `The mobile phone is bound, not support updating mobile phone.`,
  key1007507: `Product category not mapped to platform`,
  key1007508: `Failed to obtain supplier currency interface`,
  key1007509: `Duplicate SPU, please modify`,
  key1007510: `Failed to query third-party platform orders`,
  key1007511: `Alipay payment order failed`,
  key1007512: `Failed to add recharge record`,
  key1007513: `Failed to obtain distributor currency`,
  key1007514: `Operational order not queried`,
  key1007515: `Failed to return shipment status`,
  key1007516: `Store address is empty`,
  key1007517: `The order in the logistics handover form is empty`,
  key1007518: `Multiple item sorting is not allowed to remove the picking list after the order has been changed`,
  key1007519: `Not applying for an appointment form`,
  key1007520: `The container type has already been used. Please delete the container that has already used this type before editing this container type`,
  key1007521: `No logistics tracking records found`,
  key1007522: `No valid logistics channels were matched`,
  key1007523: `There are failed orders`,
  key1007524: `Order, please replace the goods after completion.`,
  key1007525: `The customer level name already exists, please replace it and try again`,
  key1007526: `It is not allowed to modify the buyer's shipping address after being packed`,
  key1007527: `Email registration method: Email cannot be empty`,
  key1007528: `At least one email and mobile phone need to be filled out`,
  key1007529: `This logistics channel is currently unavailable. For more information, please consult customer service`,
  key1007530: `The selected product is currently generating data`,
  key1007531: `Failed to generate sales information`,
  key1007532: `Vendor account already exists`,
  key1007533: `Please login again`,
  key1007534: `Distributor account already exists, please log in again`,
  key1007535: `The supplier account permission has not been opened yet. Please contact the main account to open it. If you have any questions, please contact online customer service for consultation!`,
  key1007536: `HTML type waybills only allow individual printing`,
  key1007537: `Sales price less than or equal to 0`,
  key1007538: `When marking out of stock, the out of stock quantity must be greater than 1`,
  key1007539: `This account is an operator system account. Please change the account and try again`,
  key1007540: `This shipping warehouse already has this type of expense configuration. Please check and try again`,
  key1007541: `No warehouse processing fee set`,
  key1007542: `Fixed billing does not set regular or multi item order processing fees`,
  key1007543: `Layered billing is not set with tiered pricing or multi frequency order processing fees`,
  key1007544: `The currently selected bill has already been confirmed`,
  key1007545: `This specification attribute has been used and cannot be modified as a regular attribute`,
  key1007546: `Address book with the same template name exists`,
  key1007547: `The note content is too long, adding failed`,
  key1007548: `Failed to update permission authorization for shelving tools`,
  key1007549: `The bill of lading where the backup note is located has been packed`,
  key1007550: `Same platform configuration already exists`,
  key1007551: `The specified platform is not configured`,
  key1007552: `No specified store configured`,
  key1007553: `No publishing template configured`,
  key1007554: `Store token invalid`,
  key1007555: `No timeout time set`,
  key1007556: `Please activate AliExpress fully managed logistics first`,
  key1007557: `Incorrect IOSS encoding format`,
  key1007558: `Target country tax rate setting already exists`,
  key1007559: `IOSS configuration with the same name already exists`,
  key1007560: `Some of the raw materials are being used in assembled products and cannot be deleted.`,
  key1007561: `Platform order IOSS has been entered`,
  key1007562: `Logistics agent payment, customs clearance fee cannot be empty`,
  key1007563: `This logistics channel has been deactivated. Please select a new logistics channel`,
  key1007564: `There is data that has already generated sales information`,
  key1007565: `The distributor's stock order is not in a pending payment status`,
  key1007566: `Abnormal verification of the quantity of goods in the distributor's cancellation of the stock order`,
  key1007567: `The distributor's stock order is not in the status of awaiting price adjustment`,
  key1007568: `The distributor's stock order is not in the supplier's pending price status`,
  key1007569: `Failed to list inventory on the allocation order`,
  key1007570: `Set assembly items to include deleted items`,
  key1007571: `Set the original materials of the assembled goods to include the assembled goods`,
  key1007572: `The raw materials for assembling the product cannot be consistent with the current product`,
  key1007573: `There is an export template with the same name`,
  key1007574: `Unconfigured virtual storage location for assembled products`,
  key1007575: `Failed to assemble raw materials and finished products into and out of the warehouse`,
  key1007576: `Logistics handover form not in sorting status`,
  key1007577: `No matching buyer's zip code`,
  key1007578: `The number of operational orders is inconsistent with the selection`,
  key1007579: `Failed to save declaration information`,
  key1007580: `Unsupported inventory operations`,
  key1007581: `Inventory operation failed`,
  key1007582: `Failed to retrieve supplier data through interface call`,
  key1007583: `The current bill of lading is not owned by the logistics company and is in a waiting for collection status. The logistics cannot be modified`,
  key1007584: `Item allocation failed`,
  key1007585: `Withdrawal`,
  key1007586: `Speed regulating AliExpress failed to create collection interface`,
  key1007587: `Printing collection waybill image access failed`,
  key1007588: `Speed regulating AliExpress fully managed printing collection waybill interface failed`,
  key1007589: `AliExpress reservation delivery interface call API exception`,
  key1007590: `Exceeded the logistics size limit. Please change the logistics and try again`,
  key1007591: `Exceeded the weight limit of this logistics. Please change the logistics and try again`,
  key1007592: `Beyond the delivery range of this logistics, please change the logistics and try again`,
  key1007593: `The pending order status cannot match the product`,
  key1007594: `Due to the excessive quantity of goods, please make a single print in the details`,
  key1007595: `Proportion of unfilled attribute for commodity attribute`,
  key1007596: `There is a canceled package in the current delivery slip. Please remove the canceled package and try again`,
  key1007597: `Non-boxed orders exist`,
  key1007598: `There is an exception in importing the new inventory owner role, please check and try again.`,
  key1007599: `Supplier Merchant Error Importing New Inventory`,
  key1007600: `This item has been discontinued,`,
  key1007601: `The quantity stored in the warehouse is less than the quantity of the ordered goods, and the order cannot be placed for the time being.`,
  key1007602: `Failed to generate picking list`,
  key1007603: `There is a distributor and the order has not been canceled. Please try again later.`,
  key1007604: `The current logistics is not available, please cancel the order and place the order again.`,
  key1007605: `The distributor account authority has not been opened yet. Please contact the main account. If you have any questions, please contact the online customer service consultation!`,
  key1007606: `Change delivery address cancel`,
  key1007607: `order anomaly`,
  key1007608: `Failed to change shipping address, order canceled`,
  key1007609: `There is a duplicate express number, please scan this package through the bill of lading number.`,
  key1007610: `Non-waiting collection status cannot be voided`,
  key1007611: `Void supplier bill of lading failed`,
  key1007612: `The site name is already in use, please change another site name`,
  key1007613: `Only orders that have been created and are in stock are supported for cancellation. Please refresh the data to view`,
  key1007614: `Cloud selling logistics rules are not set`,
  key1007615: `Failed to return the sample shipment information.`,
  key1007616: `Failed to obtain large warehouse receiving address.`,
  key1007617: `Commodity barcode query failed`,
  key1007618: `Query sample list`,
  key1007619: `Not matched to shipping method`,
  key1007620: `Logistics payment, customs clearance fee can not be empty`,
  key1007621: `No valid shipping information`,
  key1007622: `No transaction information exists in the platform sheet.`,
  key1007623: `Order Shipped`,
  key1007624: `The issue document is not in issue status`,
  key1007625: `Goods not to be reviewed`,
  key1007626: `I have paid attention to this store.`,
  key1007627: `Commodity classification information does not exist`,
  key1007628: `Favourite canceled`,
  key1007629: `The current bill of lading to be put on the shelf is not in receipt status.`,
  key1007630: `Failed to reset package status`,
  key1007631: `Not matched to warehouse, please contact customer service`,
  key1007632: `Container non-goods sorting completion status`,
  key1007633: `It has been put on the shelf, please do not repeat the operation.`,
  key1007634: `The goods have been sorted`,
  key1007635: `No posting rules set`,
  key1007636: `Not matched to the reservoir area, please contact customer service`,
  key1007637: `SKU does not match the location number, please check and try again`,
  key1007638: `SKU picked`,
  key1007639: `Bill is not payment status`,
  key1007640: `Must pass one`,
  key1007641: `Vendor has not set up a vesting warehouse`,
  key1007642: `ymsWarehouseLocation not fully allocated`,
  key1007643: `AliExpress online delivery UserNick must be transmitted`,
  key1007644: `The parcel is not authorized in the warehouse`,
  key1007645: `Logistics handover order warehouse does not match with parcel warehouse`,
  key1007646: `Logistics delivery order warehouse is inconsistent with parcel logistics`,
  key1007647: `Missing package`,
  key1007648: `Logistics provider number already exists`,
  key1007649: `The three-party platform does not exist.`,
  key1007650: `Failed to obtain the delivery and return address of the store.`,
  key1007651: `The current cloud order has not been shipped`,
  key1007652: `The current order logistics method is not cloud selling logistics.`,
  key1007653: `AliExpress Print Face Single Interface Failure`,
  key1007654: `Can handle up to 200 packages at a time, please remove them before binding the bag.`,
  key1007655: `The distributor stock order has been paid and cannot be paid again.`,
  key1007656: `The selected warehouse does not have this storage area. Please verify and try again`,
  key1007657: `The selected warehouse does not have this location. Please verify and try again`,
  key1007658: `There is duplicate data, please confirm and try again`,
  key1007659: `Category does not exist`,
  key1007660: `Order ID Query Order Id Set Exception`,
  key1007661: `Failed to save package information`,
  key1007662: `Obtain the exception of the logistics provider.`,
  key1007663: `Print Surface Sheet Abnormal`,
  key1007664: `Package already exists`,
  key1007665: `Logistics provider account does not exist`,
  key1007666: `There are unrecycled packages`,
  key1007667: `Parcel order data exception`,
  key1007668: `Get Order Exception`,
  key1007669: `Failed to update order print time`,
  key1007670: `The package data in the delivery system is inconsistent with the data in the order system.`,
  key1007671: `Delivery document delivery logistics failed`,
  key1007672: `The issue document mark failed to print, and some packages have been printed in other ways.`,
  key1007673: `Package not delivered`,
  key1007674: `Invalid number of available stock Please enter more than 0 number of available stock`,
  key1007675: `There are no goods in the delivery desk, and the distribution list cannot be printed.`,
  key1007676: `Failed to modify stock document item quantity.`,
  key1007677: `The current bill of lading is not waiting for collection, and the logistics cannot be modified.`,
  key1007678: `The current bill of lading is not self-owned logistics and cannot be modified.`,
  key1007679: `Obtaining Warehouse Exception`,
  key1007680: `Update Package Wrap Status Abnormal`,
  key1007681: `Print the address sheet when the user does not open the sorting`,
  key1007682: `There are products using this brand and cannot be deleted!`,
  key1007683: `Commit exists same property`,
  key1007684: `Variable parameter commodity null attribute`,
  key1007685: `The attribute key is inconsistent`,
  key1007686: `Delete SKU Exceptions`,
  key1007687: `The upload path is empty.`,
  key1007688: `common commodity spu and sku must be consistent`,
  key1007689: `Variable parameter commodity attribute cannot be empty`,
  key1007690: `Property labels contain commas`,
  key1007691: `Non-variable parameter cannot add extra sku`,
  key1007692: `spu cannot be empty`,
  key1007693: `cnName cannot be empty`,
  key1007694: `Classification ID cannot be empty`,
  key1007695: `productGoodsList cannot be empty`,
  key1007696: `sku not matched`,
  key1007697: `Null request parameter`,
  key1007698: `Failed to unallocate`,
  key1007699: `Unallocation failed. The issue document does not exist.`,
  key1007700: `Unallocation failed Shipped, Cancelled, Picking Order Generated or Picking cannot be canceled`,
  key1007701: `Failed to cancel allocation Failed to delete picking list`,
  key1007702: `Unallocation failed to restore original inventory data`,
  key1007703: `(before allocation`,
  key1007704: `) failed`,
  key1007705: `Failed to cancel the allocation. Failed to modify the inventory product details data.`,
  key1007706: `(Assigned Quantity`,
  key1007707: `Failed to unassign product assignment record deletion failed`,
  key1007708: `Failed to operate issue Doc`,
  key1007709: `Detail data is empty`,
  key1007710: `No issue document found`,
  key1007711: `Failed to operate goods`,
  key1007712: `Picking Status Incorrect`,
  key1007713: `Shipment Status Status Incorrect`,
  key1007714: `The logistics address is blank, please fill in the logistics address`,
  key1007715: `Address does not match, please contact online customer service consultation`,
  key1007716: `Abnormal Alipay transfer call`,
  key1007717: `Failed to synchronize platform address`,
  key1007718: `Only pending customers can proceed with the audit, please reselect`,
  key1007719: `AliExpress interface exception`,
  key1007720: `the pms logistics account token is empty`,
  key1007721: `Package number is empty`,
  key1007722: `Product link is empty`,
  key1007723: `Abnormal Logistics Cancellation`,
  key1007724: `Failed to obtain ioss tax rate configuration`,
  key1007725: `The current order is not a manual order.`,
  key1007726: `Contact corresponding to customer number not found`,
  key1007727: `The data YmsInventoryWarehouse to be updated in the inventory statistics table is not found.`,
  key1007728: `Failed to modify alibabagj shipping address.`,
  key1007729: `There is a POD order in the current order whose outbound order is not a final logistics order.`,
  key1007730: `Confirmed order payment error, interface exception`,
  key1007731: `Ali International Platform List is not canceled manually`,
  key1007732: `Shipment retry`,
  key1007733: `No distributor platform orders found for matched items`,
  key1007734: `wms delivery failed`,
  key1007735: `No cloud selling logistics meeting the order conditions was found`,
  key1007736: `wms cancel failed`,
  key1007737: `Warehouse is empty`,
  key1007738: `The current picking list contains a non-`,
  key1007739: `Pending/picking`,
  key1007740: `The ordershipingid under the package already exists`,
  key1007741: `Get shipment setting exception`,
  key1007742: `Invalid quantity in issue document list`,
  key1007743: `Allocate Inventory Exceptions`,
  key1007744: `Undelivered packages`,
  key1007745: `Failed to update bill and issue document status`,
  key1007746: `The same site cannot exist under the same platform`,
  key1007747: `Please confirm whether the merchant number is correct`,
  key1007748: `The store does not exist`,
  key1007749: `Picking list is being packed`,
  key1007750: `Container is not ready for picking`,
  key1007751: `The picking list is not to be picked or picking.`,
  key1007752: `The current YMS order is being reviewed during picking`,
  key1007753: `Product status error`,
  key1007754: `Picking list status is abnormal`,
  key1007755: `Get Wrapper Settings Exception`,
  key1007756: `Does not match the specified YMS order`,
  key1007757: `No exception obtained`,
  key1007758: `Distributors cannot choose to place orders for Alibaba International products`,
  key1007759: `Reservoir name name duplicate`,
  key1007760: `Reservoir location cannot all be null`,
  key1007761: `Available inventory cannot be less than 0`,
  key1007762: `The label generated by the product is abnormal`,
  key1007763: `Exception of YMS order`,
  key1007764: `Invalid warehouse inventory information ID`,
  key1007765: `Only batch approval of bills in the status to be approved is supported. Please check and try again.`,
  key1007766: `Only batch approval of bills in payment status is supported. Please check and try again.`,
  key1007767: `No this API permission, please contact customer service to open`,
  key1007768: `Goods stocking document splitting failed`,
  key1007769: `Order tag with same name already exists`,
  key1007770: `This order contains special processing goods, can not be canceled directly, if you need to cancel please contact customer service`,
  key1007771: `Product tag with same name already exists`,
  key1007772: `An order import template with the same name already exists`,
  key1007773: `The same Excel file title exists`,
  key1007774: `The level discount factor value setting is invalid`,
  key1007775: `There is payment information that is not pending confirmation`,
  key1007776: `Cancellation failed, the operation has been reconciled, please refresh and view`,
  key1007777: `Unmatched platform warehouse`,
  key1007778: `Failed to query the basic information interface of the seller's shipping warehouse`,
  key1007779: `Only common attribute optional values can be associated with sub-attributes`,
  key1007780: `There are circular associations between product attributes`,
  key1007781: `The associated attribute cannot be modified to a specification attribute`,
  key1007782: `Must meet`,
  key1007783: `Total credit limit ≥ withheld amount + used credit limit - balance`,
  key1007784: `This logistics channel needs to send express to the collection point. Domestic express or logistics company, logistics order number cannot be empty`,
  key1007785: `Country of Shipment is empty`,
  key1007786: `Duplicate warehouse name or code`,
  key1007787: `This address template is in use and cannot be deactivated`,
  key1007788: `Supply bin configuration cannot be empty`,
  key1007789: `Straight bin configuration cannot be empty`,
  key1007790: `The delivery warehouse is inconsistent with the destination warehouse.`,
  key1007791: `Failed to query the order shipping address decryption interface.`,
  key1007792: `Shipment place duplicate`,
  key1007793: `Failed to update warehouse settings`,
  key1007794: `Failed to update supplier warehouse type`,
  key1007795: `The distributor has not set up a smart warehouse rule.`,
  key1007796: `No warehouse rules meet the condition`,
  key1007797: `Shipment warehouse not specified in order`,
  key1007798: `Cloud selling platform order cloud selling order relationship does not exist`,
  key1007799: `Cloud Sell Platform Order Cloud Sell Order Relationship Processing`,
  key1007800: `When selecting the specified logistics, the logistics provider or channel is empty.`,
  key1007801: `Customized goods do not support stocking`,
  key1007802: `Non-straight orders cannot be shipped directly`,
  key1007803: `Self-owned logistics delivery logistics waybill number cannot be empty`,
  key1007804: `Third-party logistics delivery express to the collection point logistics channel or express number cannot be empty.`,
  key1007805: `Shipment information for unmatched logistics exists`,
  key1007806: `No Pending Payment`,
  key1007807: `The delivery warehouse cannot supply to the central warehouse.`,
  key1007808: `This logistics provider name already exists`,
  key1007809: `Invalid mailing method`,
  key1007810: `The corresponding category of this commodity is not mapped to the platform information, please contact the operation after setting`,
  key1007811: `There can only be one default partition for the same global reachable freight.`,
  key1007812: `Third-party logistics delivery method cannot be empty`,
  key1007813: `stock order spu does not allow stocking current warehouse`,
  key1007814: `Please "commodity management list-supplier inventory" empty the corresponding delivery warehouse inventory before removing the delivery warehouse`,
  key1007815: `At present, the supplier warehouse has formed a supply/stocking relationship with it. Please do not modify the warehouse's place of shipment.`,
  key1007816: `Please empty the inventory of the corresponding warehouse before deactivating it.`,
  key1007817: `A product that supports customization already exists under the category. You cannot set the category to not allow customization.`,
  key1007818: `Currently there is no enabled custom part information, please save after maintenance`,
  key1007819: `There are customized goods in the order. If you need to cancel the order, please contact the platform operation.`,
  key1007820: `Customization information is not set for customized goods`,
  key1007821: `Custom information picture not set for custom goods`,
  key1007822: `Order item not associated with compliance information`,
  key1007823: `Failed to modify the address. If you need to modify the address, please contact the operation for adjustment.`,
  key1007824: `Customized goods orders can only be canceled before packing, please refresh the data to view the status.`,
  key1007825: `Failed to obtain customized goods.`,
  key1007826: `Custom goods order processing status cannot be empty`,
  key1007827: `Fill in at least one mobile phone, email address and official website`,
  key1007828: `The price of the goods in the country where the delivery warehouse is not set.`,
  key1007829: `Failed to merge compliance labels`,
  key1007830: `Associated area cannot be empty`,
  key1007831: `Manufacturer with same name already exists`,
  key1007832: `Category id cannot be empty`,
  key1007833: `Level 1 category cannot be deleted`,
  key1007834: `The category has lower-level categories and cannot be deleted.`,
  key1007835: `Document exists under category and cannot be deleted`,
  key1007836: `Batch new category data cannot be empty`,
  key1007837: `Help Center document category id cannot be empty`,
  key1007838: `Help Center document information does not exist`,
  key1007839: `Batch Add Help Center Document Data cannot be empty`,
  key1007840: `The approved product does not exist, please refresh the list and try again.`,
  key1007841: `The current document is an official document and cannot be deleted.`,
  key1007842: `The platform id cannot be empty.`,
  key1007843: `Help Center document id cannot be empty`,
  key1007844: `Failed to get mailing method`,
  key1007845: `Module id cannot be empty`,
  key1007846: `The document category data to be updated cannot be empty.`,
  key1007847: `Commodity sales price rules are being implemented, please refresh`,
  key1007848: `New plate data cannot be empty.`,
  key1007849: `Update plate data cannot be empty`,
  key1007850: `Logistic document voiding configuration interval is illegal`,
  key1007851: `Custom part does not exist`,
  key1007852: `Custom parts cannot be duplicated`,
  key1007853: `The preview of the finished product of the customized product cannot be empty and can be uploaded at most two.`,
  key1007854: `The customized product material map cannot be empty and one map can be uploaded at most.`,
  key1007855: `The customized product material map or finished product map cannot be empty.`,
  key1007856: `Custom content cannot be empty`,
  key1007857: `Special Sales Price Configuration One Required for Each Group of Rules`,
  key1007858: `Please configure the rule information of normal state first`,
  key1007859: `Non-three-party warehouse logistics channels are not related to three-party warehouse logistics.`,
  key1007860: `Third-party warehouse configuration items cannot be edited`,
  key1007861: `SAAS does not open three-party warehouse configuration`,
  key1007862: `Buyer information current cycle, user no decryption times. Please apply for decryption quota`,
  key1007863: `Failed to query 1688 buyer recipient information`,
  key1007864: `Origin of goods cannot be empty`,
  key1007865: `Compliance information Missing commodity information`,
  key1007866: `Admin users cannot deactivate`,
  key1007867: `Product specification attribute has been disabled or does not exist, please fill in again`,
  key1007868: `Error in importing self-operated merchants of new inventory goods platform`,
  key1007869: `Query platform self-operated owner inventory is not supported`,
  key1007870: `Bill of lading receipt type error`,
  key1007871: `Counting owner cannot be empty`,
  key1007872: `New bill of lading information cannot be empty`,
  key1007873: `The operation quantity of the new bill of lading is wrong.`,
  key1007874: `B/L warehouse cannot be empty`,
  key1007875: `Supply Ladder Price Start Price cannot be empty`,
  key1007876: `Payment method cannot be empty`,
  key1007877: `Payment voucher cannot be empty`,
  key1007878: `Incomplete payment voucher information`,
  key1007879: `Offline payment failed, save payment voucher exception`,
  key1007880: `The order has been paid offline, please go to the payment management process.`,
  key1007881: `Platform sales link not filled in`,
  key1007882: `Contact cannot be empty`,
  key1007883: `Store ID cannot be empty.`,
  key1007884: `There are currently orders using this warehouse as the delivery warehouse, please process and then deactivate the warehouse.`,
  key1007885: `Supply price in some countries cannot be empty`,
  key1007886: `Order obtained waybill number`,
  key1007887: `Fetching the waybill number in the background. Please try again later.`,
  key1007888: `Platform self-operated goods`,
  key1007889: `Edit platform self-operated goods`,
  key1007890: `Supplier Goods`,
  key1007891: `Edited goods`,
  key1007892: `Size Chart Template`,
  key1007893: `Add/Edit Size Chart Template`,
  key1007894: `New Product Review`,
  key1007895: `New Product Review/Editing`,
  key1007896: `Review of modification of goods for sale`,
  key1007897: `On-sale goods modification review/edit goods`,
  key1007898: `Commodity Sales Price Configuration`,
  key1007899: `Supplier order details`,
  key1007900: `Distributor Stock List`,
  key1007901: `Supplier Stock List`,
  key1007902: `Supplier Stock Order Details`,
  key1007903: `Order payment account`,
  key1007904: `Warehousing management`,
  key1007905: `Bill of Lading Management`,
  key1007906: `Bill of lading management details`,
  key1007907: `View outbound order details`,
  key1007908: `Picking list`,
  key1007909: `See delivery order`,
  key1007910: `Setting of consignment order`,
  key1007911: `Logistics provider handover order management`,
  key1007912: `Logistics provider handover order management details`,
  key1007913: `Supplier Management`,
  key1007914: `Supplier list`,
  key1007915: `Supplier Audit`,
  key1007916: `Supplier level management`,
  key1007917: `customer management`,
  key1007918: `Customer List`,
  key1007919: `Tuoke Link`,
  key1007920: `Platform Bill Details`,
  key1007921: `Supplier bill`,
  key1007922: `Supplier billing details`,
  key1007923: `Customer billing details`,
  key1007924: `Logistics billing details`,
  key1007925: `Warehouse billing details`,
  key1007926: `Customer balance changes`,
  key1007927: `Password management`,
  key1007928: `Logistics Management`,
  key1007929: `Basic logistics`,
  key1007930: `Intelligent Logistics Rules`,
  key1007931: `Warehouse management`,
  key1007932: `Warehouse management`,
  key1007933: `Storage bin management`,
  key1007934: `Message template`,
  key1007935: `Container management`,
  key1007936: `Container type settings`,
  key1007937: `Address library management`,
  key1007938: `Configuration of inbound and outbound processes`,
  key1007939: `IOSS tax rate setting`,
  key1007940: `System Configuration`,
  key1007941: `Rule`,
  key1007942: `Automatic warehousing rules`,
  key1007943: `Third-party platform management`,
  key1007944: `Shipment Management`,
  key1007945: `Content management`,
  key1007946: `questionnaire survey`,
  key1007947: `Edit questionnaire`,
  key1007948: `Data Center`,
  key1007949: `marketing management`,
  key1007950: `Site Management`,
  key1007951: `Event Management`,
  key1007952: `Add/Edit Activity`,
  key1007953: `Advertising management`,
  key1007954: `Distributor fee allocation`,
  key1007955: `View messages and Email`,
  key1007956: `Employee Management`,
  key1007957: `Task Center`,
  key1007958: `Import Task`,
  key1007959: `Export task`,
  key1007960: `Order Center`,
  key1007961: `Collection Order List`,
  key1007962: `Straight Hair Order List`,
  key1007963: `Stock Order Details`,
  key1007964: `Shipping Record`,
  key1007965: `Shipment Record Details`,
  key1007966: `Product Center`,
  key1007967: `Add/Edit products`,
  key1007968: `Brand management`,
  key1007969: `Warehousing and Logistics`,
  key1007970: `Warehouse Expense Configuration`,
  key1007971: `Third party platforms`,
  key1007972: `Platform Authorization`,
  key1007973: `Reconciliation management`,
  key1007974: `Account management`,
  key1007975: `distribution market`,
  key1007976: `Favorite Items`,
  key1007977: `I Designed The Goods`,
  key1007978: `Generate Sales Records`,
  key1007979: `Automatic Rules`,
  key1007980: `Store Management`,
  key1007981: `Platform order details`,
  key1007982: `Add Temu Order`,
  key1007983: `Payment Management`,
  key1007984: `Order Import Template`,
  key1007985: `Warehouse List`,
  key1007986: `Smart Warehouse Rules`,
  key1007987: `Compliance Responsible Person Management`,
  key1007988: `Manufacturer Information Management`,
  key1007989: `Right Management`,
  key1007990: `Role Management`,
  key1007991: `User Management`,
  key1007992: `Details of price changes`,
  key1007993: `Account management`,
  key1007994: `Security Information`,
  key1007995: `List of products and stores`
}
